export default {
	clients: [
		{
			id: 1, 
			posiciones_actuales: '',
			parent: 0,
			nombre: 'Grupo Don Ramitos',
			tipo: 'Grupo',
			fecha_constitucion: '',
			actividad_principal: '',
			cliente_desde: '',
			pais_cabecera: '',
			rfc: '',
			cuenta_clave: 'NO',
			examen: false,
			codigo: null,
			entidad: 9016,
			cif: 'xxxx1',
			informes: [
				{
					fecha: '31/12/2015',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2015,
					divisa: 'PESOS MEXICANOS',
					balance: {
						activo: [
							{
								titulo: 'ACTIVO NO CORRIENTE',
								monto: 158324,
								porcentaje: '',
							},
							{
								titulo: 'Inmovilizado Inagible',
								monto: 220,
								porcentaje: null,
							},
							{
								titulo: 'Inmovilizado Material',
								monto: 158104,
								porcentaje: null,
							},
							{
								titulo: 'Inveersiones en empresas',
								monto: 0,
								porcentaje: null,
							},
							{
								titulo: 'Inveersiones financieras LP',
								monto: 0,
								porcentaje: null,
							},
							{
								titulo: 'Fondo de Comercio',
								monto: 0,
								porcentaje: 0,
							},
							{
								titulo: 'Impuestos diferidos',
								monto: 0,
								porcentaje: 0,
							},
							{
								titulo: 'ACTIVO CORRIENTE',
								monto: 1359115,
								porcentaje: 90,
							},
							{
								titulo: 'Existencias',
								monto: 12671,
								porcentaje: null,
							},
							{
								titulo: 'Clientes',
								monto: 594874,
								porcentaje: null,
							},
							{
								titulo: 'Empresas Grupo',
								monto: 19156,
								porcentaje: null,
							},
							{
								titulo: 'Otros deudores',
								monto: 39247,
								porcentaje: null,
							},
						
							{
								titulo: 'Inversiones Financieras CP',
								monto: 273450,
								porcentaje: null,
							},
							{
								titulo: 'Otros activos corrientes',
								monto: 85500,
								porcentaje: null,
							},
							{
								titulo: 'Efectivo y equivalentes de efectivo',
								monto: 334217,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVO',
								monto: 1517439,
								porcentaje: 100,
							},
						],
						pasivo: [
							{
								titulo: 'PATRIMONIO NETO',
								monto: 687769,
								porcentaje: 45,
							},
							{
								titulo: 'Capital',
								monto: 254650,
								porcentaje:  null,
							},
							{
								titulo: 'Reservas y otros FFPP',
								monto: 265969,
								porcentaje:  null,
							},
							{
								titulo: 'Resultados',
								monto: 167150,
								porcentaje:  null,
							},
							{
								titulo: 'Intereses minoritarios',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'PASIVOS NO CORRIENTES',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'Provis. LP e Ingr Difereidos',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'Bancos + Bonos LP',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'Grupo l/p',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'Otros pasivos no corrientes',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'PASIVOS CORRIENTES',
								monto: 829670,
								porcentaje:  55,
							},
							{
								titulo: 'Bancos + Bonos CP',
								monto: 280767,
								porcentaje:  null,
							},
							{
								titulo: 'Grupo c/p',
								monto: 34805,
								porcentaje:  null,
							},
							{
								titulo: 'Proveedores',
								monto: 411169,
								porcentaje:  null,
							},
							{
								titulo: 'Otros CP',
								monto: 102929,
								porcentaje:  null,
							},
							{
								titulo: 'TOTAL P. NETO Y PASIVO',
								monto: 1517439,
								porcentaje:  100,
							},
						]
					},
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							monto: 2696098,
							porcentaje: 100,
						},
						{
							titulo: 'EBITDA',
							monto: 13288,
							porcentaje: 4.9,
						},
						{
							titulo: 'EBIT / RTDO. NETO EXPLOTACIÓN',
							monto: 128000,
							porcentaje: 4.7,
						},
						{
							titulo: 'Gastos financieros',
							monto: 11233,
							porcentaje: 0.4,
						},
						{
							titulo: 'RTDO. FINANCIERO NETO',
							monto: 55264,
							porcentaje: 2,
						},
						{
							titulo: 'RTDO. ACTIVIDADES ORDINARIAS',
							monto: 55264,
							porcentaje: 2,
						},
						{
							titulo: 'OTROS INGRESOS (GASTOS)',
							monto: 0,
							porcentaje: null,
						},
						{
							titulo: 'RTDO. ANTES DE IMP. Y OP. DISCONTINUAS',
							monto: 183264,
							porcentaje: 6.8,
						},
						{
							titulo: 'Resultado operaciones discontinuas',
							monto: 0,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO NETO DESPUÉS IMPUESTOS',
							monto: 167150,
							porcentaje: 6.2,
						},
						{
							titulo: 'RESULTADO NETO ATRIBUIBLE',
							monto: 167150,
							porcentaje: 6.2,
						},
					],
					cash_flow: null,
					magnitudes_y_ratios: [
						{
							titulo: 'Fondo de Maniobra',
							monto: 5259445,
						},
						{
							titulo: 'Deuda financiera total',
							monto: 280767,
						},
						{
							titulo: 'Deuda financiera neta',
							monto: -53450,
						},
						{
							titulo: 'Cash Flow  Discrecional',
							monto: null,
						},
						{
							titulo: 'Deuda financiera total/Patrimonio neto (x)',
							monto: 0.408,
						},
						{
							titulo: 'Cobertura de intereses con EBITDA (x)',
							monto: 11688,
						},
						{
							titulo: 'Pay-back neto (n° años)',
							monto: -0.444,
						},
						{
							titulo: 'GIF/Deuda financiera Neta (%)',
							monto: -225371,
						},
						{
							titulo: 'Retorno sobre el Patrimonio Neto (%)',
							monto: 18611,
						},
						{
							titulo: 'Deuda financiera neta/EBITDA (x)',
							monto: -0.407,
						},
						
					]
				},
				{
					fecha: '31/12/2016',
					datos_en: 'Miles',
					divisa: 'PESOS MEXICANOS',
					estado: 'CONSOLIDATED',
					ano: 2016,
					balance: {
						activo: [
							{
								titulo: 'ACTIVO NO CORRIENTE',
								monto: 203090,
								porcentaje: 11,
							},
							{
								titulo: 'Inmovilizado Inagible',
								monto: 216,
								porcentaje: null,
							},
							{
								titulo: 'Inmovilizado Material',
								monto: 202874,
								porcentaje: null,
							},
							{
								titulo: 'Inveersiones en empresas',
								monto: 0,
								porcentaje: null,
							},
							{
								titulo: 'Inveersiones financieras LP',
								monto: 0,
								porcentaje: null,
							},
							{
								titulo: 'Fondo de Comercio',
								monto: 0,
								porcentaje: 0,
							},
							{
								titulo: 'Impuestos diferidos',
								monto: 0,
								porcentaje: 0,
							},
							{
								titulo: 'ACTIVO CORRIENTE',
								monto: 1712514,
								porcentaje: 89,
							},
							{
								titulo: 'Existencias',
								monto: 112609,
								porcentaje: null,
							},
							{
								titulo: 'Clientes',
								monto: 684211,
								porcentaje: null,
							},
							{
								titulo: 'Empresas Grupo',
								monto: 0,
								porcentaje: null,
							},
							{
								titulo: 'Otros deudores',
								monto: 108351,
								porcentaje: null,
							},
						
							{
								titulo: 'Inversiones Financieras CP',
								monto: 362018,
								porcentaje: null,
							},
							{
								titulo: 'Otros activos corrientes',
								monto: 95255,
								porcentaje: null,
							},
							{
								titulo: 'Efectivo y equivalentes de efectivo',
								monto: 350070,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVO',
								monto: 1915604,
								porcentaje: 100,
							},
						],
						pasivo: [
							{
								titulo: 'PATRIMONIO NETO',
								monto: 847740,
								porcentaje: 44,
							},
							{
								titulo: 'Capital',
								monto: 247470,
								porcentaje:  null,
							},
							{
								titulo: 'Reservas y otros FFPP',
								monto: 441300,
								porcentaje:  null,
							},
							{
								titulo: 'Resultados',
								monto: 158970,
								porcentaje:  null,
							},
							{
								titulo: 'Intereses minoritarios',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'PASIVOS NO CORRIENTES',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'Provis. LP e Ingr Difereidos',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'Bancos + Bonos LP',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'Grupo l/p',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'Otros pasivos no corrientes',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'PASIVOS CORRIENTES',
								monto: 1067864,
								porcentaje:  56,
							},
							{
								titulo: 'Bancos + Bonos CP',
								monto: 330238,
								porcentaje:  null,
							},
							{
								titulo: 'Grupo c/p',
								monto: 176444,
								porcentaje:  null,
							},
							{
								titulo: 'Proveedores',
								monto: 420704,
								porcentaje:  null,
							},
							{
								titulo: 'Otros CP',
								monto: 140478,
								porcentaje:  null,
							},
							{
								titulo: 'TOTAL P. NETO Y PASIVO',
								monto: 1915604,
								porcentaje:  100,
							},
						]
					},
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							monto: 2386713,
							porcentaje: 100,
						},
						{
							titulo: 'EBITDA',
							monto: 85007,
							porcentaje: 3.6,
						},
						{
							titulo: 'EBIT / RTDO. NETO EXPLOTACIÓN',
							monto: 79237,
							porcentaje: 3.3,
						},
						{
							titulo: 'Gastos financieros',
							monto: 39039,
							porcentaje: 1.6,
						},
						{
							titulo: 'RTDO. FINANCIERO NETO',
							monto: 90790,
							porcentaje: 3.8,
						},
						{
							titulo: 'RTDO. ACTIVIDADES ORDINARIAS',
							monto: 170027,
							porcentaje: 7.1,
						},
						{
							titulo: 'OTROS INGRESOS (GASTOS)',
							monto: 0,
							porcentaje: null,
						},
						{
							titulo: 'RTDO. ANTES DE IMP. Y OP. DISCONTINUAS',
							monto: 170027,
							porcentaje: 7.1,
						},
						{
							titulo: 'Resultado operaciones discontinuas',
							monto: 0,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO NETO DESPUÉS IMPUESTOS',
							monto: 158970,
							porcentaje: 6.7,
						},
						{
							titulo: 'RESULTADO NETO ATRIBUIBLE',
							monto: 158970,
							porcentaje: 6.2,
						},
					],
					cash_flow: [
						{
							titulo: 'Generación Interna de fondos',
							monto: 58094,
						},
						{
							titulo: 'Capital circulante',
							monto: -10307,
						},
						{
							titulo: 'Cash flow operativo',
							monto: 47787,
						},
						{
							titulo: 'Capex',
							monto: -50536,
						},
						{
							titulo: 'Inversiones / desinversiones',
							monto: -145696,
						},
						{
							titulo: 'Otros (Dividendos de participadas)',
							monto: null,
						},
						{
							titulo: 'Cash flow de Inversión',
							monto: -196232,
						},
						{
							titulo: 'Variación neta deuda financiera',
							monto: 49471,
						},
						{
							titulo: 'Ampliaciones capital (dividendos)',
							monto: 8181,
						},
						{
							titulo: 'Dividendos / shares buy back',
							monto: null,
						},
						{
							titulo: 'Otros',
							monto: null,
						},
						{
							titulo: 'Cash flow de financiación',
							monto: 57652,
						},
						{
							titulo: 'Variación en la tesorería',
							monto: -90793,
						},
					],
					magnitudes_y_ratios: [
						{
							titulo: 'Fondo de Maniobra',
							monto: 644650,
						},
						{
							titulo: 'Deuda financiera total',
							monto: 330238,
						},
						{
							titulo: 'Deuda financiera neta',
							monto: -19832,
						},
						{
							titulo: 'Cash Flow  Discrecional',
							monto: null,
						},
						{
							titulo: 'Deuda financiera total/Patrimonio neto (x)',
							monto: 0.39,
						},
						{
							titulo: 'Cobertura de intereses con EBITDA (x)',
							monto: 2177,
						},
						{
							titulo: 'Pay-back neto (n° años)',
							monto: -0.341,
						},
						{
							titulo: 'GIF/Deuda financiera Neta (%)',
							monto: -292931,
						},
						{
							titulo: 'Retorno sobre el Patrimonio Neto (%)',
							monto: 9347,
						},
						{
							titulo: 'Deuda financiera neta/EBITDA (x)',
							monto: -0.233,
						},
						
					]
				},
				{
					fecha: '31/12/2017',
					datos_en: 'Miles',
					divisa: 'PESOS MEXICANOS',
					estado: 'CONSOLIDATED',
					ano: 2017,
					balance: {
						activo: [
							{
								titulo: 'ACTIVO NO CORRIENTE',
								monto: 215143,
								porcentaje: 12,
							},
							{
								titulo: 'Inmovilizado Inagible',
								monto: 12991,
								porcentaje: null,
							},
							{
								titulo: 'Inmovilizado Material',
								monto: 202152,
								porcentaje: null,
							},
							{
								titulo: 'Inveersiones en empresas',
								monto: 0,
								porcentaje: null,
							},
							{
								titulo: 'Inveersiones financieras LP',
								monto: 0,
								porcentaje: null,
							},
							{
								titulo: 'Fondo de Comercio',
								monto: 0,
								porcentaje: 0,
							},
							{
								titulo: 'Impuestos diferidos',
								monto: 0,
								porcentaje: 0,
							},
							{
								titulo: 'ACTIVO CORRIENTE',
								monto: 1603645,
								porcentaje: 88,
							},
							{
								titulo: 'Existencias',
								monto: 85409,
								porcentaje: null,
							},
							{
								titulo: 'Clientes',
								monto: 606829,
								porcentaje: null,
							},
							{
								titulo: 'Empresas Grupo',
								monto: 202056,
								porcentaje: null,
							},
							{
								titulo: 'Otros deudores',
								monto: 17320,
								porcentaje: null,
							},
							
							{
								titulo: 'Inversiones Financieras CP',
								monto: 342995,
								porcentaje: null,
							},
							{
								titulo: 'Otros activos corrientes',
								monto: 29194,
								porcentaje: null,
							},
							{
								titulo: 'Efectivo y equivalentes de efectivo',
								monto: 319842,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVO',
								monto: 1818788,
								porcentaje: 100,
							},
						],
						pasivo: [
							{
								titulo: 'PATRIMONIO NETO',
								monto: 909416,
								porcentaje: 50,
							},
							{
								titulo: 'Capital',
								monto: 149176,
								porcentaje:  null,
							},
							{
								titulo: 'Reservas y otros FFPP',
								monto: 689564,
								porcentaje:  null,
							},
							{
								titulo: 'Resultados',
								monto: 61676,
								porcentaje:  null,
							},
							{
								titulo: 'Intereses minoritarios',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'PASIVOS NO CORRIENTES',
								monto: 45010,
								porcentaje:  2,
							},
							{
								titulo: 'Provis. LP e Ingr Difereidos',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'Bancos + Bonos LP',
								monto: 45010,
								porcentaje:  null,
							},
							{
								titulo: 'Grupo l/p',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'Otros pasivos no corrientes',
								monto: 0,
								porcentaje:  null,
							},
							{
								titulo: 'PASIVOS CORRIENTES',
								monto: 864362,
								porcentaje:  46,
							},
							{
								titulo: 'Bancos + Bonos CP',
								monto: 336242,
								porcentaje:  null,
							},
							{
								titulo: 'Grupo c/p',
								monto: 125287,
								porcentaje:  null,
							},
							{
								titulo: 'Proveedores',
								monto: 288042,
								porcentaje:  null,
							},
							{
								titulo: 'Otros CP',
								monto: 114793,
								porcentaje:  null,
							},
							{
								titulo: 'TOTAL P. NETO Y PASIVO',
								monto: 1818788,
								porcentaje:  100,
							},
						]
					},
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							monto: 982279,
							porcentaje: 100,
						},
						{
							titulo: 'EBITDA',
							monto: 88510,
							porcentaje: 9,
						},
						{
							titulo: 'EBIT / RTDO. NETO EXPLOTACIÓN',
							monto: 84762,
							porcentaje: 8.6,
						},
						{
							titulo: 'Gastos financieros',
							monto: 37256,
							porcentaje: 3.8,
						},
						{
							titulo: 'RTDO. FINANCIERO NETO',
							monto: -23086,
							porcentaje: 3.8,
						},
						{
							titulo: 'RTDO. ACTIVIDADES ORDINARIAS',
							monto: 61676,
							porcentaje: 6.3,
						},
						{
							titulo: 'OTROS INGRESOS (GASTOS)',
							monto: 0,
							porcentaje: null,
						},
						{
							titulo: 'RTDO. ANTES DE IMP. Y OP. DISCONTINUAS',
							monto: 61676,
							porcentaje: 7.1,
						},
						{
							titulo: 'Resultado operaciones discontinuas',
							monto: 0,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO NETO DESPUÉS IMPUESTOS',
							monto: 61676,
							porcentaje: 6.7,
						},
						{
							titulo: 'RESULTADO NETO ATRIBUIBLE',
							monto: 61676,
							porcentaje: 6.2,
						},
					],
					cash_flow: [
						{
							titulo: 'Generación Interna de fondos',
							monto: 100998,
						},
						{
							titulo: 'Capital circulante',
							monto: -38861,
						},
						{
							titulo: 'Cash flow operativo',
							monto: 62137,
						},
						{
							titulo: 'Capex',
							monto: -15801,
						},
						{
							titulo: 'Inversiones / desinversiones',
							monto: -190296,
						},
						{
							titulo: 'Otros (Dividendos de participadas)',
							monto: null,
						},
						{
							titulo: 'Cash flow de Inversión',
							monto: -206097,
						},
						{
							titulo: 'Variación neta deuda financiera',
							monto: 51012,
						},
						{
							titulo: 'Ampliaciones capital (dividendos)',
							monto: 98294,
						},
						{
							titulo: 'Dividendos / shares buy back',
							monto: null,
						},
						{
							titulo: 'Otros',
							monto: null,
						},
						{
							titulo: 'Cash flow de financiación',
							monto: 149306,
						},
						{
							titulo: 'Variación en la tesorería',
							monto: 5346,
						},
					],
					magnitudes_y_ratios: [
						{
							titulo: 'Fondo de Maniobra',
							monto: 739283,
						},
						{
							titulo: 'Deuda financiera total',
							monto: 381250,
						},
						{
							titulo: 'Deuda financiera neta',
							monto: 61408,
						},
						{
							titulo: 'Cash Flow  Discrecional',
							monto: null,
						},
						{
							titulo: 'Deuda financiera total/Patrimonio neto (x)',
							monto: 0.419,
						},
						{
							titulo: 'Cobertura de intereses con EBITDA (x)',
							monto: 2376,
						},
						{
							titulo: 'Pay-back neto (n° años)',
							monto: 0.304,
						},
						{
							titulo: 'GIF/Deuda financiera Neta (%)',
							monto: 328941,
						},
						{
							titulo: 'Retorno sobre el Patrimonio Neto (%)',
							monto: 18641,
						},
						{
							titulo: 'Deuda financiera neta/EBITDA (x)',
							monto: 0.347,
						},
						
					]
				},
			],
			buro: [
				{
					buro_de_credito: 'Metales Internacionales SAB',
					fecha: '12/03/2014',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '0',
					dls_val: '',
					udis_val: '',
					total: '',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
				{
					buro_de_credito: 'Infraestructura y Transportes Nacionales SA de CV',
					fecha: '12/03/2014',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '0',
					dls_val: '',
					udis_val: '',
					total: '',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
				{
					buro_de_credito: 'Proyectos y Desarrollos Nacionales SA de CV',
					fecha: '12/03/2014',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '378,000',
					dls_val: '',
					udis_val: '',
					total: '378,000',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
				{
					buro_de_credito: 'Nations Minig Corporation',
					fecha: '12/03/2014',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '378,000',
					dls_val: '85,000',
					udis_val: '',
					total: '1,143,250',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
			],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
			],
			rating_local: [
				{
					nombre: 'Agrotecama SA de CV',
					fecha: '2014-12-31',
					puntuacion_cuantitativa: '',
					puntuacion_cualitativa: '',
					puntuacion_tital: '',
					escala_actual: '',
					escala_anterior: ''
				},
				{
					nombre: 'Servicio Sujuxi SA de CV',
					fecha: '2014-12-31',
					puntuacion_cuantitativa: '',
					puntuacion_cualitativa: '',
					puntuacion_tital: '',
					escala_actual: '',
					escala_anterior: ''
				},
				{
					nombre: 'Transportes Ayan SA de CV',
					fecha: '2014-12-31',
					puntuacion_cuantitativa: '',
					puntuacion_cualitativa: '',
					puntuacion_tital: '',
					escala_actual: '',
					escala_anterior: ''
				},
				{
					nombre: 'Metapel SA de CV',
					fecha: '2014-12-31',
					puntuacion_cuantitativa: '',
					puntuacion_cualitativa: '',
					puntuacion_tital: '',
					escala_actual: '',
					escala_anterior: ''
				},
				{
					nombre: 'El Juan Drio SA de SV',
					fecha: '2014-12-31',
					puntuacion_cuantitativa: '',
					puntuacion_cualitativa: '',
					puntuacion_tital: '',
					escala_actual: '',
					escala_anterior: ''
				},
				{
					nombre: 'Inmobiliaria San Juan N Lugo Sa de Cv',
					fecha: '2014-12-31',
					puntuacion_cuantitativa: '',
					puntuacion_cualitativa: '',
					puntuacion_tital: '',
					escala_actual: '',
					escala_anterior: ''
				},
			],
			cash_flow: [],
			magnitudes_y_ratios: [],
		},
		// Examen 1
		{
			id: 3, 
			posiciones_actuales: `
			<p>POSICIONES ACTUALES:</p><p><br></p><p>(1) RIESGO FINANCIERO LARGO PLAZO SIN GARANTIAS REALES.- Techo por 70 MM USD (o su equivalente en Moneda Nacional) para realizar operaciones a plazos máximos de 5 años, se establece un sublímite de 10 MM USD para operaciones con plazo de hasta 7 años. Forma de pago a través de amortizaciones mensuales o trimestrales iguales y sucesivas. Al amparo de este Límite se pueden realizar las siguientes operaciones con las siguientes divisiones y bajo lo siguientes sublímites:</p><p><br></p><p>- División Bebidas: Podrá utilizar la totalidad del techo por&nbsp;70 MM USD.</p><p>- División Industrial: Podrá utilizar hasta un monto de 10 MM USD. Aval / Obligación Solidaria de la División Bebidas.</p><p><br></p><p>La suma de las disposiciones realizadas por la División Bebidas y la División Industrial no podrá superar USD 70 MM</p><p><br></p><p>Actualmente se tienen los siguientes saldos dispuestos:</p><p><br></p><p>División Bebidas:</p><p>a) Crédito Simple por 67MM USD&nbsp;a un plazo de 60 meses con vencimiento en septiembre del 2019</p><p><br></p><p>(2) RIESGO FINANCIERO LARGO PLAZO CON GARANTIAS REALES.- Límite para realizar operaciones hasta 70 MM USD (o su equivalente en Moneda Nacional) y con plazos máximos de 5 años , se establece un sublímite de 20 MM USD para operaciones con plazo de hasta 7 años. Forma de pago a través de amortizaciones mensuales o trimestrales iguales y sucesivas. GH con cobertura mínima de 1,2X años. Al amparo de este límite se podrán realizar operaciones de arrendamiento hasta un monto de 20 MM USD.&nbsp;Este límite podrá ser utilizado por las siguientes divisiones y bajo los siguientes sublímites:</p><p><br></p><p>- División Bebidas: Podrá utilizar la totalidad del techo por&nbsp;70 MM USD.</p><p>- División Industrial: Podrá utilizar hasta un monto de 10 MM USD. Aval / Obligación Solidaria de la División Bebidas.</p><p>- División Motriz:&nbsp;Podrá utilizar hasta un monto de 2 MM USD.</p><p><br></p><p>La suma de las disposiciones realizadas por la División Bebidas, la División Industrial y la División Motriz no podrá superar USD 70 MM</p><p><br></p><p>Actualmente sin riesgos dispuestos.</p><p><br></p><p>Las disposiciones al amparo de los límites (1) y (2) no podrán superar USD 70 MM</p><p><br></p><p>(3) RIESGO FINANCIERO C/P Y COMERCIAL:&nbsp;Techo por 120 MM USD para operaciones a plazos máximos de 12 meses. Se podrán operar cualquiera de los productos del catálogo a excepción de PQ´s. En caso de operar Crediproveedores se podrán establecer a un plazo máximo de 180 días. Los contratos se podrán firmar a un plazo de 24 meses con revisión anual. Este límite podrá ser utilizado por las siguientes divisiones y bajo los siguientes sublímites:</p><p><br></p><p>- División Bebidas: Podrá utilizar la totalidad del techo por USD 120 MM.</p><p>- División Industrial: Podrá utilizar hasta un monto de USD 20 MM.&nbsp;Aval / Obligación Solidaria de la División Bebidas.</p><p>- División Motriz:&nbsp;Podrá utilizar hasta un monto de USD 20 MM. Podrá realizar operaciones de Plan Piso.</p><p><br></p><p>Actualmente se tienen los siguientes saldos dispuestos:</p><p><br></p><p>División Bebidas:&nbsp;&nbsp;</p><p>a) CCC líquido anual por un monto de&nbsp;por un monto de 25 MM USD&nbsp;y saldo dispuesto por 10 MM USD.</p><p><br></p><p>División Motriz:&nbsp;</p><p>a) CCC líquido a plazos por un monto de&nbsp;15 MM USD&nbsp;y saldo dispuesto por&nbsp;15 MM USD.</p><p><br></p><p>(4) RIESGO DE FIRMA: Techo por $90 MM USD (o su equivalente en Moneda Nacional) para operaciones a plazos máximos de 1 año.&nbsp;Se podrán establecer Cartas de Crédito a plazos máximos de 180 días y Stand By's a plazos máximos de 360 días. Este límite podrá ser utilizado por las siguientes divisiones y bajo los siguientes sublímites:</p><p><br></p><p>- División Bebidas: Podrá utilizar la totalidad del techo por USD 90 MM.</p><p>- División Industrial: Podrá utilizar hasta un monto de USD 20 MM.&nbsp;Aval / Obligación Solidaria de la División Bebidas.</p><p>- División Motriz:&nbsp;Podrá utilizar hasta un monto de USD 10 MM.&nbsp;</p><p><br></p><p>Actualmente se tienen los siguientes saldos dispuestos:</p><p><br></p><p>División Motriz</p><p>a) Carta de Crédito por un monto de 8,5 MM USD , la carta está establecida a un plazo de 180 con fecha de vencimiento en noviembre del 2015.</p><p><br></p><p>(5) RIESGO DE TESORERÍA: Techo por 5 MM USD para realizar operaciones de FX, CCS e IRS para cobertura de tipo de cambio y de tasa de interés a plazos màximos de 60 meses. Las operaciones al amparo de este techo servírán para cubrir créditos con BBVA Bancomer. Se deberá contar con contrato ISDA o similar en todos los casos.</p><p><br></p><p>Las operaciones que se formalicen con el Sector Industrial y Motriz deberán contar con Aval / Obligación Solidaria de la División Bebidas</p><p><br></p><p>Actualmente se tienen las siguientes operaciones formalizadas:</p><p><br></p><p>División Bebidas:</p><p>a) Operaciones de IRS para cubrir la tasa de interés por un monto de USD 1 y con fecha de vencimiento máximo en 2019.</p><p><br></p><p>La suma de las operaciones al amparo de los Límites del (1) al (5) no pueden superar USD 120 MM (Considerar que las operaciones al amparo de los límites (1) y (2) no podrán superar USD 70 MM como ya se ha mencionado)</p><p><br></p><p>Los límites se podrán utilizar en USD o su equivalente en Moneda Nacional.</p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p>
			`,
			parent: 0,
			nombre: 'Comercializadora del Sureste S.A de C.V.',
			tipo: 'Grupo',
			fecha_constitucion: '',
			actividad_principal: '',
			cliente_desde: '',
			pais_cabecera: '',
			rfc: '',
			cuenta_clave: 'NO',
			examen: true,
			codigo: '3PHABW8MH1G3',
			entidad: 9016,
			cif: 'xxxx',
			cash_flow: [
				{
					ano: 2014,
					datos: [
						{
							titulo: 'Generación Interna de fondos',
							monto: 747778,
						},
						{
							titulo: 'Capital circulante',
							monto: 0,
						},
						{
							titulo: 'Cash flow operativo',
							monto: -5259,
						},
						{
							titulo: 'Capex',
							monto: 0,
						},
						{
							titulo: 'Inversiones / desinversiones',
							monto: -1135696,
						},
						{
							titulo: 'Otros (Dividendos de participadas)',
							monto: -1010403,
						},
						{
							titulo: 'Cash flow de Inversión',
							monto: -125293,
						},
						{
							titulo: 'Variación neta deuda financiera',
							monto: 1442116,
						},
						{
							titulo: 'Ampliaciones capital (dividendos)',
							monto: 0,
						},
						{
							titulo: 'Dividendos / shares buy back',
							monto: -847691,
						},
						{
							titulo: 'Otros',
							monto: null,
						},
						{
							titulo: 'Cash flow de financiación',
							monto: 484663,
						},
						{
							titulo: 'Variación en la tesorería',
							monto: -25748,
						},
					]
				},
				{
					ano: 2015,
					datos: [
						{
							titulo: 'Generación Interna de fondos',
							monto: 838030,
						},
						{
							titulo: 'Capital circulante',
							monto: 0,
						},
						{
							titulo: 'Cash flow operativo',
							monto: 1507272,
						},
						{
							titulo: 'Capex',
							monto: 0,
						},
						{
							titulo: 'Inversiones / desinversiones',
							monto: -2284295,
						},
						{
							titulo: 'Otros (Dividendos de participadas)',
							monto: 482604,
						},
						{
							titulo: 'Cash flow de Inversión',
							monto: -2766899,
						},
						{
							titulo: 'Variación neta deuda financiera',
							monto: 312362,
						},
						{
							titulo: 'Ampliaciones capital (dividendos)',
							monto: 0,
						},
						{
							titulo: 'Dividendos / shares buy back',
							monto: 0,
						},
						{
							titulo: 'Otros',
							monto: 0,
						},
						{
							titulo: 'Cash flow de financiación',
							monto: 581837,
						},
						{
							titulo: 'Variación en la tesorería',
							monto: 160240,
						},
					]
				}

			],
			magnitudes_y_ratios: [
				{
					ano: 2014,
					datos: [
						{
							titulo: 'Fondo de Maniobra',
							monto: 646363,
						},
						{
							titulo: 'Deuda financiera total',
							monto: 22037,
						},
						{
							titulo: 'Deuda financiera neta',
							monto: 23708,
						},
						{
							titulo: 'Cash Flow  Discrecional',
							monto: null,
						},
						{
							titulo: 'Deuda financiera total/Patrimonio neto (x)',
							monto: 0.00402401,
						},
						{
							titulo: 'Cobertura de intereses con EBITDA (x)',
							monto: 21550,
						},
						{
							titulo: 'Pay-back neto (n° años)',
							monto: 1140,
						},
						{
							titulo: 'GIF/Deuda financiera Neta (%)',
							monto: 0,
						},
						{
							titulo: 'Retorno sobre el Patrimonio Neto (%)',
							monto: 9880,
						},
						{
							titulo: 'Deuda financiera neta/EBITDA (x)',
							monto: 0.01631613,
						},
					]
				},
				{
					ano: 2015,
					datos: [
						{
							titulo: 'Fondo de Maniobra',
							monto: 194453,
						},
						{
							titulo: 'Deuda financiera total',
							monto: 422341,
						},
						{
							titulo: 'Deuda financiera neta',
							monto: 419067,
						},
						{
							titulo: 'Cash Flow  Discrecional',
							monto: null,
						},
						{
							titulo: 'Deuda financiera total/Patrimonio neto (x)',
							monto: 0.08662701,
						},
						{
							titulo: 'Cobertura de intereses con EBITDA (x)',
							monto: 12780,
						},
						{
							titulo: 'Pay-back neto (n° años)',
							monto: 1930,
						},
						{
							titulo: 'GIF/Deuda financiera Neta (%)',
							monto: 0.00178439,
						},
						{
							titulo: 'Retorno sobre el Patrimonio Neto (%)',
							monto: 7150,
						},
						{
							titulo: 'Deuda financiera neta/EBITDA (x)',
							monto: 0.31282902,
						},
					]
				},
				{
					ano: 2016,
					datos: [
						{
							titulo: 'Fondo de Maniobra',
							monto: 249353,
						},
						{
							titulo: 'Deuda financiera total',
							monto: 443239,
						},
						{
							titulo: 'Deuda financiera neta',
							monto: 163175,
						},
						{
							titulo: 'Cash Flow  Discrecional',
							monto: null,
						},
						{
							titulo: 'Deuda financiera total/Patrimonio neto (x)',
							monto: 0.08404775,
						},
						{
							titulo: 'Cobertura de intereses con EBITDA (x)',
							monto: 7100,
						},
						{
							titulo: 'Pay-back neto (n° años)',
							monto: 1830,
						},
						{
							titulo: 'GIF/Deuda financiera Neta (%)',
							monto: 0.0013577,
						},
						{
							titulo: 'Retorno sobre el Patrimonio Neto (%)',
							monto: 7300,
						},
						{
							titulo: 'Deuda financiera neta/EBITDA (x)',
							monto: 0.12577097,
						},
					]
				},
				
			],
			informes: [
				{
					fecha: '31/12/2012',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2012,
					divisa: 'PESOS MEXICANOS',
					balance: {
						activo: [
							{
								titulo: 'Efectivo  2,5  2,3  2,1',
								monto: 187964,
								porcentaje: '',
							},
							{
								titulo: 'Ctas/Notas x cobrar - Comerciales  ',
								monto: 390486,
								porcentaje: null,
							},
							{
								titulo: 'Reserva para ctas incobrables (-) ',
								monto: 24177,
								porcentaje: null,
							},
							{
								titulo: 'Tot ctas x cobrar-Netas  ',
								monto: 366309,
								porcentaje: null,
							},
							{
								titulo: 'Préstamos a emp rel - PC',
								monto: 38220,
								porcentaje: null,
							},
						
							{
								titulo: 'Adeudado por emp rel - PC  ',
								monto: 172514,
								porcentaje: null,
							},
							{
								titulo: 'Ctas/Notas x cobrar - Otras  ',
								monto: 506015,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos acreditables ',
								monto: 211946,
								porcentaje: null,
							},
							{
								titulo: 'Materias primas   ',
								monto: 324548,
								porcentaje: null,
							},
							{
								titulo: 'Existencias por recibir  ',
								monto: 39067,
								porcentaje: null,
							},
							{
								titulo: 'Producción en proceso  ',
								monto: 3904,
								porcentaje: null,
							},
							{
								titulo: 'Producto terminado',
								monto: 152153,
								porcentaje: null,
							},
							{
								titulo: 'Depreciación de existencias (-)',
								monto: 6567,
								porcentaje: null,
							},
							{
								titulo: 'Anticipos a proveedores',
								monto: 6334,
								porcentaje: null,
							},
							{
								titulo: 'Otro inventario',
								monto: 3640,
								porcentaje: null,
							},
							{
								titulo: 'Total inventario  6,9  8,3  8,5',
								monto: 3640,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVO CIRCULANTE ',
								monto: 2006047,
								porcentaje: null,
							},
						
							{
								titulo: 'ACTIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Construcción en proceso ',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Edificios y mejoras',
								monto: 6469682,
								porcentaje: null,
							},
							{
								titulo: 'Maquinaria y equipo ',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Muebles y equipo',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Activo fijo bruto  ',
								monto: 6469682,
								porcentaje: null,
							},
							{
								titulo: 'Depreciación acumulada (-)  ',
								monto: 2459470,
								porcentaje: null,
							},
							{
								titulo: 'Total activo fijo - Neto',
								monto: 4010212,
								porcentaje: null,
							},
							{
								titulo: 'Inversión en subsidiarias  ',
								monto: 711832,
								porcentaje: null,
							},
							{
								titulo: 'Anticipos/Diferidos - PLP - -  ',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Activo no circ operativos',
								monto: 266778,
								porcentaje: null,
							},
							{
								titulo: 'Activos no circ no op',
								monto: 34102,
								porcentaje: null,
							},
							{
								titulo: 'Fondo de comercio',
								monto: 527002,
								porcentaje: null,
							},
							{
								titulo: 'Intangibles - Otros',
								monto: 60862,
								porcentaje: null,
							},
							{
								titulo: 'Total intangibles - Netos',
								monto: 587864,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVOS NO CIRC',
								monto: 5610788,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVOS  ',
								monto: 7616835,
								porcentaje: null,
							},
					
						],
						pasivo: [
							{
								titulo: 'PASIVO CIRCULANTE',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Prést banc x pagar CP  ',
								monto: 2738,
								porcentaje: null,
							},
							{
								titulo: 'PCPLP con bancos',
								monto: 23366,
								porcentaje: null,
							},
							{
								titulo: 'Proveedores (PC)  ',
								monto: 488918,
								porcentaje: null,
							},
							{
								titulo: 'Adeudado a emp rel - PC  ',
								monto: 95559,
								porcentaje: null,
							},
							{
								titulo: 'Anticipos de clientes (PC)   ',
								monto: 1838,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos x pagar   ',
								monto: 305404,
								porcentaje: null,
							},
							{
								titulo: 'Pasivo circ no op  ',
								monto: 170799,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVO CIRCULANTE',
								monto: 1359684,
								porcentaje: null,
							},
							{
								titulo: 'PASIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Deuda bancaria LP ',
								monto: 19299,
								porcentaje: null,
							},
							{
								titulo: 'Gasto x indemnización de retiro - PLP ',
								monto: 342033,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos diferidos exigibles - PLP  ',
								monto: 419440,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVOS NO CIRC  ',
								monto: 780772,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVO  ',
								monto: 2140456,
								porcentaje: null,
							},
							{
								titulo: 'CAPITAL CONTABLE',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Capital de interés minoritario  ',
								monto: 90319,
								porcentaje: null,
							},
							{
								titulo: 'Capital exhibido',
								monto: 2271363,
								porcentaje: null,
							},
							{
								titulo: 'Otro capital',
								monto: -56286,
								porcentaje: null,
							},
							{
								titulo: 'Resultados retenidos',
								monto: 3170983,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL CAP CONTABLE  ',
								monto: 5476379,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVOS Y CAP CONTABLE  ',
								monto: 7616835,
								porcentaje: null,
							},
						]
					},
					cuenta_resultados: [
						{
							titulo: 'Ventas nacionales ',
							monto: 9718771,
							porcentaje: null,
						},
						{
							titulo: 'Coste de ventas/Ingresos (-)  ',
							monto: 5147129,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO BRUTO      ',
							monto: 4571642,
							porcentaje: null,
						},
						{
							titulo: 'Gastos de venta (-) ',
							monto: 3118599,
							porcentaje: null,
						},
						{
							titulo: 'Depreciación (-) ',
							monto: 289919,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL GASTO OPERACION  ',
							monto: 3408518,
							porcentaje: null,
						},
						{
							titulo: 'RDO. NETO DE OPERACION ',
							monto: 1163124,
							porcentaje: null,
						},
						{
							titulo: 'Gasto x interés (-)  ',
							monto: 9063,
							porcentaje: 6.8,
						},
						
						{
							titulo: 'Ingreso x interés ',
							monto: 12678,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) tipo de cambio  ',
							monto: -8808,
							porcentaje: null,
						},
						{
							titulo: 'Tot ingreso x interés(Gto)',
							monto: 3615,
							porcentaje: null,
						},
						{
							titulo: 'Ingresos de subs y asociaciones  ',
							monto: 76388,
							porcentaje: null,
						},
						{
							titulo: 'Otros gastos (-) ',
							monto: 8637,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL OTROS (GTO) INGRESOS ',
							monto: 71366,
							porcentaje: null,
						},
						{
							titulo: 'RDO. ANT IMPUESTOS  ',
							monto: 1225682,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos (-)  ',
							monto: 327508,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos diferidos (-)  (0,1)  (0,4)  (0,2)',
							monto: -8067,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL GASTO X IMPTOS  ',
							monto: 319441,
							porcentaje: null,
						},
						{
							titulo: 'Interés minoritario (-)  ',
							monto: 5575,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO ANTES DE',
							monto: '',
							porcentaje: null,
						},
						{
							titulo: 'PARTIDAS EXTRAORDINARIAS  ',
							monto: 900666,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) extraordinaria  ',
							monto: -179,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO NETO  ',
							monto: 900487,
							porcentaje: null,
						},
						{
							titulo: 'Rdo.antes impto e int (EBIT)  ',
							monto: 1163124,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes impto, int depr y amort (EBITDA)  ',
							monto: 1453043,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes int, depr y amort (EBIDA)  ',
							monto: 1133602,
							porcentaje: null,
						},
						{
							titulo: 'Dividendos - Común (-)   -',
							monto: -894327,
							porcentaje: null,
						},
						{
							titulo: 'Retiradas (-) ',
							monto: 899902,
							porcentaje: null,
						},
						{
							titulo: 'Ajuste a utilidades retenidas  ',
							monto: 595017,
							porcentaje: null,
						},
						
					],
				},
				{
					fecha: '31/12/2013',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2013,
					divisa: 'PESOS MEXICANOS',
					balance: {
						activo: [
							{
								titulo: 'Efectivo  2,5  2,3  2,1',
								monto: 174598,
								porcentaje: '',
							},
							{
								titulo: 'Ctas/Notas x cobrar - Comerciales  ',
								monto: 373767,
								porcentaje: null,
							},
							{
								titulo: 'Reserva para ctas incobrables (-) ',
								monto: 18813,
								porcentaje: null,
							},
							{
								titulo: 'Tot ctas x cobrar-Netas  ',
								monto: 354954,
								porcentaje: null,
							},
							{
								titulo: 'Préstamos a emp rel - PC',
								monto: 29070,
								porcentaje: null,
							},
							{
								titulo: 'Adeudado por emp rel - PC',
								monto: 227350,
								porcentaje: null,
							},
							
							{
								titulo: 'Ctas/Notas x cobrar - Otras  ',
								monto: 254695,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos acreditables ',
								monto: 113658,
								porcentaje: null,
							},
							{
								titulo: 'Materias primas   ',
								monto: 231938,
								porcentaje: null,
							},
							{
								titulo: 'Existencias por recibir  ',
								monto: 7159,
								porcentaje: null,
							},
							{
								titulo: 'Producción en proceso  ',
								monto: 6261,
								porcentaje: null,
							},
							{
								titulo: 'Producto terminado',
								monto: 149575,
								porcentaje: null,
							},
							{
								titulo: 'Depreciación de existencias (-)',
								monto: 2900,
								porcentaje: null,
							},
							{
								titulo: 'Anticipos a proveedores',
								monto: 14224,
								porcentaje: null,
							},
							{
								titulo: 'Otro inventario',
								monto: 226612,
								porcentaje: null,
							},
							{
								titulo: 'Total inventario  6,9  8,3  8,5',
								monto: 632869,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVO CIRCULANTE ',
								monto: 1787194,
								porcentaje: null,
							},
						
							{
								titulo: 'ACTIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Construcción en proceso ',
								monto: 14773,
								porcentaje: null,
							},
							{
								titulo: 'Edificios y mejoras',
								monto: 2337025,
								porcentaje: null,
							},
							{
								titulo: 'Maquinaria y equipo ',
								monto: 4144012,
								porcentaje: null,
							},
							{
								titulo: 'Muebles y equipo',
								monto: 235505,
								porcentaje: null,
							},
							{
								titulo: 'Activo fijo bruto  ',
								monto: 6731315,
								porcentaje: null,
							},
							{
								titulo: 'Depreciación acumulada (-)  ',
								monto: 2607795,
								porcentaje: null,
							},
							{
								titulo: 'Total activo fijo - Neto',
								monto: 4123520,
								porcentaje: null,
							},
							{
								titulo: 'Inversión en subsidiarias  ',
								monto: 728849,
								porcentaje: null,
							},
							{
								titulo: 'Anticipos/Diferidos - PLP - -  ',
								monto: 40799,
								porcentaje: null,
							},
							{
								titulo: 'Activo no circ operativos',
								monto: 263705,
								porcentaje: null,
							},
							{
								titulo: 'Activos no circ no op',
								monto: 118737,
								porcentaje: null,
							},
							{
								titulo: 'Fondo de comercio',
								monto: 527002,
								porcentaje: null,
							},
							{
								titulo: 'Intangibles - Otros',
								monto: 61396,
								porcentaje: null,
							},
							{
								titulo: 'Total intangibles - Netos',
								monto: 588398,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVOS NO CIRC',
								monto: 5864008,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVOS  ',
								monto: 7651202,
								porcentaje: null,
							},
					
						],
						pasivo: [
							{
								titulo: 'PASIVO CIRCULANTE',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Prést banc x pagar CP  ',
								monto: 11466000,
								porcentaje: null,
							},
							{
								titulo: 'PCPLP con bancos',
								monto: 351030,
								porcentaje: null,
							},
							{
								titulo: 'Proveedores (PC)  ',
								monto: 420424,
								porcentaje: null,
							},
							{
								titulo: 'Adeudado a emp rel - PC  ',
								monto: 245335,
								porcentaje: null,
							},
							{
								titulo: 'Anticipos de clientes (PC)   ',
								monto: 1601,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos x pagar   ',
								monto: 318382,
								porcentaje: null,
							},
							{
								titulo: 'Pasivo circ no op  ',
								monto: 141309,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVO CIRCULANTE',
								monto: 1592741,
								porcentaje: null,
							},
							{
								titulo: 'PASIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Deuda bancaria LP ',
								monto: 410875,
								porcentaje: null,
							},
							{
								titulo: 'Gasto x indemnización de retiro - PLP ',
								monto: 404261,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos diferidos exigibles - PLP  ',
								monto: 367929,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVOS NO CIRC  ',
								monto: 1183065,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVO  ',
								monto: 2775806,
								porcentaje: null,
							},
							{
								titulo: 'CAPITAL CONTABLE',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Capital de interés minoritario  ',
								monto: 91580,
								porcentaje: null,
							},
							{
								titulo: 'Capital exhibido',
								monto: 2671363,
								porcentaje: null,
							},
							{
								titulo: 'Otro capital',
								monto: -141780,
								porcentaje: null,
							},
							{
								titulo: 'Resultados retenidos',
								monto: 2254233,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL CAP CONTABLE  ',
								monto: 4875396,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVOS Y CAP CONTABLE  ',
								monto: 7651202,
								porcentaje: null,
							},
						]
					},
					cuenta_resultados: [
						{
							titulo: 'Ventas nacionales ',
							monto: 9989984,
							porcentaje: null,
						},
						{
							titulo: 'Coste de ventas/Ingresos (-)  ',
							monto: 5210651,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO BRUTO      ',
							monto: 4779333,
							porcentaje: null,
						},
						{
							titulo: 'Gastos de venta (-) ',
							monto: 3439729,
							porcentaje: null,
						},
						{
							titulo: 'Depreciación (-) ',
							monto: 303297,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL GASTO OPERACION  ',
							monto: 3743026,
							porcentaje: null,
						},
						{
							titulo: 'RDO. NETO DE OPERACION ',
							monto: 1036307,
							porcentaje: null,
						},
						{
							titulo: 'Gasto x interés (-)  ',
							monto: 3274,
							porcentaje: null,
						},
					
						{
							titulo: 'Ingreso x interés ',
							monto: 10681,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) tipo de cambio  ',
							monto: -8431,
							porcentaje: null,
						},
						{
							titulo: 'Tot ingreso x interés(Gto)',
							monto: -22059,
							porcentaje: null,
						},
						{
							titulo: 'Ingresos de subs y asociaciones  ',
							monto: 22989,
							porcentaje: null,
						},
						{
							titulo: 'Otros gastos (-) ',
							monto: 3530,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL OTROS (GTO) INGRESOS ',
							monto: -2600,
							porcentaje: null,
						},
						{
							titulo: 'RDO. ANT IMPUESTOS  ',
							monto: 1025276,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos (-)  ',
							monto: 326642,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos diferidos (-)  (0,1)  (0,4)  (0,2)',
							monto: -37098,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL GASTO X IMPTOS  ',
							monto: 289544,
							porcentaje: null,
						},
						{
							titulo: 'Interés minoritario (-)  ',
							monto: 2482,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO ANTES DE',
							monto: '',
							porcentaje: null,
						},
						{
							titulo: 'PARTIDAS EXTRAORDINARIAS  ',
							monto: 733250,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) extraordinaria  ',
							monto: null,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO NETO  ',
							monto: 733250,
							porcentaje: null,
						},
						{
							titulo: 'Rdo.antes impto e int (EBIT)  ',
							monto: 1036307,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes impto, int depr y amort (EBITDA)  ',
							monto: 1339604,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes int, depr y amort (EBIDA)  ',
							monto: 1050060,
							porcentaje: null,
						},
						{
							titulo: 'Dividendos - Común (-)   -',
							monto: -1650000,
							porcentaje: null,
						},
						{
							titulo: 'Retiradas (-) ',
							monto: null,
							porcentaje: null,
						},
						{
							titulo: 'Ajuste a utilidades retenidas  ',
							monto: null,
							porcentaje: null,
						},
						
					],
				},
				{
					fecha: '31/12/2014',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2014,
					divisa: 'PESOS MEXICANOS',
					balance: {
						activo: [
							{
								titulo: 'Efectivo  2,5  2,3  2,1',
								monto: 175846,
								porcentaje: '',
							},
							{
								titulo: 'Ctas/Notas x cobrar - Comerciales  ',
								monto: 431941,
								porcentaje: null,
							},
							{
								titulo: 'Reserva para ctas incobrables (-) ',
								monto: 21994,
								porcentaje: null,
							},
							{
								titulo: 'Tot ctas x cobrar-Netas  ',
								monto: 409947,
								porcentaje: null,
							},
							{
								titulo: 'Préstamos a emp rel - PC',
								monto: 192279,
								porcentaje: null,
							},
							{
								titulo: 'Adeudado por emp rel - PC',
								monto: 229901,
								porcentaje: null,
							},
							
							{
								titulo: 'Ctas/Notas x cobrar - Otras  ',
								monto: 181742,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos acreditables ',
								monto: 162159,
								porcentaje: null,
							},
							{
								titulo: 'Materias primas   ',
								monto: 297935,
								porcentaje: null,
							},
							{
								titulo: 'Existencias por recibir  ',
								monto: null,
								porcentaje: null,
							},
							{
								titulo: 'Producción en proceso  ',
								monto: 5470,
								porcentaje: null,
							},
							{
								titulo: 'Producto terminado',
								monto: 179241,
								porcentaje: null,
							},
							{
								titulo: 'Depreciación de existencias (-)',
								monto: 2336,
								porcentaje: null,
							},
							{
								titulo: 'Anticipos a proveedores',
								monto: null,
								porcentaje: null,
							},
							{
								titulo: 'Otro inventario',
								monto: 222236,
								porcentaje: null,
							},
							{
								titulo: 'Total inventario  6,9  8,3  8,5',
								monto: 702550,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVO CIRCULANTE ',
								monto: 2054420,
								porcentaje: null,
							},
						
							{
								titulo: 'ACTIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Construcción en proceso ',
								monto: 63350,
								porcentaje: null,
							},
							{
								titulo: 'Edificios y mejoras',
								monto: 2251089,
								porcentaje: null,
							},
							{
								titulo: 'Maquinaria y equipo ',
								monto: 4801468,
								porcentaje: null,
							},
							{
								titulo: 'Muebles y equipo',
								monto: 629369,
								porcentaje: null,
							},
							{
								titulo: 'Activo fijo bruto  ',
								monto: 7745276,
								porcentaje: null,
							},
							{
								titulo: 'Depreciación acumulada (-)  ',
								monto: 3034452,
								porcentaje: null,
							},
							{
								titulo: 'Total activo fijo - Neto',
								monto: 4710824,
								porcentaje: null,
							},
							{
								titulo: 'Inversión en subsidiarias  ',
								monto: 737881,
								porcentaje: null,
							},
							{
								titulo: 'Anticipos/Diferidos - PLP - -  ',
								monto: 91066,
								porcentaje: null,
							},
							{
								titulo: 'Activo no circ operativos',
								monto: null,
								porcentaje: null,
							},
							{
								titulo: 'Activos no circ no op',
								monto: 71583,
								porcentaje: null,
							},
							{
								titulo: 'Fondo de comercio',
								monto: 527002,
								porcentaje: null,
							},
							{
								titulo: 'Intangibles - Otros',
								monto: 76753,
								porcentaje: null,
							},
							{
								titulo: 'Total intangibles - Netos',
								monto: 603755,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVOS NO CIRC',
								monto: 6215109,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVOS  ',
								monto: 8269529,
								porcentaje: null,
							},
					
						],
						pasivo: [
							{
								titulo: 'PASIVO CIRCULANTE',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Prést banc x pagar CP  ',
								monto: 25863000,
								porcentaje: null,
							},
							{
								titulo: 'PCPLP con bancos',
								monto: 162766000,
								porcentaje: null,
							},
							{
								titulo: 'Proveedores (PC)  ',
								monto: 583512,
								porcentaje: null,
							},
							{
								titulo: 'Adeudado a emp rel - PC  ',
								monto: 169187,
								porcentaje: null,
							},
							{
								titulo: 'Anticipos de clientes (PC)   ',
								monto: 145,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos x pagar   ',
								monto: 411009,
								porcentaje: null,
							},
							{
								titulo: 'Pasivo circ no op  ',
								monto: 218513,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVO CIRCULANTE',
								monto: 1805067,
								porcentaje: null,
							},
							{
								titulo: 'PASIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Deuda bancaria LP ',
								monto: 417376,
								porcentaje: null,
							},
							{
								titulo: 'Gasto x indemnización de retiro - PLP ',
								monto: 409136,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos diferidos exigibles - PLP  ',
								monto: 364293,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVOS NO CIRC  ',
								monto: 1190805,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVO  ',
								monto: 2995872,
								porcentaje: null,
							},
							{
								titulo: 'CAPITAL CONTABLE',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Capital de interés minoritario  ',
								monto: 93574,
								porcentaje: null,
							},
							{
								titulo: 'Capital exhibido',
								monto: 2671363,
								porcentaje: null,
							},
							{
								titulo: 'Otro capital',
								monto: -47186,
								porcentaje: null,
							},
							{
								titulo: 'Resultados retenidos',
								monto: 2555906,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL CAP CONTABLE  ',
								monto: 5273657,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVOS Y CAP CONTABLE  ',
								monto: 8269529,
								porcentaje: null,
							},
						]
					},
					cuenta_resultados: [
						{
							titulo: 'Ventas nacionales ',
							monto: 10108228,
							porcentaje: null,
						},
						{
							titulo: 'Coste de ventas/Ingresos (-)  ',
							monto: 5307648,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO BRUTO      ',
							monto: 4800580,
							porcentaje: null,
						},
						{
							titulo: 'Gastos de venta (-) ',
							monto: 3503181,
							porcentaje: null,
						},
						{
							titulo: 'Depreciación (-) ',
							monto: 426521,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL GASTO OPERACION  ',
							monto: 3929702,
							porcentaje: null,
						},
						{
							titulo: 'RDO. NETO DE OPERACION ',
							monto: 870878,
							porcentaje: null,
						},
						{
							titulo: 'Gasto x interés (-)  ',
							monto: 51481,
							porcentaje: null,
						},
					
						{
							titulo: 'Ingreso x interés ',
							monto: 10681,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) tipo de cambio  ',
							monto: 19066,
							porcentaje: null,
						},
						{
							titulo: 'Tot ingreso x interés(Gto)',
							monto: -40475,
							porcentaje: null,
						},
						{
							titulo: 'Ingresos de subs y asociaciones  ',
							monto: 6242,
							porcentaje: null,
						},
						{
							titulo: 'Otros gastos (-) ',
							monto: 14449,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL OTROS (GTO) INGRESOS ',
							monto: -48682,
							porcentaje: null,
						},
						{
							titulo: 'RDO. ANT IMPUESTOS  ',
							monto: 841262,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos (-)  ',
							monto: 260885,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos diferidos (-)  (0,1)  (0,4)  (0,2)',
							monto: -16456,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL GASTO X IMPTOS  ',
							monto: 244429,
							porcentaje: null,
						},
						{
							titulo: 'Interés minoritario (-)  ',
							monto: 1962,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO ANTES DE',
							monto: '',
							porcentaje: null,
						},
						{
							titulo: 'PARTIDAS EXTRAORDINARIAS  ',
							monto: 594871,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) extraordinaria  ',
							monto: null,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO NETO  ',
							monto: 594871,
							porcentaje: null,
						},
						{
							titulo: 'Rdo.antes impto e int (EBIT)  ',
							monto: 870878,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes impto, int depr y amort (EBITDA)  ',
							monto: 1297399,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes int, depr y amort (EBIDA)  ',
							monto: 1052970,
							porcentaje: null,
						},
						{
							titulo: 'Dividendos - Común (-)   -',
							monto: 0,
							porcentaje: null,
						},
						{
							titulo: 'Retiradas (-) ',
							monto: null,
							porcentaje: null,
						},
						{
							titulo: 'Ajuste a utilidades retenidas  ',
							monto: -293198,
							porcentaje: null,
						},
						
					],
				},
			],
			buro: [
				{
					buro_de_credito: 'EMBOTELLADORA DEL SURESTE SA DE CV',
					fecha: '17/05/2015',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '2,743,527',
					dls_val: '',
					udis_val: '',
					total: '2,743,527',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
				{
					buro_de_credito: 'SURESTE INDUSTRIAL SA DE CV',
					fecha: '17/05/2015',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '0',
					dls_val: '',
					udis_val: '',
					total: '0',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
				{
					buro_de_credito: 'SURESTE MOTRIZ SA DE CV',
					fecha: '17/05/2015',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '38,700',
					dls_val: '',
					udis_val: '',
					total: '38,700',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
				{
					buro_de_credito: 'GRUPO FINANCIERO DEL SURESTE SOFOM',
					fecha: '17/05/2015',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '3,271,460',
					dls_val: '',
					udis_val: '',
					total: '3,271,460',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
			],
			rating: [
				// {
				// 	ano: 2014,
				// 	score: 5.17,
				// 	escala_maestra: 'BBB',
				// 	escala_larga: 'BBB2',
				// },
				// {
				// 	ano: 2013,
				// 	score: 5.14,
				// 	escala_maestra: 'BBB',
				// 	escala_larga: 'BBB2',
				// }
				{
					ano: 2014,
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: 2013,
					score: '',
					escala_maestra: '',
					escala_larga: '',
				}
			],
			rating_local: [
				// {
				// 	nombre: 'EMBOTELLADORA DEL SURESTE SA DE CV',
				// 	fecha: '2014-12-31',
				// 	puntuacion_cuantitativa: 1.95,
				// 	puntuacion_cualitativa: 4.25,
				// 	puntuacion_tital: 6.20,
				// 	escala_actual: 'BBB-2',
				// 	escala_anterior: 'BBB-2'
				// },
				// {
				// 	nombre: 'SURESTE INDUSTRIAL SA DE CV',
				// 	fecha: '2014-12-31',
				// 	puntuacion_cuantitativa: 2.09,
				// 	puntuacion_cualitativa: 4.28,
				// 	puntuacion_tital: 6.37,
				// 	escala_actual: 'BB+1',
				// 	escala_anterior: 'BB+1'
				// },
				// {
				// 	nombre: 'SURESTE MOTRIZ SA DE CV',
				// 	fecha: '2014-12-31',
				// 	puntuacion_cuantitativa: 3.35,
				// 	puntuacion_cualitativa: 4.69,
				// 	puntuacion_tital: 8.05,
				// 	escala_actual: 'B2',
				// 	escala_anterior: 'B-3'
				// },
				// {
				// 	nombre: 'GRUPO FINANCIERO DEL SURESTE SOFOM',
				// 	fecha: '2014-12-31',
				// 	puntuacion_cuantitativa: 'NR',
				// 	puntuacion_cualitativa: 'NR',
				// 	puntuacion_tital: 'NR',
				// 	escala_actual: 'NR',
				// 	escala_anterior: 'NR'
				// },
				{
					nombre: 'EMBOTELLADORA DEL SURESTE SA DE CV',
					fecha: '2014-12-31',
					puntuacion_cuantitativa: '',
					puntuacion_cualitativa: '',
					puntuacion_tital: '',
					escala_actual: '',
					escala_anterior: ''
				},
				{
					nombre: 'SURESTE INDUSTRIAL SA DE CV',
					fecha: '2014-12-31',
					puntuacion_cuantitativa: '',
					puntuacion_cualitativa: '',
					puntuacion_tital: '',
					escala_actual: '',
					escala_anterior: ''
				},
				{
					nombre: 'SURESTE MOTRIZ SA DE CV',
					fecha: '2014-12-31',
					puntuacion_cuantitativa: '',
					puntuacion_cualitativa: '',
					puntuacion_tital: '',
					escala_actual: '',
					escala_anterior: ''
				},
				{
					nombre: 'GRUPO FINANCIERO DEL SURESTE SOFOM',
					fecha: '2014-12-31',
					puntuacion_cuantitativa: '',
					puntuacion_cualitativa: '',
					puntuacion_tital: '',
					escala_actual: '',
					escala_anterior: ''
				},
			],
			politicas: [
				{
					negritas: false,
					nombre: 'RIESGO FINANCIERO L/P SIN GARANTIAS REALES',
					limite_anterior: '70',
					limite_actual: '67',
					dispuesto: '67',
					propuesto: '80',
					limite_nuevo: '',
					notas: '(1)',
				},
				{
					negritas: false,
					nombre: 'RIESGO FINANCIERO L/P CON GARANTIAS REALES',
					limite_anterior: '70',
					limite_actual: '0',
					dispuesto: '0',
					propuesto: '80',
					limite_nuevo: '',
					notas: '(2)',
				},
				{
					negritas: false,
					nombre: 'RIESGO FINANCIERO C/P',
					limite_anterior: '120',
					limite_actual: '40',
					dispuesto: '25',
					propuesto: '140',
					limite_nuevo: '',
					notas: '(3)',
				},
				{
					negritas: false,
					nombre: 'RIESGO DE FIRMA',
					limite_anterior: '90',
					limite_actual: '8.5',
					dispuesto: '8.5',
					propuesto: '90',
					limite_nuevo: '',
					notas: '(4)',
				},
				{
					negritas: false,
					nombre: 'RIESGO DE TESORERÍA',
					limite_anterior: '5',
					limite_actual: '0',
					dispuesto: '0',
					propuesto: '5',
					limite_nuevo: '',
					notas: '(5)',
				},
				{
					negritas: false,
					nombre: 'TOTAL RIESGO CORPORATIVO',
					limite_anterior: '120',
					limite_actual: '116',
					dispuesto: '101',
					propuesto: '140',
					limite_nuevo: '',
					notas: '',
				},
				{
					negritas: false,
					nombre: 'FINANCIACION ESPECIALIZADA',
					limite_anterior: '',
					limite_actual: '',
					dispuesto: '',
					propuesto: '',
					limite_nuevo: '',
					notas: '',
				},
				{
					negritas: false,
					nombre: 'OTROS',
					limite_anterior: '',
					limite_actual: '',
					dispuesto: '',
					propuesto: '',
					limite_nuevo: '',
					notas: '',
				},
				{
					negritas: true,
					nombre: 'TOTAL GRUPO',
					limite_anterior: '120',
					limite_actual: '116',
					dispuesto: '101',
					propuesto: '140',
					limite_nuevo: '',
					notas: '',
				},
			]
		},
		// Examen 2
		{
			id: 4, 
			posiciones_actuales: `
			<p>POSICIONES ACTUALES:</p><p><br></p><p>(1) RIESGO FINANCIERO LARGO PLAZO SIN GARANTIAS REALES.- Techo por 300 MM USD (o su equivalente en Moneda Nacional) para realizar operaciones a plazos máximos de 5 años. Forma de pago a través de amortizaciones mensuales o trimestrales iguales y sucesivas. Al amparo de este límite se pueden realizar las siguientes operaciones con las siguientes empresas, bajo lo siguientes sublímites y los siguientes plazos:</p><p><br></p><p>- Mexicos Podrá utilizar la totalidad del techo por 300 MM USD y plazos hasta 5 años incluyendo hasta dos años de gracia.</p><p>- Consmexica: Podrá utilizar hasta un monto de 100 MM USD. y plazos hasta 5 años incluyendo hasta dos años de gracia.</p><p>- Huasteca: Podrá utilizar hasta un límite USD 15 MM USD y plazos hasta 3 años.</p><p><br></p><p>La suma de las disposiciones realizadas por las empresas Mexicos, Consmexica y Huasteca&nbsp;no podrá superar USD 300 MM</p><p><br></p><p>Actualmente se tienen los siguientes saldos dispuestos:</p><p><br></p><p>Mexicos:</p><p>a) Crédito Simple a un plazo de 5 años con amoritizaciones y pago de intereses trimestrales con vencimiento en marzo del 2015. Saldo dispuesto por 10 MM USD</p><p><br></p><p>Consmexica:</p><p>a) Crédito simple a un plazo de 5 años incluidos dos de gracias con amortizaciones mensuales. Covenants: cobertura de intereses mayor de 3.0X a 1.0X; Apalancamiento menor a 3.30X. Saldo dispuesto por 56 MM y fecha de vencimiento&nbsp;en febrero del 2017.</p><p><br></p><p>(2) RIESGO FINANCIERO LARGO PLAZO CON GARANTIAS REALES.- Límite para realizar operaciones hasta&nbsp;350 MM USD (o su equivalente en Moneda Nacional) y con plazos máximos de 7 años. Forma de pago a través de amortizaciones mensuales o trimestrales. Se podrán establecer&nbsp;operaciones de arrendamiento financiero y en caso de establecerse créditos para la compra de maquinaria y/o equipo esta deberá contar con garantía del bien financiado. También se podrán formalizar CS para capital de trabajo permanente con GH con cobertura mínima de 1,5X. Al amparo de este límite se pueden realizar las siguientes operaciones con las siguientes empresas, bajo lo siguientes sublímites y los siguientes plazos:</p><p><br></p><p>- Mexicos: Podrá utilizar la totalidad del techo por 350 MM USD y plazos hasta 7 años.</p><p>- Consmexica: Podrá utilizar hasta un monto de 100 MM USD. y plazos hasta 7 años.</p><p>- Huasteca: Podrá utilizar hasta un límite USD 15 MM USD y plazos hasta 3 años.</p><p><br></p><p>La suma de las disposiciones realizadas por las empresas Mexicos, Consmexica y Huasteca&nbsp;no podrá superar USD 350 MM</p><p><br></p><p>Actualmente se tienen los siguientes saldos dispuestos:</p><p><br></p><p>Mexicos:</p><p>a) Créditos simple a un plazo de 5 años con amortizaciones mensuales i guales y sucesivas. GH con cobertura de 1,5X. Saldo dispuesto por USD 80 MM y fecha de vencimiento en nov-17.</p><p>b) Operaciones de arrendamiento financiero de maquinaria y equipo a un plazo de 7 años. Saldo dispuesto de estas operaciones&nbsp;134 USD MM con diversas fechas de vencimiento.</p><p><br></p><p>(3) RIESGO FINANCIERO C/P Y COMERCIAL:&nbsp;Techo por 450 MM USD para operaciones a plazos máximos de 12 meses. Se podrán operar cualquiera de los productos del catálogo a excepción de PQ´s. Los contratos se podrán firmar a un plazo de 24 meses con revisión anual. Este límite podrá ser utilizado por las siguientes empresas y bajo los siguientes sublímites:</p><p><br></p><p>- Mexicos: Podrá utilizar la totalidad del techo por 450 MM USD .</p><p>- Consmexica: Podrá utilizar hasta un monto de 140 MM USD.</p><p>- Huasteca: Podrá utilizar hasta un límite USD 20 MM.</p><p><br></p><p>Actualmente se tienen los siguientes saldos dispuestos:</p><p><br></p><p>Huasteca:&nbsp;&nbsp;</p><p>a) Crediproveedores por un monto de 10 MM USD&nbsp;y saldo dispuesto por 3 MM USD.</p><p><br></p><p>(4) RIESGO DE FIRMA: Techo por $150 MM USD (o su equivalente en Moneda Nacional) para operaciones a plazos máximos de 1 año.&nbsp;Se podrán establecer Cartas de Crédito y/o&nbsp;Stand By's a plazos máximos de 360 días. Este límite podrá ser utilizado por las siguientes empresas y bajo los siguientes sublímites:</p><p><br></p><p>- Mexicos: Podrá utilizar la totalidad del techo por 150 MM USD .</p><p>- Consmexica: Podrá utilizar hasta un monto de 70 MM USD</p><p>- Huasteca: Podrá utilizar hasta un límite USD 20 MM USD.</p><p><br></p><p>Actualmente se tienen los siguientes saldos dispuestos:</p><p><br></p><p>Huasteca:</p><p>a) Cartas de Crédito para materias primas por un monto de 6 MM USD con diferentes vencimientos.&nbsp;</p><p><br></p><p>(5) RIESGO DE TESORERÍA: Techo por 35 MM USD para realizar operaciones de Cross Currency Swaps (CCS) e interest Rate Swap (IRS) para cobertura de tipo de cambio y de tasa de interés a plazos máximos de 60 meses. Las operaciones al amparo de este techo servírán para cubrir créditos con BBVA Bancomer y/o emisiones de bonos, para este último se podrán establecer cobertura con plazos de hasta 10 años. Se deberá contar con contrato ISDA y CSA o equivalente local en todos los casos. Este límite podrá ser utilizado por las siguientes empresas y bajo los siguientes sublímites:</p><p><br></p><p>- Mexicos: Podrá utilizar la totalidad del techo por 35 MM USD .</p><p>- Consmexica: Podrá utilizar hasta un monto de 10 MM USD</p><p>- Huasteca: Podrá utilizar hasta un límite USD 1 MM USD.</p><p><br></p><p>Actualmente se tienen las siguientes operaciones formalizadas:</p><p><br></p><p>Mexicos</p><p>a) Operaciones de IRS para cubrir la tasa de interés por un monto de USD 30.</p><p><br></p><p>La suma de las operaciones al amparo de los Límites del (1) al (5) no pueden superar USD 450 MM.</p><p><br></p><p>Los límites se podrán utilizar en USD o su equivalente en Moneda Nacional.</p><p><br></p>
			`,
			parent: 0,
			nombre: 'Grupo Kraken SA de CV',
			tipo: 'Grupo',
			fecha_constitucion: '',
			actividad_principal: '',
			cliente_desde: '',
			pais_cabecera: '',
			rfc: '',
			cuenta_clave: 'NO',
			examen: true,
			codigo: 'YZWE6KBM3WF9',
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2012',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2012,
					divisa: 'PESOS MEXICANOS',
					balance: {
						activo: [
							{
								titulo: 'Efectivo ',
								monto: 11525319,
								porcentaje: '',
							},
							{
								titulo: 'Ctas/Notas x cobrar - Comerciales  ',
								monto: 13904466,
								porcentaje: null,
							},
							{
								titulo: 'Préstamos a emp rel - PC  ',
								monto: 67615,
								porcentaje: null,
							},
							{
								titulo: 'Ctas/Notas x cobrar - Otras - -  ',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Producto terminado  ',
								monto: 8843763,
								porcentaje: null,
							},
							{
								titulo: 'Anticipos/Diferidos - PC   ',
								monto: 369025,
								porcentaje: null,
							},
							{
								titulo: 'Activos derivados - PC -',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVO CIRCULANTE  ',
								monto: 34710188,
								porcentaje: null,
							},
							{
								titulo: 'ACTIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Terrenos ',
								monto: 34135386,
								porcentaje: null,
							},
							{
								titulo: 'Ctas/Notas x cobrar -Largo plazo - -  ',
								monto: '',
								porcentaje: null,
							},
							
							{
								titulo: 'Inversión en subsidiarias  ',
								monto: 777288,
								porcentaje: null,
							},
							{
								titulo: 'Préstamos a emp rel - PLP  ',
								monto: 50553,
								porcentaje: null,
							},
							{
								titulo: 'Activo no circ operativos ',
								monto: 369619,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos recuperables diferidos - PLP  ',
								monto: 1006178,
								porcentaje: null,
							},
							{
								titulo: 'Fondo de comercio  ',
								monto: 5926780,
								porcentaje: null,
							},
							{
								titulo: 'Intangibles - Otros  ',
								monto: 6635352,
								porcentaje: null,
							},
							{
								titulo: 'Total intangibles - Netos  ',
								monto: 12562132,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVOS NO CIRC  ',
								monto: 48901156,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVOS  ',
								monto: 83611344,
								porcentaje: null,
							},
							
							
						],
						pasivo: [
							{
								titulo: 'PASIVO CIRCULANTE',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'PCPLP con bancos  ',
								monto: 3912939,
								porcentaje: null,
							},
							{
								titulo: 'Proveedores (PC) ',
								monto: 11490562,
								porcentaje: null,
							},
							{
								titulo: 'Adeudado a emp rel ',
								monto: 214459,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos x pagar  - ',
								monto: 5846,
								porcentaje: null,
							},
							{
								titulo: 'Gasto x indemnización de retiro - ',
								monto: 294355,
								porcentaje: null,
							},
							{
								titulo: 'Pasivo circ operación  ',
								monto: 4443157,
								porcentaje: null,
							},
							{
								titulo: 'Pasivos derivados - PC  ',
								monto: 139229,
								porcentaje: null,
							},
							{
								titulo: 'Pasivo circ no op ',
								monto: 139229,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVO CIRCULANTE  ',
								monto: 20500547,
								porcentaje: null,
							},
							{
								titulo: 'PASIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Deuda bancaria LP  ',
								monto: 24743917,
								porcentaje: null,
							},
							{
								titulo: 'Pasivos derivados - PLP ',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Pasivo no circ no op  ',
								monto: 794276,
								porcentaje: null,
							},
							{
								titulo: 'Provisiones diversas LP (incl. Impuestos diferidos  ',
								monto: 5260853,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVOS NO CIRC  ',
								monto: 30799046,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVO  ',
								monto: 51299593,
								porcentaje: null,
							},
							{
								titulo: 'CAPITAL CONTABLE',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Capital de interés minoritario ',
								monto: 4590288,
								porcentaje: null,
							},
							{
								titulo: 'Otro capital (Area gris)  ',
								monto: 5252859,
								porcentaje: null,
							},
							{
								titulo: 'Capital exhibido  ',
								monto: 2747376,
								porcentaje: null,
							},
							{
								titulo: 'Resultados retenidos  ',
								monto: 17413797,
								porcentaje: null,
							},
							{
								titulo: 'Otro ingreso integral acum  ',
								monto: 2307431,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL CAP CONTABLE  ',
								monto: 32311751,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVOS Y CAP CONTABLE  ',
								monto: 83611344,
								porcentaje: null,
							},
							
						]
					},
					cuenta_resultados: [
						{
							titulo: 'Ventas nacionales ',
							monto: 63463233,
							porcentaje: null,
						},
						{
							titulo: 'Coste de ventas/Ingresos (-)  ',
							monto: 44597177,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO BRUTO      ',
							monto: 18866056,
							porcentaje: null,
						},
						{
							titulo: 'Gastos generales y administrativos (-)  ',
							monto: 9317232,
							porcentaje: null,
						},
						{
							titulo: 'Depreciación (-) ',
							monto: 920444,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL GASTO OPERACION  ',
							monto: 10237676,
							porcentaje: null,
						},
						{
							titulo: 'RDO. NETO DE OPERACION ',
							monto: 8628380,
							porcentaje: null,
						},
						{
							titulo: 'Gasto x interés (-)  ',
							monto: 1978708,
							porcentaje: 6.8,
						},
						
						{
							titulo: 'Ingreso x interés ',
							monto: 167379,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) tipo de cambio  ',
							monto: -1114168,
							porcentaje: null,
						},
						{
							titulo: 'Tot ingreso x interés(Gto)',
							monto: -1811329,
							porcentaje: null,
						},
						{
							titulo: 'Ingresos de subs y asociaciones  ',
							monto: '',
							porcentaje: null,
						},
						{
							titulo: 'Resultado de posición monetaria  ',
							monto: -45007,
							porcentaje: null,
						},
						{
							titulo: 'Otros gastos (-) ',
							monto: 321202,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL OTROS (GTO) INGRESOS ',
							monto: 2177538,
							porcentaje: null,
						},
						{
							titulo: 'RDO. ANT IMPUESTOS  ',
							monto: 5336674,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos (-)  ',
							monto: 2135728,
							porcentaje: null,
						},
					
						{
							titulo: 'RESULTADO ANTES DE',
							monto: '',
							porcentaje: null,
						},
						{
							titulo: 'PARTIDAS EXTRAORDINARIAS  ',
							monto: 3200946,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) extraordinaria  ',
							monto: -893515,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO NETO  ',
							monto: 2307431,
							porcentaje: null,
						},
						{
							titulo: 'Rdo.antes impto e int (EBIT)  ',
							monto: 8628380,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes impto, int depr y amort (EBITDA)  ',
							monto: 9548824,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes int, depr y amort (EBIDA)  ',
							monto:  7413096,
							porcentaje: null,
						},
					],
				},
				{
					fecha: '31/12/2013',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2013,
					divisa: 'PESOS MEXICANOS',
					balance: {
						activo: [
							{
								titulo: 'Efectivo ',
								monto: 23304478,
								porcentaje: '',
							},
							{
								titulo: 'Ctas/Notas x cobrar - Comerciales  ',
								monto: 16117723,
								porcentaje: null,
							},
							{
								titulo: 'Préstamos a emp rel - PC  ',
								monto: 47941,
								porcentaje: null,
							},
							{
								titulo: 'Ctas/Notas x cobrar - Otras - -  ',
								monto: 328037,
								porcentaje: null,
							},
							{
								titulo: 'Producto terminado  ',
								monto: 12049418,
								porcentaje: null,
							},
							{
								titulo: 'Anticipos/Diferidos - PC   ',
								monto: 972856,
								porcentaje: null,
							},
							{
								titulo: 'Activos derivados - PC -',
								monto: 8549,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVO CIRCULANTE  ',
								monto: 52829002,
								porcentaje: null,
							},
							{
								titulo: 'ACTIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Terrenos ',
								monto: 43908268,
								porcentaje: null,
							},
							{
								titulo: 'Ctas/Notas x cobrar -Largo plazo - -  ',
								monto: 214774,
								porcentaje: null,
							},
							
							{
								titulo: 'Inversión en subsidiarias  ',
								monto: 1221802,
								porcentaje: null,
							},
							{
								titulo: 'Préstamos a emp rel - PLP  ',
								monto: 50553,
								porcentaje: null,
							},
							{
								titulo: 'Activo no circ operativos ',
								monto: 855232,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos recuperables diferidos - PLP  ',
								monto: 774532,
								porcentaje: null,
							},
							{
								titulo: 'Fondo de comercio  ',
								monto: 6746382,
								porcentaje: null,
							},
							{
								titulo: 'Intangibles - Otros  ',
								monto: 15500803,
								porcentaje: null,
							},
							{
								titulo: 'Total intangibles - Netos  ',
								monto: 22247185,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVOS NO CIRC  ',
								monto: 69272346,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVOS  ',
								monto: 122101348,
								porcentaje: null,
							},
							
							
						],
						pasivo: [
							{
								titulo: 'PASIVO CIRCULANTE',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'PCPLP con bancos  ',
								monto: 4909937,
								porcentaje: null,
							},
							{
								titulo: 'Proveedores (PC) ',
								monto: 11994790,
								porcentaje: null,
							},
							{
								titulo: 'Adeudado a emp rel ',
								monto: 581713,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos x pagar  - ',
								monto: 5057,
								porcentaje: null,
							},
							{
								titulo: 'Gasto x indemnización de retiro - ',
								monto: 4809186,
								porcentaje: null,
							},
							{
								titulo: 'Pasivo circ operación  ',
								monto: 945.812,
								porcentaje: null,
							},
							{
								titulo: 'Pasivos derivados - PC  ',
								monto: 0,
								porcentaje: null,
							},
							{
								titulo: 'Pasivo circ no op ',
								monto: 21285,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVO CIRCULANTE  ',
								monto: 23267780,
								porcentaje: null,
							},
							{
								titulo: 'PASIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Deuda bancaria LP  ',
								monto: 38057156,
								porcentaje: null,
							},
							{
								titulo: 'Pasivos derivados - PLP ',
								monto: 227627,
								porcentaje: null,
							},
							{
								titulo: 'Pasivo no circ no op  ',
								monto: 300226,
								porcentaje: null,
							},
							{
								titulo: 'Provisiones diversas LP (incl. Impuestos diferidos  ',
								monto: 8896979,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVOS NO CIRC  ',
								monto: 47481988,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVO  ',
								monto: 70749768,
								porcentaje: null,
							},
							{
								titulo: 'CAPITAL CONTABLE',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Capital de interés minoritario ',
								monto: 29234249,
								porcentaje: null,
							},
							{
								titulo: 'Otro capital (Area gris)  ',
								monto: 2850703,
								porcentaje: null,
							},
							{
								titulo: 'Capital exhibido  ',
								monto: 2747376,
								porcentaje: null,
							},
							{
								titulo: 'Resultados retenidos  ',
								monto: 12013741,
								porcentaje: null,
							},
							{
								titulo: 'Otro ingreso integral acum  ',
								monto: 4505511,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL CAP CONTABLE  ',
								monto: 51351580,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVOS Y CAP CONTABLE  ',
								monto: 122101348,
								porcentaje: null,
							},
							
						]
					},
					cuenta_resultados: [
						{
							titulo: 'Ventas nacionales ',
							monto: 78446682,
							porcentaje: null,
						},
						{
							titulo: 'Coste de ventas/Ingresos (-)  ',
							monto: 49552653,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO BRUTO      ',
							monto: 28894029,
							porcentaje: null,
						},
						{
							titulo: 'Gastos generales y administrativos (-)  ',
							monto: 14214861,
							porcentaje: null,
						},
						{
							titulo: 'Depreciación (-) ',
							monto: 4675616,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL GASTO OPERACION  ',
							monto: 18890477,
							porcentaje: null,
						},
						{
							titulo: 'RDO. NETO DE OPERACION ',
							monto: 10003552,
							porcentaje: null,
						},
						{
							titulo: 'Gasto x interés (-)  ',
							monto: 3859902,
							porcentaje: 6.8,
						},
						
						{
							titulo: 'Ingreso x interés ',
							monto: 520068,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) tipo de cambio  ',
							monto: -345712,
							porcentaje: null,
						},
						{
							titulo: 'Tot ingreso x interés(Gto)',
							monto: -3339834,
							porcentaje: null,
						},
						{
							titulo: 'Ingresos de subs y asociaciones  ',
							monto: 58458,
							porcentaje: null,
						},
						{
							titulo: 'Resultado de posición monetaria  ',
							monto: -39065,
							porcentaje: null,
						},
						{
							titulo: 'Otros gastos (-) ',
							monto: 36515,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL OTROS (GTO) INGRESOS ',
							monto: 3356956,
							porcentaje: null,
						},
						{
							titulo: 'RDO. ANT IMPUESTOS  ',
							monto: 6300884,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos (-)  ',
							monto: 1552020,
							porcentaje: null,
						},
					
						{
							titulo: 'RESULTADO ANTES DE',
							monto: '',
							porcentaje: null,
						},
						{
							titulo: 'PARTIDAS EXTRAORDINARIAS  ',
							monto: 4748864,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) extraordinaria  ',
							monto: -243353,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO NETO  ',
							monto: 4505511,
							porcentaje: null,
						},
						{
							titulo: 'Rdo.antes impto e int (EBIT)  ',
							monto: 10003552,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes impto, int depr y amort (EBITDA)  ',
							monto: 14679168,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes int, depr y amort (EBIDA)  ',
							monto:  13127148,
							porcentaje: null,
						},
					],
				},
				{
					fecha: '31/12/2014',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2014,
					divisa: 'PESOS MEXICANOS',
					balance: {
						activo: [
							{
								titulo: 'Efectivo ',
								monto: 20075276,
								porcentaje: '',
							},
							{
								titulo: 'Ctas/Notas x cobrar - Comerciales  ',
								monto: 17688637,
								porcentaje: null,
							},
							{
								titulo: 'Préstamos a emp rel - PC  ',
								monto: 547890,
								porcentaje: null,
							},
							{
								titulo: 'Ctas/Notas x cobrar - Otras - -  ',
								monto: 263897,
								porcentaje: null,
							},
							{
								titulo: 'Producto terminado  ',
								monto: 11780590,
								porcentaje: null,
							},
							{
								titulo: 'Anticipos/Diferidos - PC   ',
								monto: 667359,
								porcentaje: null,
							},
							{
								titulo: 'Activos derivados - PC -',
								monto: 9810,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVO CIRCULANTE  ',
								monto: 51033459,
								porcentaje: null,
							},
							{
								titulo: 'ACTIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Terrenos ',
								monto: 55882311,
								porcentaje: null,
							},
							{
								titulo: 'Ctas/Notas x cobrar -Largo plazo - -  ',
								monto: '',
								porcentaje: null,
							},
							
							{
								titulo: 'Inversión en subsidiarias  ',
								monto: 547579,
								porcentaje: null,
							},
							{
								titulo: 'Préstamos a emp rel - PLP  ',
								monto: 53851,
								porcentaje: null,
							},
							{
								titulo: 'Activo no circ operativos ',
								monto: 949864,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos recuperables diferidos - PLP  ',
								monto: 2951759,
								porcentaje: null,
							},
							{
								titulo: 'Fondo de comercio  ',
								monto: 8674095,
								porcentaje: null,
							},
							{
								titulo: 'Intangibles - Otros  ',
								monto: 17314635,
								porcentaje: null,
							},
							{
								titulo: 'Total intangibles - Netos  ',
								monto: 25988730,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVOS NO CIRC  ',
								monto: 86374094,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL ACTIVOS  ',
								monto: 137407553,
								porcentaje: null,
							},
							
							
						],
						pasivo: [
							{
								titulo: 'PASIVO CIRCULANTE',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'PCPLP con bancos  ',
								monto: 8999339,
								porcentaje: null,
							},
							{
								titulo: 'Proveedores (PC) ',
								monto: 9903680,
								porcentaje: null,
							},
							{
								titulo: 'Adeudado a emp rel ',
								monto: 189814,
								porcentaje: null,
							},
							{
								titulo: 'Impuestos x pagar  - ',
								monto: 170948,
								porcentaje: null,
							},
							{
								titulo: 'Gasto x indemnización de retiro - ',
								monto: 5583612,
								porcentaje: null,
							},
							{
								titulo: 'Pasivo circ operación  ',
								monto: 918184,
								porcentaje: null,
							},
							{
								titulo: 'Pasivos derivados - PC  ',
								monto: 0,
								porcentaje: null,
							},
							{
								titulo: 'Pasivo circ no op ',
								monto: 297464,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVO CIRCULANTE  ',
								monto: 26063041,
								porcentaje: null,
							},
							{
								titulo: 'PASIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Deuda bancaria LP  ',
								monto: 38858778,
								porcentaje: null,
							},
							{
								titulo: 'Pasivos derivados - PLP ',
								monto: 976671,
								porcentaje: null,
							},
							{
								titulo: 'Pasivo no circ no op  ',
								monto: 340177,
								porcentaje: null,
							},
							{
								titulo: 'Provisiones diversas LP (incl. Impuestos diferidos  ',
								monto: 11603828,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVOS NO CIRC  ',
								monto: 51779454,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVO  ',
								monto: 77842495,
								porcentaje: null,
							},
							{
								titulo: 'CAPITAL CONTABLE',
								monto: '',
								porcentaje: null,
							},
							{
								titulo: 'Capital de interés minoritario ',
								monto: 33481276,
								porcentaje: null,
							},
							{
								titulo: 'Otro capital (Area gris)  ',
								monto: 3480547,
								porcentaje: null,
							},
							{
								titulo: 'Capital exhibido  ',
								monto: 2747376,
								porcentaje: null,
							},
							{
								titulo: 'Resultados retenidos  ',
								monto: 18346622,
								porcentaje: null,
							},
							{
								titulo: 'Otro ingreso integral acum  ',
								monto: 1509237,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL CAP CONTABLE  ',
								monto: 59565058,
								porcentaje: null,
							},
							{
								titulo: 'TOTAL PASIVOS Y CAP CONTABLE  ',
								monto: 137407553,
								porcentaje: null,
							},
							
						]
					},
					cuenta_resultados: [
						{
							titulo: 'Ventas nacionales ',
							monto: 80660864,
							porcentaje: null,
						},
						{
							titulo: 'Coste de ventas/Ingresos (-)  ',
							monto: 58074924,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO BRUTO      ',
							monto: 22585940,
							porcentaje: null,
						},
						{
							titulo: 'Gastos generales y administrativos (-)  ',
							monto: 13705731,
							porcentaje: null,
						},
						{
							titulo: 'Depreciación (-) ',
							monto: 1400383,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL GASTO OPERACION  ',
							monto: 15106114,
							porcentaje: null,
						},
						{
							titulo: 'RDO. NETO DE OPERACION ',
							monto: 7479826,
							porcentaje: null,
						},
						{
							titulo: 'Gasto x interés (-)  ',
							monto: 2837740,
							porcentaje: 6.8,
						},
						
						{
							titulo: 'Ingreso x interés ',
							monto: 891825,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) tipo de cambio  ',
							monto: -686077,
							porcentaje: null,
						},
						{
							titulo: 'Tot ingreso x interés(Gto)',
							monto: -1945915,
							porcentaje: null,
						},
						{
							titulo: 'Ingresos de subs y asociaciones  ',
							monto: 14544,
							porcentaje: null,
						},
						{
							titulo: 'Resultado de posición monetaria  ',
							monto: -176637,
							porcentaje: null,
						},
						{
							titulo: 'Otros gastos (-) ',
							monto: -970404,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL OTROS (GTO) INGRESOS ',
							monto: 1137604,
							porcentaje: null,
						},
						{
							titulo: 'RDO. ANT IMPUESTOS  ',
							monto: 5656145,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos (-)  ',
							monto: 2191351,
							porcentaje: null,
						},
					
						{
							titulo: 'RESULTADO ANTES DE',
							monto: '',
							porcentaje: null,
						},
						{
							titulo: 'PARTIDAS EXTRAORDINARIAS  ',
							monto: 3464794,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) extraordinaria  ',
							monto: 1955557,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO NETO  ',
							monto: 1509237,
							porcentaje: null,
						},
						{
							titulo: 'Rdo.antes impto e int (EBIT)  ',
							monto: 7479826,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes impto, int depr y amort (EBITDA)  ',
							monto: 8880209,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes int, depr y amort (EBIDA)  ',
							monto:  6688858,
							porcentaje: null,
						},
					],
				},
				
			],
			buro: [
				{
					buro_de_credito: 'Grupo Kraken SA de CV',
					fecha: '10/06/2014',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '1,039,286',
					dls_val: '',
					udis_val: '',
					total: '1,039,286',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
				{
					buro_de_credito: 'Méxicos SAB de CV',
					fecha: '10/06/2014',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '0',
					dls_val: '',
					udis_val: '',
					total: '0',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
				{
					buro_de_credito: 'Consmexica SA de CV',
					fecha: '10/06/2014',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '90,027',
					dls_val: '',
					udis_val: '',
					total: '90,027',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
				{
					buro_de_credito: 'Huasteca SAB',
					fecha: '10/06/2014',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '0',
					dls_val: '',
					udis_val: '',
					total: '0',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
			],
			rating: [
				// {
				// 	ano: 2013,
				// 	score: 6.08,
				// 	escala_maestra: 'BBB-',
				// 	escala_larga: 'BBB-2',
				// },
				// {
				// 	ano: 2012,
				// 	score: 5.77,
				// 	escala_maestra: 'BBB-',
				// 	escala_larga: 'BBB-1',
				// },
				{
					ano: 2013,
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: 2012,
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
			],
			rating_local: [
				{
					nombre: 'Grupo Kraken SA de CV',
					fecha: '2013-12-31',
					puntuacion_cuantitativa: 2.5,
					puntuacion_cualitativa: 3.58,
					puntuacion_tital: 6.08,
					escala_actual: 'BBB-2',
					escala_anterior: 'BBB-1'
				},
				{
					nombre: 'Quimexicos SAB de CV',
					fecha: '2013-12-31',
					puntuacion_cuantitativa: 2.28,
					puntuacion_cualitativa: 5.70,
					puntuacion_tital: 7.98,
					escala_actual: 'BBB-1',
					escala_anterior: 'BBB2'
				},
				{
					nombre: 'Consmexica SA de CV',
					fecha: '2013-12-31',
					puntuacion_cuantitativa: 2.56,
					puntuacion_cualitativa: 4.18,
					puntuacion_tital: 6.73,
					escala_actual: 'BB+2',
					escala_anterior: 'BB+1'
				},
				{
					nombre: 'Huasteca SAB',
					fecha: '2013-12-31',
					puntuacion_cuantitativa: 3.24,
					puntuacion_cualitativa: 4.50,
					puntuacion_tital: 7.74,
					escala_actual: 'B+3',
					escala_anterior: 'BB-2'
				},
			],
			cash_flow: [
				{
					ano: 2012,
					datos: [
						{
							titulo: 'Generación Interna de fondos',
							monto: 4505511,
						},
						{
							titulo: 'Capital circulante',
							monto: 0,
						},
						{
							titulo: 'Cash flow operativo',
							monto: 4307988,
						},
						{
							titulo: 'Capex',
							monto: 0,
						},
						{
							titulo: 'Inversiones / desinversiones',
							monto: -14448489,
						},
						{
							titulo: 'Otros (Dividendos de participadas)',
							monto: 0,
						},
						{
							titulo: 'Cash flow de Inversión',
							monto: -22911671,
						},
						{
							titulo: 'Variación neta deuda financiera',
							monto: 14310237,
						},
						{
							titulo: 'Ampliaciones capital (dividendos)',
							monto: 0,
						},
						{
							titulo: 'Dividendos / shares buy back',
							monto: 0,
						},
						{
							titulo: 'Otros',
							monto: 0,
						},
						{
							titulo: 'Cash flow de financiación',
							monto: 26223043,
						},
						{
							titulo: 'Variación en la tesorería',
							monto: 12124871,
						},
					]
				},
				{
					ano: 2013,
					datos: [
						{
							titulo: 'Generación Interna de fondos',
							monto: 1509237,
						},
						{
							titulo: 'Capital circulante',
							monto: 0,
						},
						{
							titulo: 'Cash flow operativo',
							monto: 131178,
						},
						{
							titulo: 'Capex',
							monto: 0,
						},
						{
							titulo: 'Inversiones / desinversiones',
							monto: -13374426,
						},
						{
							titulo: 'Otros (Dividendos de participadas)',
							monto: 0,
						},
						{
							titulo: 'Cash flow de Inversión',
							monto: -19663616,
						},
						{
							titulo: 'Variación neta deuda financiera',
							monto: 4891024,
						},
						{
							titulo: 'Ampliaciones capital (dividendos)',
							monto: 0,
						},
						{
							titulo: 'Dividendos / shares buy back',
							monto: 0,
						},
						{
							titulo: 'Otros',
							monto: 0,
						},
						{
							titulo: 'Cash flow de financiación',
							monto: 15480076,
						},
						{
							titulo: 'Variación en la tesorería',
							monto: -2543125,
						},
					]
				}

			],
			magnitudes_y_ratios: [
				{
					ano: 2011,
					datos: [
						{
							titulo: 'Fondo de Maniobra',
							monto: 14209641,
						},
						{
							titulo: 'Deuda financiera total',
							monto: 24743917,
						},
						{
							titulo: 'Deuda financiera neta',
							monto: 22765209,
						},
						{
							titulo: 'Cash Flow  Discrecional',
							monto: null,
						},
						{
							titulo: 'Deuda financiera total/Patrimonio neto (x)',
							monto: 0.76578694,
						},
						{
							titulo: 'Cobertura de intereses con EBITDA (x)',
							monto: 3.7,
						},
						{
							titulo: 'Pay-back neto (n° años)',
							monto: 3,
						},
						{
							titulo: 'GIF/Deuda financiera Neta (%)',
							monto: 0,
						},
						{
							titulo: 'Retorno sobre el Patrimonio Neto (%)',
							monto: 7.14,
						},
						{
							titulo: 'Deuda financiera neta/EBITDA (x)',
							monto: 2.3840851,
						},
					]
				},
				{
					ano: 2012,
					datos: [
						{
							titulo: 'Fondo de Maniobra',
							monto: 29651222,
						},
						{
							titulo: 'Deuda financiera total',
							monto: 38057156,
						},
						{
							titulo: 'Deuda financiera neta',
							monto: 34197254,
						},
						{
							titulo: 'Cash Flow  Discrecional',
							monto: null,
						},
						{
							titulo: 'Deuda financiera total/Patrimonio neto (x)',
							monto: 0.74110974,
						},
						{
							titulo: 'Cobertura de intereses con EBITDA (x)',
							monto: 2.63,
						},
						{
							titulo: 'Pay-back neto (n° años)',
							monto: 2.93,
						},
						{
							titulo: 'GIF/Deuda financiera Neta (%)',
							monto: 0.13175067,
						},
						{
							titulo: 'Retorno sobre el Patrimonio Neto (%)',
							monto: 8.77,
						},
						{
							titulo: 'Deuda financiera neta/EBITDA (x)',
							monto: 2.32964520,
						},
					]
				},
				{
					ano: 2013,
					datos: [
						{
							titulo: 'Fondo de Maniobra',
							monto: 24970418,
						},
						{
							titulo: 'Deuda financiera total',
							monto: 38858778,
						},
						{
							titulo: 'Deuda financiera neta',
							monto: 36021038,
						},
						{
							titulo: 'Cash Flow  Discrecional',
							monto: null,
						},
						{
							titulo: 'Deuda financiera total/Patrimonio neto (x)',
							monto: 0.65237539,
						},
						{
							titulo: 'Cobertura de intereses con EBITDA (x)',
							monto: 2.99,
						},
						{
							titulo: 'Pay-back neto (n° años)',
							monto: 5.39,
						},
						{
							titulo: 'GIF/Deuda financiera Neta (%)',
							monto: 0.04189876,
						},
						{
							titulo: 'Retorno sobre el Patrimonio Neto (%)',
							monto: 2.53,
						},
						{
							titulo: 'Deuda financiera neta/EBITDA (x)',
							monto: 4.05632773,
						},
					]
				},
				
			],
			politicas: [
				{
					negritas: false,
					nombre: 'RIESGO FINANCIERO L/P SIN GARANTIAS REALES',
					limite_anterior: '300',
					limite_actual: '80',
					dispuesto: '66',
					propuesto: '300',
					limite_nuevo: '',
					notas: '(1)',
				},
				{
					negritas: false,
					nombre: 'RIESGO FINANCIERO L/P CON GARANTIAS REALES',
					limite_anterior: '350',
					limite_actual: '250',
					dispuesto: '214',
					propuesto: '400',
					limite_nuevo: '',
					notas: '(2)',
				},
				{
					negritas: false,
					nombre: 'RIESGO FINANCIERO C/P',
					limite_anterior: '450',
					limite_actual: '10',
					dispuesto: '3',
					propuesto: '550',
					limite_nuevo: '',
					notas: '(3)',
				},
				{
					negritas: false,
					nombre: 'RIESGO DE FIRMA',
					limite_anterior: '150',
					limite_actual: '6',
					dispuesto: '6',
					propuesto: '150',
					limite_nuevo: '',
					notas: '(4)',
				},
				{
					negritas: false,
					nombre: 'RIESGO DE TESORERÍA',
					limite_anterior: '35',
					limite_actual: '30',
					dispuesto: '30',
					propuesto: '35',
					limite_nuevo: '',
					notas: '(5)',
				},
				{
					negritas: false,
					nombre: 'TOTAL RIESGO CORPORATIVO',
					limite_anterior: '450',
					limite_actual: '376',
					dispuesto: '319',
					propuesto: '550',
					limite_nuevo: '',
					notas: '',
				},
				{
					negritas: false,
					nombre: 'FINANCIACION ESPECIALIZADA',
					limite_anterior: '',
					limite_actual: '',
					dispuesto: '',
					propuesto: '',
					limite_nuevo: '',
					notas: '',
				},
				{
					negritas: false,
					nombre: 'OTROS',
					limite_anterior: '',
					limite_actual: '',
					dispuesto: '',
					propuesto: '',
					limite_nuevo: '',
					notas: '',
				},
				{
					negritas: false,
					nombre: 'TOTAL GRUPO',
					limite_anterior: '450',
					limite_actual: '376',
					dispuesto: '319',
					propuesto: '550',
					limite_nuevo: '',
					notas: '',
				},
				
			]
			
			
		},
		// Examen 3
		{
			id: 5, 
			posiciones_actuales: `
			<p>POSICIONES ACTUALES:</p><p><br></p><p>(1) RIESGO FINANCIERO LARGO PLAZO SIN GARANTIAS REALES.- Techo por $250MM USD (o su equivalente en Moneda Nacional) para realizar operaciones a plazos máximos de 7 años, con máximo 3 años de carencia o 5 años bullet. Al amparo de este Límite se podrán realizar las siguientes operaciones con las tres divisiones y bajo lo siguientes sublímites:</p><p><br></p><p>- Grupo Metales Internacionales: Podrá utilizar la totalidad del techo por USD 250 MM.</p><p>- Nations Mining Corporation: Podrá utilizar la totalidad del techo por USD 250 MM contando con el aval / Obligación solidaria de Grupo Metales Internacionales.</p><p>- Infraestructura y Transportes Nacionales SA de CV : Podrá utilizar hasta un monto de USD 150 MM.</p><p><br></p><p>La suma de las disposiciones realizadas por Grupo Metales Internacionales , Nations Mining Corporation e Infraestructura y Transportes Nacionales no podrá superar de USD 250 MM</p><p><br></p><p>Actualmente sin riesgos dispuestos.</p><p><br></p><p>(2) RIESGO FINANCIERO LARGO PLAZO CON GARANTIAS REALES.- Límite para realizar operaciones hasta $450MM USD (o su equivalente en Moneda Nacional) para realizar operaciones a plazos máximos de 10 años, máximo con 3 años de carencia.&nbsp;</p><p><br></p><p>&nbsp;-Grupo Metales Internacionales: Podrá utilizar la totalidad del techo por USD 450 MM.</p><p>- Nations Mining Corporation: Podrá utilizar la totalidad del techo por USD 450 MM contando con el aval / Obligación solidaria de Grupo México.</p><p>- Infraestructura y Transportes Nacionales: Podrá utilizar hasta un monto de 300 MM&nbsp;</p><p>- Proyectos y Desarrollos Nacionales: Podrá utilizar hasta un monto de USD 250 MM&nbsp;</p><p><br></p><p>La suma de las disposiciones realizadas por Grupo Metales Internacionales, Nations Mining Corporation e Infraestructura , Transportes Nacionales y Proyectos y Desarrollos&nbsp;nacionales no podrá superar de USD 450 MM</p><p><br></p><p>Actualmente se tienen los siguientes saldos dispuestos:</p><p><br></p><p>Infraestructura y Transportes Nacionales SA de CV:&nbsp;&nbsp;</p><p>a) Arrendamiento por un monto de USD&nbsp;4,08 MM con vencimiento en Septiembre del 2016</p><p>b) Arrendamiento por USD 13,7 MM con vencimiento en 2017</p><p>c) Crédito Simple por USD 260,5 MM con vencimiento en 2023&nbsp;</p><p><br></p><p>Destino: Adquisición y arrendamiento de Tolvas, Locomotoras, Equipo de Arrastre y transporte directo.</p><p><br></p><p>Proyectos y Desarrollos Nacionales:&nbsp;</p><p>a) Arrendamiento por USD 3,2 MM con vencimiento en 2023</p><p>a) Crédito simple por USD 21 MM con vencimiento en 2021</p><p><br></p><p>Destino: Adquisición de Maquinaria y Equipo de construcción</p><p><br></p><p>Las disposiciones al amparo de los límites (1) y (2) no podrán superar USD 450 MM</p><p>Los Términos y Condiciones de cada operación que se quiera establecer&nbsp;al amparo de los límites (1) y (2)deberán contar con Vo. Bo. de UCRC.</p><p><br></p><p>(3) RIESGO FINANCIERO C/P Y COMERCIAL:&nbsp;Techo por $500MM USD para operaciones a plazos máximos de 12 meses. Para establecer operaciones de PQ se deberá c ontar con Vo. Bo. de UCRC y no se podrá operar hasta un monto máximo de USD 150 MM. Los contratos se podrán firmar a un plazo de 24 meses con revisión anual.</p><p><br></p><p>- Grupo Metales Internacionales: Podrá utilizar la totalidad del techo por USD 500 MM y de PQs por USD 150 MM.</p><p>- Nations Mining Corporation: Podrá utilizar la totalidad del techo por USD 500 MM y de PQs por USD 150 MM contando con el aval / Obligación solidaria de Grupo México.</p><p>- Infraestructura y Transportes Nacionales SA de CV : Podrá utilizar hasta un monto de USD 300 MM y en PQs hasta por USD 75 MM.</p><p><br></p><p>Actualmente se tienen los siguientes saldos dispuestos:</p><p><br></p><p>Grupo Metales Internacionales:&nbsp;&nbsp;</p><p>a) PQ&nbsp;por un monto de $100MM USD en prestamos quirografarios, con vencimiento el&nbsp;proximo 20 de noviembre de 2014</p><p>b) CCC hasta por un monto de USD 207,5 MM las disposiciones con plazo de hasta 12 meses.</p><p><br></p><p>(4) RIESGO DE FIRMA: Techo por $100MM USD (o su equivalente en Moneda Nacional) para operaciones a plazos máximos de 3 años.&nbsp;Se podrán establecer Cartas de Crédito y Stand By.</p><p><br></p><p>&nbsp;-Grupo Metales Internacionales: Podrá utilizar la totalidad del techo por USD 100 MM.</p><p>- Nations Mining Corporation: Podrá utilizar la totalidad del techo por USD 100 MM contando con el aval / Obligación solidaria de Grupo México.</p><p>- Infraestructura y Transportes Nacionales: Podrá utilizar hasta un monto de 50 MM&nbsp;</p><p>- Proyectos y Desarrollos Nacionales: Podrá utilizar hasta un monto de USD 20 MM&nbsp;</p><p><br></p><p>Actualmente se tienen los siguientes saldos dispuestos:</p><p><br></p><p>Nations Mining Corporation:&nbsp;</p><p>a) Carta de Crédito por un monto de USD 45,5 MM, la carta está establecida a un plazo de 12 meses y con el aval de Grupo México , vencimiento en el 2015.</p><p><br></p><p>Proyectos y Desarrollos Nacionales:</p><p>a) Carta de Crédito por USD 1,8MM para cumplir con la garantía solicitada en uno de los proyectos en proceso, vencimiento en 2015.</p><p><br></p><p>(5) RIESGO DE TESORERÍA: Techo por $100MM USD para realizar operaciones de FX, CCS e IRS para cobertura de tipo de cambio y de tasa de interés a plazos màximos de 36 meses. Para operaciones a plazos mayores se deberá contar con Vo. Bo por parte de UCRC. Las operaciones al amparo de este techo servírán para cubrir créditos con BBVA Bancomer. Se deberá contar con contrato ISDA o similar en todos los casos.</p><p><br></p><p>Actualmente se tienen las siguientes operaciones:</p><p><br></p><p>Proyectos y Desarrollos Nacionales:</p><p>a) Operación de IRS para cubrir la tasa de interés del contrato por USD 21 MM a favor de la empresa. El consumo al día de hoy es por USD 0,741 MM</p><p><br></p><p>La suma de las operaciones al amparo de los Límites del (1) al (5) no podrán superar USD 850 MM (Considerar que las operaciones al amparo de los límites (1) y (2) no podrán superar USD 450 MM como ya se ha mencionado)</p><p><br></p><p>Los límites se podrán utilizar en USD o su equivalente en Moneda Nacional.</p><p><br></p><p><br></p><p><br></p><p><br></p><p><br></p>
			`,
			parent: 0,
			nombre: 'México de Metales Internacionales SAB',
			tipo: 'Grupo',
			fecha_constitucion: '',
			actividad_principal: '',
			cliente_desde: '',
			pais_cabecera: '',
			rfc: '',
			cuenta_clave: 'NO',
			examen: true,
			codigo: 'EFNRG5FA67NB',
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2011',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2011,
					divisa: 'PESOS MEXICANOS',
					balance: {
						activo: [
							{
								titulo: 'Efectivo',
								monto: 83900,
								porcentaje: '',
							},
							{
								titulo: 'Depósitos a plazo  ',
								monto: 2335859,
								porcentaje: '',
							},
							{
								titulo: 'Inversiones en valores  ',
								monto: 1060925,
								porcentaje: '',
							},
							{
								titulo: 'Ctas/Notas x cobrar - Comerciales  ',
								monto: 969100,
								porcentaje: '',
							},
							{
								titulo: 'Reserva para ctas incobrables (-)  -  ',
								monto: 5966,
								porcentaje: '',
							},
							{
								titulo: 'Tot ctas x cobrar-Netas  ',
								monto: 963134,
								porcentaje: '',
							},
							{
								titulo: 'Ctas/Notas x cobrar -',
								monto: 274295,
								porcentaje: '',
							},
							{
								titulo: 'Materias primas  ',
								monto: 363600,
								porcentaje: '',
							},
							{
								titulo: 'Producción en proceso  ',
								monto: 450900,
								porcentaje: '',
							},
							{
								titulo: 'Producto terminado  ',
								monto: 202400,
								porcentaje: '',
							},
							{
								titulo: 'Depreciación de existencias (-) -',
								monto: 2000,
								porcentaje: '',
							},
							
							{
								titulo: 'Otro inventario  ',
								monto: 94080,
								porcentaje: '',
							},
							{
								titulo: 'Total inventario   ',
								monto: 1108980,
								porcentaje: '',
							},
							{
								titulo: 'Anticipos/Diferidos - PC  ',
								monto: 94531,
								porcentaje: '',
							},
							{
								titulo: 'Activo circulante de operación - ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Activos derivados - PC -',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Activos circulantes no op ',
								monto: 150649,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL ACTIVO CIRCULANTE  ',
								monto: 6072273,
								porcentaje: '',
							},
							{
								titulo: 'ACTIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Terrenos  ',
								monto: 616600,
								porcentaje: '',
							},
							{
								titulo: 'Construcción en proceso  ',
								monto: 1556200,
								porcentaje: '',
							},
							{
								titulo: 'Edificios y mejoras  ',
								monto: 3024300,
								porcentaje: '',
							},
							{
								titulo: 'Maquinaria y equipo  ',
								monto: 8220100,
								porcentaje: '',
							},
							{
								titulo: 'Otros activos fijos  ',
								monto: 162400,
								porcentaje: '',
							},
							{
								titulo: 'Activo fijo bruto  ',
								monto: 13579600,
								porcentaje: '',
							},
							{
								titulo: 'Depreciación acumulada (-)  ',
								monto: 5701678,
								porcentaje: '',
							},
							
							{
								titulo: 'Total activo fijo - Neto ',
								monto: 7877922,
								porcentaje: '',
							},
							{
								titulo: 'Inversión en subsidiarias  ',
								monto: 121348,
								porcentaje: '',
							},
							
							{
								titulo: 'Efectivo restringido   ',
								monto: 36344,
								porcentaje: '',
							},
							{
								titulo: 'Otras inversiones  ',
								monto: 93064,
								porcentaje: '',
							},
							{
								titulo: 'Activo no circ operativos  ',
								monto: 158725,
								porcentaje: '',
							},
							{
								titulo: 'Impuestos recuperables diferidos - PLP  ',
								monto: 1276054,
								porcentaje: '',
							},
							{
								titulo: 'Fondo de comercio  ',
								monto: 123900,
								porcentaje: '',
							},
							{
								titulo: 'Intangibles - Otros  ',
								monto: 137722,
								porcentaje: '',
							},
							{
								titulo: 'Total intangibles - Netos  ',
								monto: 261622,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL ACTIVOS NO CIRC  ',
								monto: 9825079,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL ACTIVOS   ',
								monto: 15897352,
								porcentaje: '',
							},
							
					
						],
						pasivo: [
							{
								titulo: 'PASIVO CIRCULANTE',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Prést banc x pagar CP ',
								monto: 277396,
								porcentaje: '',
							},
							{
								titulo: 'PCDLP comercial - ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Proveedores (PC)  ',
								monto: 839563,
								porcentaje: '',
							},
							{
								titulo: 'Préstamos de emp rel - ',
								monto: 8338,
								porcentaje: '',
							},
							{
								titulo: 'Intereses x pagar - ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Impuestos x pagar  ',
								monto: 453692,
								porcentaje: '',
							},
							{
								titulo: 'Gasto x indemnización de retiro - PC - ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Pasivo circ operación - ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Pasivos derivados - PC  0,1 - ',
								monto: 15674,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL PASIVO CIRCULANTE  ',
								monto: 1594663,
								porcentaje: '',
							},
							{
								titulo: 'PASIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Deuda bancaria LP',
								monto: 3475459,
								porcentaje: '',
							},
							{
								titulo: 'DLP Bonos ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Gasto x indemnización de retiro - PLP',
								monto: 527276,
								porcentaje: '',
							},
							{
								titulo: 'Pasivo no circ operación -',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Provisiones diversas LP  ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Provisiones diversas LP  ',
								monto: 270922,
								porcentaje: '',
							},
							{
								titulo: 'Impuestos diferidos - PLP  ',
								monto: 1247029,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL PASIVOS NO CIRC  ',
								monto: 5520686,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL PASIVO ',
								monto: 711534944,
								porcentaje: '',
							},
							{
								titulo: 'CAPITAL CONTABLE',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Capital de interés minoritario  ',
								monto: 1494696,
								porcentaje: '',
							},
							{
								titulo: 'Acciones comunes  ',
								monto: 2003496,
								porcentaje: '',
							},
							{
								titulo: 'Capital exhibido  ',
								monto: 9043,
								porcentaje: '',
							},
							{
								titulo: 'Otras reservas  ',
								monto: 243306,
								porcentaje: '',
							},
							{
								titulo: 'Otro capital ',
								monto: -186231,
								porcentaje: '',
							},
							{
								titulo: 'Reserva Legal ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Resultados retenidos  ',
								monto: 5765211,
								porcentaje: '',
							},
							{
								titulo: 'Acciones propias (-) ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'TOTAL CAP CONTABLE  ',
								monto: 8782003,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL PASIVOS Y CAP CONTABLE ',
								monto: 15897352,
								porcentaje: '',
							},
						]
					},
					cuenta_resultados: [
						{
							titulo: 'Ventas nacionales ',
							monto: 10373068,
							porcentaje: null,
						},
						{
							titulo: 'Coste de ventas/Ingresos (-) ',
							monto: 4958858,
							porcentaje: null,
						},
						{
							titulo: 'Amortización Inmovilizado (-)  ',
							monto: 552838,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL COSTE DE VENTAS/INGRESOS  ',
							monto: 5511696,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO BRUTO  ',
							monto: 4861372,
							porcentaje: null,
						},
						{
							titulo: 'Gastos generales y administrativos (-) ',
							monto: 241492,
							porcentaje: null,
						},
						{
							titulo: 'RDO. NETO DE OPERACION   ',
							monto: 4619880,
							porcentaje: null,
						},
						{
							titulo: 'Gasto x interés (-)',
							monto: 29245,
							porcentaje: null,
						},
						{
							titulo: 'Ingreso x interés  ',
							monto: 28975,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) tipo de cambio  ',
							monto: 18413,
							porcentaje: null,
						},
						
						{
							titulo: 'Tot ingreso x interés(Gto)  ',
							monto: -245062,
							porcentaje: null,
						},
						{
							titulo: 'Ingresos de subs y asociaciones  ',
							monto: 10426,
							porcentaje: null,
						},
						{
							titulo: 'Gastos extraordinarios con caja ',
							monto: '',
							porcentaje: null,
						},
						{
							titulo: 'Resultados en derivados  ',
							monto: -1509,
							porcentaje: null,
						},
						{
							titulo: 'Otros gastos (-)',
							monto: 103907,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL OTROS (GTO) INGRESOS',
							monto: -340052,
							porcentaje: null,
						},
						{
							titulo: 'RDO. ANT IMPUESTOS',
							monto: 4279828,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos (-)',
							monto: 1313647,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos diferidos (-) ',
							monto: '',
							porcentaje: null,
						},
						{
							titulo: 'TOTAL GASTO X IMPTOS  ',
							monto: 1313647,
							porcentaje: null,
						},
						{
							titulo: 'TRESULTADO NETO  ',
							monto: 2966181,
							porcentaje: null,
						},
						{
							titulo: 'Rdo.antes impto e int (EBIT)  ',
							monto: 4526399,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes impto, int depr y amort (EBITDA)  ',
							monto: 5079237,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes int, depr y amort (EBIDA)  ',
							monto: 3765590,
							porcentaje: null,
						},
						
						
					],
				},
				{
					fecha: '31/12/2012',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2012,
					divisa: 'PESOS MEXICANOS',
					balance: {
						activo: [
							{
								titulo: 'Efectivo',
								monto: 247600,
								porcentaje: '',
							},
							{
								titulo: 'Depósitos a plazo  ',
								monto: 2911768,
								porcentaje: '',
							},
							{
								titulo: 'Inversiones en valores  ',
								monto: 1074148,
								porcentaje: '',
							},
							{
								titulo: 'Ctas/Notas x cobrar - Comerciales  ',
								monto: 1015600,
								porcentaje: '',
							},
							{
								titulo: 'Reserva para ctas incobrables (-)  -  ',
								monto: 6808,
								porcentaje: '',
							},
							{
								titulo: 'Tot ctas x cobrar-Netas  ',
								monto: 1008792,
								porcentaje: '',
							},
							{
								titulo: 'Ctas/Notas x cobrar -',
								monto: 601879,
								porcentaje: '',
							},
							{
								titulo: 'Materias primas  ',
								monto: 421600,
								porcentaje: '',
							},
							{
								titulo: 'Producción en proceso  ',
								monto: 420500,
								porcentaje: '',
							},
							{
								titulo: 'Producto terminado  ',
								monto: 157600,
								porcentaje: '',
							},
							{
								titulo: 'Depreciación de existencias (-) -',
								monto: 2100,
								porcentaje: '',
							},
							
							{
								titulo: 'Otro inventario  ',
								monto: 184109,
								porcentaje: '',
							},
							{
								titulo: 'Total inventario   ',
								monto: 1181709,
								porcentaje: '',
							},
							{
								titulo: 'Anticipos/Diferidos - PC  ',
								monto: 26648,
								porcentaje: '',
							},
							{
								titulo: 'Activo circulante de operación - ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Activos derivados - PC -',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Activos circulantes no op ',
								monto: 272032,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL ACTIVO CIRCULANTE  ',
								monto: 7324576,
								porcentaje: '',
							},
							{
								titulo: 'ACTIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Terrenos  ',
								monto: 622700,
								porcentaje: '',
							},
							{
								titulo: 'Construcción en proceso  ',
								monto: 2221900,
								porcentaje: '',
							},
							{
								titulo: 'Edificios y mejoras  ',
								monto: 3128200,
								porcentaje: '',
							},
							{
								titulo: 'Maquinaria y equipo  ',
								monto: 9715700,
								porcentaje: '',
							},
							{
								titulo: 'Otros activos fijos  ',
								monto: 143700,
								porcentaje: '',
							},
							{
								titulo: 'Activo fijo bruto  ',
								monto: 15832200,
								porcentaje: '',
							},
							{
								titulo: 'Depreciación acumulada (-)  ',
								monto: 6390822,
								porcentaje: '',
							},
							
							{
								titulo: 'Total activo fijo - Neto ',
								monto: 9441378,
								porcentaje: '',
							},
							{
								titulo: 'Inversión en subsidiarias  ',
								monto: 109479,
								porcentaje: '',
							},
							
							{
								titulo: 'Efectivo restringido   ',
								monto: 443354,
								porcentaje: '',
							},
							{
								titulo: 'Otras inversiones  ',
								monto: 377960,
								porcentaje: '',
							},
							{
								titulo: 'Activo no circ operativos  ',
								monto: 163601,
								porcentaje: '',
							},
							{
								titulo: 'Impuestos recuperables diferidos - PLP  ',
								monto: 1312277,
								porcentaje: '',
							},
							{
								titulo: 'Fondo de comercio  ',
								monto: 127400,
								porcentaje: '',
							},
							{
								titulo: 'Intangibles - Otros  ',
								monto: 187960,
								porcentaje: '',
							},
							{
								titulo: 'Total intangibles - Netos  ',
								monto: 315360,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL ACTIVOS NO CIRC  ',
								monto: 12163409,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL ACTIVOS   ',
								monto: 19487985,
								porcentaje: '',
							},
							
					
						],
						pasivo: [
							{
								titulo: 'PASIVO CIRCULANTE',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Prést banc x pagar CP ',
								monto: 108421,
								porcentaje: '',
							},
							{
								titulo: 'PCDLP comercial - ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Proveedores (PC)  ',
								monto: 980616,
								porcentaje: '',
							},
							{
								titulo: 'Préstamos de emp rel - ',
								monto: 10047,
								porcentaje: '',
							},
							{
								titulo: 'Intereses x pagar - ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Impuestos x pagar  ',
								monto: 436890,
								porcentaje: '',
							},
							{
								titulo: 'Gasto x indemnización de retiro - PC - ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Pasivo circ operación - ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Pasivos derivados - PC  0,1 - ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'TOTAL PASIVO CIRCULANTE  ',
								monto: 1535974,
								porcentaje: '',
							},
							{
								titulo: 'PASIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Deuda bancaria LP',
								monto: 1009953,
								porcentaje: '',
							},
							{
								titulo: 'DLP Bonos ',
								monto: 44347273,
								porcentaje: '',
							},
							{
								titulo: 'Gasto x indemnización de retiro - PLP',
								monto: 545759000,
								porcentaje: '',
							},
							{
								titulo: 'Pasivo no circ operación -',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Provisiones diversas LP  ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Provisiones diversas LP  ',
								monto: 239551,
								porcentaje: '',
							},
							{
								titulo: 'Impuestos diferidos - PLP  ',
								monto: 1543441,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL PASIVOS NO CIRC  ',
								monto: 7772977,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL PASIVO ',
								monto: 30895147.8,
								porcentaje: '',
							},
							{
								titulo: 'CAPITAL CONTABLE',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Capital de interés minoritario  ',
								monto: 1813535,
								porcentaje: '',
							},
							{
								titulo: 'Acciones comunes  ',
								monto: 2003496,
								porcentaje: '',
							},
							{
								titulo: 'Capital exhibido  ',
								monto: 9043,
								porcentaje: '',
							},
							{
								titulo: 'Otras reservas  ',
								monto: 243306,
								porcentaje: '',
							},
							{
								titulo: 'Otro capital ',
								monto: -229119,
								porcentaje: '',
							},
							{
								titulo: 'Reserva Legal ',
								monto: 30800,
								porcentaje: '',
							},
							{
								titulo: 'Resultados retenidos  ',
								monto: 6850104,
								porcentaje: '',
							},
							{
								titulo: 'Acciones propias (-) ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'TOTAL CAP CONTABLE  ',
								monto: 10179034,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL PASIVOS Y CAP CONTABLE ',
								monto: 19487985,
								porcentaje: '',
							},
						]
					},
					cuenta_resultados: [
						{
							titulo: 'Ventas nacionales ',
							monto: 10182920,
							porcentaje: null,
						},
						{
							titulo: 'Coste de ventas/Ingresos (-) ',
							monto: 4894386,
							porcentaje: null,
						},
						{
							titulo: 'Amortización Inmovilizado (-)  ',
							monto: 612559,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL COSTE DE VENTAS/INGRESOS  ',
							monto: 5506945,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO BRUTO  ',
							monto: 4675975,
							porcentaje: null,
						},
						{
							titulo: 'Gastos generales y administrativos (-) ',
							monto: 267747,
							porcentaje: null,
						},
						{
							titulo: 'RDO. NETO DE OPERACION   ',
							monto: 4408228,
							porcentaje: null,
						},
						{
							titulo: 'Gasto x interés (-)',
							monto: 273308,
							porcentaje: null,
						},
						{
							titulo: 'Ingreso x interés  ',
							monto: 45431,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) tipo de cambio  ',
							monto: 14330,
							porcentaje: null,
						},
						{
							titulo: 'Tot ingreso x interés(Gto)  ',
							monto: -213547,
							porcentaje: null,
						},
					
						{
							titulo: 'Ingresos de subs y asociaciones  ',
							monto: 54754,
							porcentaje: null,
						},
						{
							titulo: 'Gastos extraordinarios con caja ',
							monto: 316233,
							porcentaje: null,
						},
						{
							titulo: 'Resultados en derivados  ',
							monto: '',
							porcentaje: null,
						},
						{
							titulo: 'Otros gastos (-)',
							monto: -331495,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL OTROS (GTO) INGRESOS',
							monto: -143531,
							porcentaje: null,
						},
						{
							titulo: 'RDO. ANT IMPUESTOS',
							monto: 4264697,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos (-)',
							monto: 1286633,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos diferidos (-) ',
							monto: '',
							porcentaje: null,
						},
						{
							titulo: 'TOTAL GASTO X IMPTOS  ',
							monto: 1286633,
							porcentaje: null,
						},
						{
							titulo: 'TRESULTADO NETO  ',
							monto: 2978064,
							porcentaje: null,
						},
						{
							titulo: 'Rdo.antes impto e int (EBIT)  ',
							monto: 4794477,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes impto, int depr y amort (EBITDA)  ',
							monto: 5723269,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes int, depr y amort (EBIDA)  ',
							monto: 4436636,
							porcentaje: null,
						},
						
						
					],
				},
				{
					fecha: '31/12/2013',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2013,
					divisa: 'PESOS MEXICANOS',
					balance: {
						activo: [
							{
								titulo: 'Efectivo',
								monto: 2435947,
								porcentaje: '',
							},
							{
								titulo: 'Depósitos a plazo  ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Inversiones en valores  ',
								monto: 1049858,
								porcentaje: '',
							},
							{
								titulo: 'Ctas/Notas x cobrar - Comerciales  ',
								monto: 948084,
								porcentaje: '',
							},
							{
								titulo: 'Reserva para ctas incobrables (-)  -  ',
								monto: 19168,
								porcentaje: '',
							},
							{
								titulo: 'Tot ctas x cobrar-Netas  ',
								monto: 928916,
								porcentaje: '',
							},
							{
								titulo: 'Ctas/Notas x cobrar -',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Materias primas  ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Producción en proceso  ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Producto terminado  ',
								monto: 117002,
								porcentaje: '',
							},
							{
								titulo: 'Depreciación de existencias (-) -',
								monto: '',
								porcentaje: '',
							},
							
							{
								titulo: 'Otro inventario  ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Total inventario   ',
								monto: 1170702,
								porcentaje: '',
							},
							{
								titulo: 'Anticipos/Diferidos - PC  ',
								monto: 19331,
								porcentaje: '',
							},
							{
								titulo: 'Activo circulante de operación - ',
								monto: 181917,
								porcentaje: '',
							},
							{
								titulo: 'Activos derivados - PC -',
								monto: 6000,
								porcentaje: '',
							},
							{
								titulo: 'Activos circulantes no op ',
								monto: 206959,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL ACTIVO CIRCULANTE  ',
								monto: 5993636,
								porcentaje: '',
							},
							{
								titulo: 'ACTIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Terrenos  ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Construcción en proceso  ',
								monto: 3508875,
								porcentaje: '',
							},
							{
								titulo: 'Edificios y mejoras  ',
								monto: 3598464,
								porcentaje: '',
							},
							{
								titulo: 'Maquinaria y equipo  ',
								monto: 11410855,
								porcentaje: '',
							},
							{
								titulo: 'Otros activos fijos  ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Activo fijo bruto  ',
								monto: 18518194,
								porcentaje: '',
							},
							{
								titulo: 'Depreciación acumulada (-)  ',
								monto: 6960375,
								porcentaje: '',
							},
							
							{
								titulo: 'Total activo fijo - Neto ',
								monto: 11557819,
								porcentaje: '',
							},
							{
								titulo: 'Inversión en subsidiarias  ',
								monto: 271652,
								porcentaje: '',
							},
							
							{
								titulo: 'Efectivo restringido   ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Otras inversiones  ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Activo no circ operativos  ',
								monto: 971369,
								porcentaje: '',
							},
							{
								titulo: 'Impuestos recuperables diferidos - PLP  ',
								monto: 707708,
								porcentaje: '',
							},
							{
								titulo: 'Fondo de comercio  ',
								monto: 549953,
								porcentaje: '',
							},
							{
								titulo: 'Intangibles - Otros  ',
								monto: 155865,
								porcentaje: '',
							},
							{
								titulo: 'Total intangibles - Netos  ',
								monto: 705818,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL ACTIVOS NO CIRC  ',
								monto: 14214366,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL ACTIVOS   ',
								monto: 20208002,
								porcentaje: '',
							},
							
					
						],
						pasivo: [
							{
								titulo: 'PASIVO CIRCULANTE',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Prést banc x pagar CP ',
								monto: 289656,
								porcentaje: '',
							},
							{
								titulo: 'PCDLP comercial - ',
								monto: 76473,
								porcentaje: '',
							},
							{
								titulo: 'Proveedores (PC)  ',
								monto: 525765,
								porcentaje: '',
							},
							{
								titulo: 'Préstamos de emp rel - ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Intereses x pagar - ',
								monto: 80578,
								porcentaje: '',
							},
							{
								titulo: 'Impuestos x pagar  ',
								monto: 34099,
								porcentaje: '',
							},
							{
								titulo: 'Gasto x indemnización de retiro - PC - ',
								monto: 219662,
								porcentaje: '',
							},
							{
								titulo: 'Pasivo circ operación - ',
								monto: 381768,
								porcentaje: '',
							},
							{
								titulo: 'Pasivos derivados - PC  0,1 - ',
								monto: 837000,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL PASIVO CIRCULANTE  ',
								monto: 1608838,
								porcentaje: '',
							},
							{
								titulo: 'PASIVOS NO CIRCULANTES',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Deuda bancaria LP',
								monto: 1058261,
								porcentaje: '',
							},
							{
								titulo: 'DLP Bonos ',
								monto: 4356298,
								porcentaje: '',
							},
							{
								titulo: 'Gasto x indemnización de retiro - PLP',
								monto: 339656,
								porcentaje: '',
							},
							{
								titulo: 'Pasivo no circ operación -',
								monto: 420628,
								porcentaje: '',
							},
							{
								titulo: 'Provisiones diversas LP  ',
								monto: 438053,
								porcentaje: '',
							},
						
							{
								titulo: 'Impuestos diferidos - PLP  ',
								monto: 306912,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL PASIVOS NO CIRC  ',
								monto: 6919808,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL PASIVO ',
								monto: 8528646,
								porcentaje: '',
							},
							{
								titulo: 'CAPITAL CONTABLE',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'Capital de interés minoritario  ',
								monto: 2038962,
								porcentaje: '',
							},
							{
								titulo: 'Acciones comunes  ',
								monto: 2003496,
								porcentaje: '',
							},
							{
								titulo: 'Capital exhibido  ',
								monto: 9043,
								porcentaje: '',
							},
							{
								titulo: 'Otras reservas  ',
								monto: 243306,
								porcentaje: '',
							},
							{
								titulo: 'Otro capital ',
								monto: -840034,
								porcentaje: '',
							},
							{
								titulo: 'Reserva Legal ',
								monto: 30800,
								porcentaje: '',
							},
							{
								titulo: 'Resultados retenidos  ',
								monto: 8193783,
								porcentaje: '',
							},
							{
								titulo: 'Acciones propias (-) ',
								monto: '',
								porcentaje: '',
							},
							{
								titulo: 'TOTAL CAP CONTABLE  ',
								monto: 11679356,
								porcentaje: '',
							},
							{
								titulo: 'TOTAL PASIVOS Y CAP CONTABLE ',
								monto: 20208002,
								porcentaje: '',
							},
						]
					},
					cuenta_resultados: [
						{
							titulo: 'Ventas nacionales ',
							monto: 9352792,
							porcentaje: null,
						},
						{
							titulo: 'Coste de ventas/Ingresos (-) ',
							monto: 5081499,
							porcentaje: null,
						},
						{
							titulo: 'Amortización Inmovilizado (-)  ',
							monto: 716271,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL COSTE DE VENTAS/INGRESOS  ',
							monto: 5797770,
							porcentaje: null,
						},
						{
							titulo: 'RESULTADO BRUTO  ',
							monto: 3555022,
							porcentaje: null,
						},
						{
							titulo: 'Gastos generales y administrativos (-) ',
							monto: 273663,
							porcentaje: null,
						},
						{
							titulo: 'RDO. NETO DE OPERACION   ',
							monto: 3281359,
							porcentaje: null,
						},
						{
							titulo: 'Gasto x interés (-)',
							monto: 286567,
							porcentaje: null,
						},
						{
							titulo: 'Ingreso x interés  ',
							monto: 49851,
							porcentaje: null,
						},
						{
							titulo: 'Ganancia (Pérdida) tipo de cambio  ',
							monto: -3629,
							porcentaje: null,
						},
						{
							titulo: 'Tot ingreso x interés(Gto)  ',
							monto: -240345,
							porcentaje: null,
						},
					
						{
							titulo: 'Ingresos de subs y asociaciones  ',
							monto: 27290,
							porcentaje: null,
						},
						{
							titulo: 'Gastos extraordinarios con caja ',
							monto: '',
							porcentaje: null,
						},
						{
							titulo: 'Resultados en derivados  ',
							monto: '',
							porcentaje: null,
						},
						{
							titulo: 'Otros gastos (-)',
							monto: -29794,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL OTROS (GTO) INGRESOS',
							monto: -183261,
							porcentaje: null,
						},
						{
							titulo: 'RDO. ANT IMPUESTOS',
							monto: 3098098,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos (-)',
							monto: 1003356,
							porcentaje: null,
						},
						{
							titulo: 'Impuestos diferidos (-) ',
							monto: -130489,
							porcentaje: null,
						},
						{
							titulo: 'TOTAL GASTO X IMPTOS  ',
							monto: 872867,
							porcentaje: null,
						},
						{
							titulo: 'TRESULTADO NETO  ',
							monto: 2225231,
							porcentaje: null,
						},
						{
							titulo: 'Rdo.antes impto e int (EBIT)  ',
							monto: 3338443,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes impto, int depr y amort (EBITDA)  ',
							monto: 4054714,
							porcentaje: null,
						},
						{
							titulo: 'Rdo. antes int, depr y amort (EBIDA)  ',
							monto: 3181847,
							porcentaje: null,
						},
						
						
					],
				},
				
			],
			buro: [
				{
					buro_de_credito: 'Metales Internacionales SAB',
					fecha: '12/03/2014',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '0',
					dls_val: '',
					udis_val: '',
					total: '0',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
				{
					buro_de_credito: 'Infraestructura y Transportes Nacionales SA de CV',
					fecha: '12/03/2014',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '0',
					dls_val: '',
					udis_val: '',
					total: '0',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
				{
					buro_de_credito: 'Proyectos y Desarrollos Nacionales SA de CV',
					fecha: '12/03/2014',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '378,000',
					dls_val: '',
					udis_val: '',
					total: '378,000',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
				{
					buro_de_credito: 'Nations Minig Corporation',
					fecha: '12/03/2014',
					clave_de_prevencion: '',
					no_bancos: '',
					mn: '0',
					dls_val: '85,000',
					udis_val: '',
					total: '1,143,250',
					hasta_30_d: '0',
					hasta_90_d: '0',
					mas_90_d: '0',
				},
			],
			rating: [
				// {
				// 	ano: 2013,
				// 	score: 4.61,
				// 	escala_maestra: 'BBB+',
				// 	escala_larga: 'BBB+2',
				// },
				// {
				// 	ano: 2012,
				// 	score: 4.48,
				// 	escala_maestra: 'BBB+',
				// 	escala_larga: 'BBB+1',
				// },
				{
					ano: 2013,
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: 2012,
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
			],
			rating_local: [
				{
					nombre: 'Metales Internacionales',
					fecha: '31-12-2013',
					puntuacion_cuantitativa: 2.00,
					puntuacion_cualitativa: 2.61,
					puntuacion_tital: 4.61,
					escala_actual: 'BBB+2',
					escala_anterior: 'BBB+1'
				},
				{
					nombre: 'Infraestructura y Transportes Nacionales SA de CV',
					fecha: '31-12-2013',
					puntuacion_cuantitativa: 1.36,
					puntuacion_cualitativa: 3.58,
					puntuacion_tital: 4.94,
					escala_actual: 'BBB1',
					escala_anterior: 'BBB2'
				},
				{
					nombre: 'Proyectos y Desarrollos Nacionales SA de CV',
					fecha: '31-12-2013',
					puntuacion_cuantitativa: 3.33,
					puntuacion_cualitativa: 4.33,
					puntuacion_tital: 7.66,
					escala_actual: 'B2',
					escala_anterior: 'B2'
				},
				{
					nombre: 'Nations Mining Corp SA',
					fecha: '31-12-2013',
					puntuacion_cuantitativa: 1.99,
					puntuacion_cualitativa: 2.50,
					puntuacion_tital: 4.49,
					escala_actual: 'BBB+1',
					escala_anterior: 'BBB+1'
				},
			],
			cash_flow: [
				{
					ano: 2012,
					datos: [
						{
							titulo: 'Generación Interna de fondos',
							monto: 0,
						},
						{
							titulo: 'Capital circulante',
							monto: 0,
						},
						{
							titulo: 'Cash flow operativo',
							monto: 0,
						},
						{
							titulo: 'Capex',
							monto: 0,
						},
						{
							titulo: 'Inversiones / desinversiones',
							monto: 0,
						},
						{
							titulo: 'Otros (Dividendos de participadas)',
							monto: 0,
						},
						{
							titulo: 'Cash flow de Inversión',
							monto: 0,
						},
						{
							titulo: 'Variación neta deuda financiera',
							monto: 0,
						},
						{
							titulo: 'Ampliaciones capital (dividendos)',
							monto: 0,
						},
						{
							titulo: 'Dividendos / shares buy back',
							monto: 0,
						},
						{
							titulo: 'Otros',
							monto: null,
						},
						{
							titulo: 'Cash flow de financiación',
							monto: 0,
						},
						{
							titulo: 'Variación en la tesorería',
							monto: 0,
						},
					]
				},
				{
					ano: 2013,
					datos: [
						{
							titulo: 'Generación Interna de fondos',
							monto: 2225231,
						},
						{
							titulo: 'Capital circulante',
							monto: 0,
						},
						{
							titulo: 'Cash flow operativo',
							monto: 2825226,
						},
						{
							titulo: 'Capex',
							monto: 0,
						},
						{
							titulo: 'Inversiones / desinversiones',
							monto: -2116441,
						},
						{
							titulo: 'Otros (Dividendos de participadas)',
							monto: 2038962,
						},
						{
							titulo: 'Cash flow de Inversión',
							monto: -1674692,
						},
						{
							titulo: 'Variación neta deuda financiera',
							monto: 181235,
						},
						{
							titulo: 'Ampliaciones capital (dividendos)',
							monto: 0,
						},
						{
							titulo: 'Dividendos / shares buy back',
							monto: 0,
						},
						{
							titulo: 'Otros',
							monto: 0,
						},
						{
							titulo: 'Cash flow de financiación',
							monto: 652774,
						},
						{
							titulo: 'Variación en la tesorería',
							monto: 2188347,
						},
					]
				}

			],
			magnitudes_y_ratios: [
				{
					ano: 2011,
					datos: [
						{
							titulo: 'Fondo de Maniobra',
							monto: 4477610,
						},
						{
							titulo: 'Deuda financiera total',
							monto: 3752855,
						},
						{
							titulo: 'Deuda financiera neta',
							monto: 3723610,
						},
						{
							titulo: 'Cash Flow  Discrecional',
							monto: null,
						},
						{
							titulo: 'Deuda financiera total/Patrimonio neto (x)',
							monto: 0.427334744,
						},
						{
							titulo: 'Cobertura de intereses con EBITDA (x)',
							monto: 15630,
						},
						{
							titulo: 'Pay-back neto (n° años)',
							monto: 0.74,
						},
						{
							titulo: 'GIF/Deuda financiera Neta (%)',
							monto: 0,
						},
						{
							titulo: 'Retorno sobre el Patrimonio Neto (%)',
							monto: 33780,
						},
						{
							titulo: 'Deuda financiera neta/EBITDA (x)',
							monto: 0.7331042,
						},
					]
				},
				{
					ano: 2012,
					datos: [
						{
							titulo: 'Fondo de Maniobra',
							monto: 5788602,
						},
						{
							titulo: 'Deuda financiera total',
							monto: 1118374,
						},
						{
							titulo: 'Deuda financiera neta',
							monto: 845066,
						},
						{
							titulo: 'Cash Flow  Discrecional',
							monto: null,
						},
						{
							titulo: 'Deuda financiera total/Patrimonio neto (x)',
							monto: 0.10987035,
						},
						{
							titulo: 'Cobertura de intereses con EBITDA (x)',
							monto: 16600,
						},
						{
							titulo: 'Pay-back neto (n° años)',
							monto: 0.97,
						},
						{
							titulo: 'GIF/Deuda financiera Neta (%)',
							monto: 0,
						},
						{
							titulo: 'Retorno sobre el Patrimonio Neto (%)',
							monto: 29260,
						},
						{
							titulo: 'Deuda financiera neta/EBITDA (x)',
							monto: 0.14765443,
						},
					]
				},
				{
					ano: 2013,
					datos: [
						{
							titulo: 'Fondo de Maniobra',
							monto: 4384798,
						},
						{
							titulo: 'Deuda financiera total',
							monto: 1347917,
						},
						{
							titulo: 'Deuda financiera neta',
							monto: 1061350,
						},
						{
							titulo: 'Cash Flow  Discrecional',
							monto: null,
						},
						{
							titulo: 'Deuda financiera total/Patrimonio neto (x)',
							monto: 0.1151022,
						},
						{
							titulo: 'Cobertura de intereses con EBITDA (x)',
							monto: 18810,
						},
						{
							titulo: 'Pay-back neto (n° años)',
							monto: 1430,
						},
						{
							titulo: 'GIF/Deuda financiera Neta (%)',
							monto: 2.09660432,
						},
						{
							titulo: 'Retorno sobre el Patrimonio Neto (%)',
							monto: 19.05,
						},
						{
							titulo: 'Deuda financiera neta/EBITDA (x)',
							monto: 0.26175706,
						},
					]
				},
				
			],
			politicas: [
				{
					negritas: false,
					nombre: 'RIESGO FINANCIERO L/P SIN GARANTIAS REALES',
					limite_anterior: '250',
					limite_actual: '0',
					dispuesto: '0',
					propuesto: '250',
					limite_nuevo: '',
					notas: '(1)',
				},
				{
					negritas: false,
					nombre: 'RIESGO FINANCIERO L/P CON GARANTIAS REALES',
					limite_anterior: '450',
					limite_actual: '351.7',
					dispuesto: '302.5',
					propuesto: '550',
					limite_nuevo: '',
					notas: '(2)',
				},
				{
					negritas: false,
					nombre: 'RIESGO FINANCIERO C/P',
					limite_anterior: '500',
					limite_actual: '307.5',
					dispuesto: '307.5',
					propuesto: '600',
					limite_nuevo: '',
					notas: '(3)',
				},
				{
					negritas: false,
					nombre: 'RIESGO DE FIRMA',
					limite_anterior: '100',
					limite_actual: '47.3',
					dispuesto: '47.3',
					propuesto: '100',
					limite_nuevo: '',
					notas: '(4)',
				},
				{
					negritas: false,
					nombre: 'RIESGO DE TESORERÍA',
					limite_anterior: '100',
					limite_actual: '5',
					dispuesto: '0.741',
					propuesto: '100',
					limite_nuevo: '',
					notas: '(5)',
				},
				{
					negritas: false,
					nombre: 'TOTAL RIESGO CORPORATIVO',
					limite_anterior: '850',
					limite_actual: '712',
					dispuesto: '658',
					propuesto: '950',
					limite_nuevo: '',
					notas: '',
				},
				{
					negritas: false,
					nombre: 'FINANCIACION ESPECIALIZADA',
					limite_anterior: '',
					limite_actual: '',
					dispuesto: '',
					propuesto: '',
					limite_nuevo: '',
					notas: '',
				},
				{
					negritas: false,
					nombre: 'OTROS',
					limite_anterior: '',
					limite_actual: '',
					dispuesto: '',
					propuesto: '',
					limite_nuevo: '',
					notas: '',
				},
				{
					negritas: false,
					nombre: 'TOTAL GRUPO',
					limite_anterior: '850',
					limite_actual: '712',
					dispuesto: '658',
					propuesto: '950',
					limite_nuevo: '',
					notas: '',
				},
				
			],
			
		},

		{
			id: 6, 
			posiciones_actuales: '',
			parent: 1,
			nombre: 'Agrotecama SA de CV',
			tipo: 'Filial',
			fecha_constitucion: '1994',
			actividad_principal: 'Compraventa de aparatos eléctricos',
			cliente_desde: '2003',
			pais_cabecera: 'México',
			rfc: 'CAN940705AM7',
			cuenta_clave: 'NO',
			examen: false,
			codigo: null,
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2019',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2019,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
					
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2020',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2020,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
					
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
			],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						1.370934796,
						1.327064525,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.93,
						0.65,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.01,
						0.05,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2019,
						2020,
					],
					datos: [
						0,
						0,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2019,
						2020,
					],
					datos: [
						36.84,
						28.46
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2019,
						2020,
					],
					datos: [
						13.76,
						12.97
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2019,
						2020,
					],
					datos: [
						34.67,
						29.45
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2019,
						2020,
					],
					datos: [
						15.93,
						11.98
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2019,
						2020,
					],
					datos: [
						2.98440033,
						3.33037575,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.00399233,
						0.00985952,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2019,
						2020,
					],
					datos: [
						44.86185567,
						0.147389969,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2019,
						2020,
					],
					datos: [
						44.86,
						0.15,
					]
				},
				{
					titulo: 'Margen Neto',
					formula: 'Utilidad Neta/Ventas',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.072378058,
						0.013010605,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.130561478,
						0.013371412,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.389647718,
						0.044531828,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2019,
						2020,
					],
					datos: [
						1,
						1,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.66492431,
						0.699733581,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.002213187,
						0.00959348,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2019,
						2020,
					],
					datos: [
						44.86185567,
						0.147389969,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2019,
						2020,
					],
					datos: [
						29963,
						22678,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2019,
						2020,
					],
					datos: [
						18261.75,
						8486.67,
					]
				},
				
			]
		},
		{
			id: 7, 
			posiciones_actuales: '',
			parent: 1,
			nombre: 'Servicio Sujuxi SA de CV',
			tipo: 'Filial',
			fecha_constitucion: '1994',
			actividad_principal: 'Compraventa de aparatos eléctricos',
			cliente_desde: '2003',
			pais_cabecera: 'México',
			rfc: 'CAN940705AM7',
			cuenta_clave: 'NO',
			examen: false,
			codigo: null,
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2019',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2019,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
					
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2020',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2020,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
					
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
			],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						1.172708789,
						1.077225867,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.97,
						0.95,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.04,
						0.03,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2019,
						2020,
					],
					datos: [
						15.89387508,
						20.03155127,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2019,
						2020,
					],
					datos: [
						54.47,
						55.93
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2019,
						2020,
					],
					datos: [
						40.22,
						36.67
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2019,
						2020,
					],
					datos: [
						43.26,
						44.03
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2019,
						2020,
					],
					datos: [
						51.43,
						48.57
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2019,
						2020,
					],
					datos: [
						2.82527214,
						2.827606711,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.033801425,
						0.030431387,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.688517745,
						0.563178677,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.19,
						0.13,
					]
				},
				{
					titulo: 'Margen Neto',
					formula: 'Utilidad Neta/Ventas',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.007035531,
						0.002852408,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.026109661,
						0.00630858,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.073766897,
						0.017838182,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2019,
						2020,
					],
					datos: [
						1,
						1,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.367892174,
						0.400669911,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.009108161,
						0.013759474,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.688517745,
						0.563178677,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2019,
						2020,
					],
					datos: [
						4502,
					   	2060,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2019,
						2020,
					],
					datos: [
						21912.58,
						12270.33,
					]
				},
				
			]
		},
		{
			id: 8, 
			posiciones_actuales: '',
			parent: 3,
			nombre: 'Embotelladora del Sureste SA de CV',
			tipo: 'Filial',
			fecha_constitucion: '1960',
			actividad_principal: 'minería, el transporte y la infraestructura.',
			cliente_desde: '1988',
			pais_cabecera: 'México',
			rfc: 'MIN991906-AR4',
			cuenta_clave: 'NO',
			examen: true,
			codigo: 'examen3',
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2013',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2013,
					divisa: 'PESOS MEXICANOS',
					balance: null,
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							monto: null,
							porcentaje: 13,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							monto: null,
							porcentaje: 0.33,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							monto: null,
							porcentaje: 7,
							base: 0,
						},
						{
							titulo: 'Caja',
							monto: null,
							porcentaje: 2,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							monto: null,
							base: 9,
							porcentaje: 5,
						},
						{
							titulo: 'Activos Circulantes',
							monto: null,
							porcentaje: 23,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							monto: null,
							porcentaje: 54,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							monto:  null,
							porcentaje: 6,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							monto:  null,
							porcentaje: 5,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							monto:  null,
							porcentaje: 21,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							monto:  null,
							porcentaje: 5,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							monto:  null,
							porcentaje: 36,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							monto:  null,
							porcentaje: 64,
							base: 16,
						},
						{
							titulo: 'Total',
							monto:  null,
							porcentaje: 100,
							base: 16,
						},
						
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2014',
					datos_en: 'Miles',
					divisa: 'PESOS MEXICANOS',
					estado: 'CONSOLIDATED',
					ano: 2014,
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							monto: null,
							porcentaje: 13,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							monto: null,
							porcentaje: 1,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							monto: null,
							porcentaje: 6,
							base: 0,
						},
						{
							titulo: 'Caja',
							monto: null,
							porcentaje: 2,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							monto: null,
							porcentaje: 5,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							monto: null,
							porcentaje: 25,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							monto: null,
							porcentaje: 57,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							monto: null,
							porcentaje: 5,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							monto: null,
							porcentaje: 7,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							monto: null,
							porcentaje: 22,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							monto: null,
							porcentaje: 5,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							monto: null,
							porcentaje: 36,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							monto: null,
							porcentaje: 64,
							base: 16,
						},
						{
							titulo: 'Total',
							monto: null,
							porcentaje: 100,
							base: 16,
						},
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				
			],
			buro: [],
			rating: [

				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2013,
						2014,
					],
					datos: [
						1.122087019,
						1.138140579
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.93,
						0.65
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.11,
						0.10
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.654346359,
						0.646502734
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2013,
						2014,
					],
					datos: [
						36.84,
						28.46
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2013,
						2014,
					],
					datos: [
						13.76,
						12.97
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2013,
						2014,
					],
					datos: [
						34.67,
						29.45
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2013,
						2014,
					],
					datos: [
						15.93,
						11.98
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.569349854,
						0.568082452,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.011794772,
						0.017183978,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2013,
						2014,
					],
					datos: [
						40.9164325,
						25.20151124,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2013,
						2014,
					],
					datos: [
						2.69,
						2.74,
					]
				},
				{
					titulo: 'Utilidad Neta/Ventas',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.073398516,
						0.058850176,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.095834615,
						0.071935294,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.150398039,
						0.112800472,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.362793454,
						0.362278432,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.573794062,
						0.602518065,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.003277283,
						0.00509298,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2013,
						2014,
					],
					datos: [
						40.9164325,
						25.20151124,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2013,
						2014,
					],
					datos: [
						194453,
						249353,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2013,
						2014,
					],
					datos: [
						832498.67,
						842352.33,
					]
				},
				
			]
		},
		{
			id: 9, 
			posiciones_actuales: '',
			parent: 3,
			nombre: 'Sureste Industrial SA de CV',
			tipo: 'Filial',
			fecha_constitucion: '1960',
			actividad_principal: 'minería, el transporte y la infraestructura.',
			cliente_desde: '1988',
			pais_cabecera: 'México',
			rfc: 'MIN991906-AR4',
			cuenta_clave: 'NO',
			examen: true,
			codigo: 'examen3',
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2013',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2013,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 3292309,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 240221,
							monto: null,
							porcentaje: 7,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 28012,
							monto: null,
							porcentaje: 1,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 20484,
							monto: null,
							porcentaje: 1,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 77548,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 351988,
							monto: null,
							porcentaje: 11,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 1359917,
							monto: null,
							porcentaje: 44,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 1570070,
							monto: null,
							porcentaje: 51,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 24498,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 3101001,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  60730,
							monto: null,
							porcentaje: 2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  359711,
							monto: null,
							porcentaje: 12,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  817648,
							monto: null,
							porcentaje: 26,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  9101,
							monto: null,
							porcentaje: 0,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  956459,
							monto: null,
							porcentaje: 31,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  2144542,
							monto: null,
							porcentaje: 64,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto:  3101001,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  69831,
						// 	porcentaje: null,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  0,
						// 	porcentaje: null,
						// },
						// {
						// 	titulo: 'Deuda Total / EBITDA',
						// 	monto:  0.29,
						// 	porcentaje: null,
						// },
						// {
						// 	titulo: 'Deuda Neta / EBITDA',
						// 	monto:  0,
						// 	porcentaje: null,
						// },
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2014',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2014,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 3117800,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 321941,
							monto: null,
							porcentaje: '',
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 31868,
							monto: null,
							porcentaje: 1,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 107279,
							monto: null,
							porcentaje: 3,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 116415,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 432881,
							monto: null,
							base: 9,
							porcentaje: 13,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 1566272,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 1617020,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 29406,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 3371838,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  68086,
							monto: null,
							porcentaje: 2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  391433,
							monto: null,
							porcentaje: 12,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  766527,
							monto: null,
							porcentaje: 23,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  37105,
							monto: null,
							porcentaje: 0,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  1029958,
							monto: null,
							porcentaje: 31,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  2341880,
							monto: null,
							porcentaje: 69,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto:  3371838,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  105191,
						// 	porcentaje: null,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  0,
						// 	porcentaje: null,
						// },
						// {
						// 	titulo: 'Deuda Total / EBITDA',
						// 	monto:  0.33,
						// 	porcentaje: null,
						// },
						// {
						// 	titulo: 'Deuda Neta / EBITDA',
						// 	monto:  0,
						// 	porcentaje: null,
						// },
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
			],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2013,
						2014,
					],
					datos: [
						1.663205927,
						2.043335721,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.97,
						0.95,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.09,
						0.15,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.290694819,
						0.326739993,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2013,
						2014,
					],
					datos: [
						54.47,
						55.93
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2013,
						2014,
					],
					datos: [
						40.22,
						36.67,
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2013,
						2014,
					],
					datos: [
						43.26,
						44.03,
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2013,
						2014,
					],
					datos: [
						51.43,
						48.57
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.445996861,
						0.439799648,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.029287194,
						0.030941067,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2013,
						2014,
					],
					datos: [
						8.575646152,
						10.10232835,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2013,
						2014,
					],
					datos: [
						2.71,
						3.22,
					]
				},
				{
					titulo: 'Utilidad Neta/Ventas',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.006221773,
						0.034408557,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.006605609,
						0.031816179,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.00955169,
						0.045808923,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.308435566,
						0.305458922,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.85486989,
						0.744231318,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.008508314,
						0.01022131,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2013,
						2014,
					],
					datos: [
						8.575646152,
						10.10232835,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2013,
						2014,
					],
					datos: [
						542269,
						799745,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2013,
						2014,
					],
					datos: [
						274359.08,
						259816.67,
					]
				},
				
			]
			
		},
		{
			id: 10, 
			posiciones_actuales: '',
			parent: 3,
			nombre: 'Grupo Financiero del Sureste SA de CV',
			tipo: 'Filial',
			fecha_constitucion: '1960',
			actividad_principal: 'minería, el transporte y la infraestructura.',
			cliente_desde: '1988',
			pais_cabecera: 'México',
			rfc: 'MIN991906-AR4',
			cuenta_clave: 'NO',
			examen: true,
			codigo: 'examen3',
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2013',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2013,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [12,13],
						deuda_neta: 4,
						cartera_vencida: 6,
						cartera_vigente: 5,
						estimacion_riesgo: 7,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 10,
						},
						{
							titulo: 'Cartera Vigente',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 10,
						},
						{
							titulo: 'Cartera Vencida',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 10,
						},
						{
							titulo: 'Estimación Para Riesgos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 10,
						},
						{
							titulo: 'Cartera Neta',
							// monto: 2550538,
							monto: null,
							porcentaje: 47,
							base: 10,
						},
						{
							titulo: 'Otros activos',
							// monto: 2872383,
							monto: null,
							porcentaje: 53,
							base: 10,
						},
						{
							titulo: 'Total Activo',
							// monto:  5422921,
							monto: null,
							porcentaje: 100,
							base: 10,
						},
						{
							titulo: 'Captación Total',
							// monto:  0,
							monto: null,
							porcentaje: 0,
							base: 17,
						},
						{
							titulo: 'Prestamos CP',
							// monto:  828742,
							monto: null,
							porcentaje: 15,
							base: 17,
						},
						{
							titulo: 'Prestamos LP',
							// monto:  756199,
							monto: null,
							porcentaje: 14,
							base: 17,
						},
						{
							titulo: 'Otros Pasivos',
							// monto:  1620743,
							monto: null,
							porcentaje: 30,
							base: 17,
						},
						{
							titulo: 'Total Pasivos',
							// monto:  3205684,
							monto: null,
							porcentaje: 59,
							base: 17,
						},
						{
							titulo: 'Capital Contable',
							// monto:  2217237,
							monto: null,
							porcentaje: 41,
							base: 17,
						},
						{
							titulo: 'Total',
							// monto:  5422921,
							monto: null,
							porcentaje: 100,
							base: 17,
						},
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2014',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2014,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [12,13],
						deuda_neta: 4,
						cartera_vencida: 6,
						cartera_vigente: 5,
						estimacion_riesgo: 7,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 10,
						},
						{
							titulo: 'Cartera Vigente',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 10,
						},
						{
							titulo: 'Cartera Vencida',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 10,
						},
						{
							titulo: 'Estimación Para Riesgos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 10,
						},
						{
							titulo: 'Cartera Neta',
							// monto: 2550538,
							monto: null,
							porcentaje: 47,
							base: 10,
						},
						{
							titulo: 'Otros activos',
							// monto: 2872383,
							monto: null,
							porcentaje: 53,
							base: 10,
						},
						{
							titulo: 'Total Activo',
							// monto:  5422921,
							monto: null,
							porcentaje: 100,
							base: 10,
						},
						{
							titulo: 'Captación Total',
							// monto:  0,
							monto: null,
							porcentaje: 0,
							base: 17,
						},
						{
							titulo: 'Prestamos CP',
							// monto:  828742,
							monto: null,
							porcentaje: 15,
							base: 17,
						},
						{
							titulo: 'Prestamos LP',
							// monto:  756199,
							monto: null,
							porcentaje: 14,
							base: 17,
						},
						{
							titulo: 'Otros Pasivos',
							// monto:  1620743,
							monto: null,
							porcentaje: 30,
							base: 17,
						},
						{
							titulo: 'Total Pasivos',
							// monto:  3205684,
							monto: null,
							porcentaje: 59,
							base: 17,
						},
						{
							titulo: 'Capital Contable',
							// monto:  2217237,
							monto: null,
							porcentaje: 41,
							base: 17,
						},
						{
							titulo: 'Total',
							// monto:  5422921,
							monto: null,
							porcentaje: 100,
							base: 17,
						},
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				// {
				// 	fecha: '31/12/2014',
				// 	datos_en: 'Miles',
				// 	estado: 'CONSOLIDATED',
				// 	ano: 2014,
				// 	divisa: 'PESOS MEXICANOS',
				// 	balance: null,
				// 	cuenta_resultados: [
				// 		{
				// 			titulo: 'VENTAS',
				// 			monto: 751838,
				// 			porcentaje: 100,
				// 		},
				// 		{
				// 			titulo: 'EBITDA',
				// 			monto: 437939,
				// 			porcentaje: 58,
				// 		},
				// 		{
				// 			titulo: 'Gastos financieros',
				// 			monto: 208351,
				// 			porcentaje: 28,
				// 		},
				// 		{
				// 			titulo: 'Beneficio Neto',
				// 			monto: 169436,
				// 			porcentaje: 23,
				// 		},
				// 		{
				// 			titulo: 'Caja',
				// 			monto: 228237,
				// 			porcentaje: 5,
				// 		},
				// 		{
				// 			titulo: 'Cartera Vigente',
				// 			monto: 2698463,
				// 			porcentaje: 57,
				// 		},
				// 		{
				// 			titulo: 'Cartera Vencida',
				// 			monto: 188441,
				// 			porcentaje: 4,
				// 		},
				// 		{
				// 			titulo: 'Estimación Para Riesgos',
				// 			monto: -162009,
				// 			porcentaje: -3,
				// 		},
				// 		{
				// 			titulo: 'Cartera Neta',
				// 			monto: 2724895,
				// 			porcentaje: 58,
				// 		},
				// 		{
				// 			titulo: 'Otros activos',
				// 			monto: 1977659,
				// 			porcentaje: 42,
				// 		},
				// 		{
				// 			titulo: 'Total Activo',
				// 			monto:  4702554,
				// 			porcentaje: 100,
				// 		},
				// 		{
				// 			titulo: 'Captación Total',
				// 			monto:  0,
				// 			porcentaje: 0,
				// 		},
				// 		{
				// 			titulo: 'Prestamos CP',
				// 			monto:  683689,
				// 			porcentaje: 15,
				// 		},
				// 		{
				// 			titulo: 'Prestamos LP',
				// 			monto:  1021846,
				// 			porcentaje: 22,
				// 		},
				// 		{
				// 			titulo: 'Otros Pasivos',
				// 			monto:  609445,
				// 			porcentaje: 13,
				// 		},
				// 		{
				// 			titulo: 'Total Pasivos',
				// 			monto:  2314980,
				// 			porcentaje: 49,
				// 		},
				// 		{
				// 			titulo: 'Capital Contable',
				// 			monto:  2387574,
				// 			porcentaje: 51,
				// 		},
				// 		{
				// 			titulo: 'Total',
				// 			monto:  4702554,
				// 			porcentaje: 100,
				// 		},
				// 		{
				// 			titulo: 'Deuda Total',
				// 			monto:  1705535,
				// 			porcentaje: 0,
				// 		},
				// 		{
				// 			titulo: 'Deuda Neta',
				// 			monto:  1477298,
				// 			porcentaje: 0,
				// 		},
				// 		{
				// 			titulo: 'Indicador CV',
				// 			monto:  6.5,
				// 			porcentaje: 0,
				// 		},
				// 		{
				// 			titulo: 'Cobertura de CV',
				// 			monto:  86,
				// 			porcentaje: 0,
				// 		},
					
				// 	],
				// 	cash_flow: null,
				// 	magnitudes_y_ratios: null
				// },
			],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.091249146,
						0.275623858,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2013,
						2014,
					],
					datos: [
						3.077601956,
						3.985576775,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.21,
						0.33,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2013,
						2014,
					],
					datos: [
						14.74348999,
						10.73792012,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2013,
						2014,
					],
					datos: [
						'',
						''
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2013,
						2014,
					],
					datos: [
						'',
						''
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2013,
						2014,
					],
					datos: [
						'',
						''
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2013,
						2014,
					],
					datos: [
						'',
						''
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2013,
						2014,
					],
					datos: [
						1,
						1,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.112649569,
						0.341870062,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2013,
						2014,
					],
					datos: [
						2.014602138,
						2.101928956,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2013,
						2014,
					],
					datos: [
						2.01,
						2.10,
					]
				},
				{
					titulo: 'Utilidad Neta/Ventas',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.219256335,
						0.225362379,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.049654938,
						0.085675033,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.064326908,
						0.070965759,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.564250311,
						0.308164856,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.511334616,
						1.121822314,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.280666802,
						0.277122199,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2013,
						2014,
					],
					datos: [
						2.014602138,
						2.101928956,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2013,
						2014,
					],
					datos: [
						-753120,
						-495248,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2013,
						2014,
					],
					datos: [
						54209.00,
						62653.17,
					]
				},
				
			]
		},
		{
			id: 11, 
			posiciones_actuales: '',
			parent: 4,
			nombre: 'Mexicos S.A.B. de C.V',
			tipo: 'Filial',
			fecha_constitucion: '1960',
			actividad_principal: 'producción y venta de productos químicos y petroquímicos',
			cliente_desde: '1988',
			pais_cabecera: 'México',
			rfc: 'MIN991906-AR4',
			cuenta_clave: 'NO',
			examen: true,
			codigo: 'examen3',
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2013',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2013,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 4867616,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 1018754,
							monto: null,
							porcentaje: 21,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 279075,
							monto: null,
							porcentaje: 6,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 351584,
							monto: null,
							porcentaje: 7,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 1643924,
							monto: null,
							porcentaje: 21,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 930231,
							monto: null,
							porcentaje: 12,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 3503374,
							monto: null,
							porcentaje: 46,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 2472259,
							monto: null,
							porcentaje: 32,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 1109628,
							monto: null,
							porcentaje: 14,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 7657433,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  129797,
							monto: null,
							porcentaje: 2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  910873,
							monto: null,
							porcentaje: 12,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  1516015,
							monto: null,
							porcentaje: 20,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  417259,
							monto: null,
							porcentaje: 5,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  4433119,
							monto: null,
							porcentaje: 58,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  3224314,
							monto: null,
							porcentaje: 42,
							base: 16,
						},
					
						{
							titulo: 'Total',
							// monto:  7657433,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  547056,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  0.54,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2014',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2014,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 4867616,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 1018754,
							monto: null,
							porcentaje: 21,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 279075,
							monto: null,
							porcentaje: 6,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 351584,
							monto: null,
							porcentaje: 7,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 1643924,
							monto: null,
							porcentaje: 21,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 930231,
							monto: null,
							porcentaje: 12,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 3503374,
							monto: null,
							porcentaje: 46,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 2472259,
							monto: null,
							porcentaje: 32,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 1109628,
							monto: null,
							porcentaje: 14,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 7657433,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  129797,
							monto: null,
							porcentaje: 2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  910873,
							monto: null,
							porcentaje: 12,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  1516015,
							monto: null,
							porcentaje: 20,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  417259,
							monto: null,
							porcentaje: 5,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  4433119,
							monto: null,
							porcentaje: 58,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  3224314,
							monto: null,
							porcentaje: 42,
							base: 16,
						},
					
						{
							titulo: 'Total',
							// monto:  7657433,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  547056,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  0.54,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				// {
				// 	fecha: '31/12/2014',
				// 	datos_en: 'Miles',
				// 	estado: 'CONSOLIDATED',
				// 	ano: 2014,
				// 	divisa: 'PESOS MEXICANOS',
				// 	balance: null,
				// 	cuenta_resultados: [
				// 		{
				// 			titulo: 'VENTAS',
				// 			monto: 5301792,
				// 			porcentaje: 100,
				// 		},
				// 		{
				// 			titulo: 'EBITDA',
				// 			monto: 848682,
				// 			porcentaje: 16,
				// 		},
				// 		{
				// 			titulo: 'Gastos financieros',
				// 			monto: 174892,
				// 			porcentaje: 3,
				// 		},
				// 		{
				// 			titulo: 'Beneficio Neto',
				// 			monto: 83055,
				// 			porcentaje: 2,
				// 		},
				// 		{
				// 			titulo: 'Caja',
				// 			monto: 1232561,
				// 			porcentaje: 15,
				// 		},
				// 		{
				// 			titulo: 'Cuentas X Cobrar',
				// 			monto: 896777,
				// 			porcentaje: 11,
				// 		},
				// 		{
				// 			titulo: 'Activos Circulantes',
				// 			monto: 3052978,
				// 			porcentaje: 37,
				// 		},
				// 		{
				// 			titulo: 'Activo Fijo',
				// 			monto: 3152748,
				// 			porcentaje: 39,
				// 		},
				// 		{
				// 			titulo: 'Otros Activos',
				// 			monto: 1208186,
				// 			porcentaje: 15,
				// 		},
				// 		{
				// 			titulo: 'Total Activo',
				// 			monto: 8181802,
				// 			porcentaje: 100,
				// 		},
				// 		{
				// 			titulo: 'Bancos CP y PCLP',
				// 			monto:  461572,
				// 			porcentaje: 6,
				// 		},
				// 		{
				// 			titulo: 'Proveedores',
				// 			monto:  553696,
				// 			porcentaje: 7,
				// 		},
				// 		{
				// 			titulo: 'Total P. Circulante',
				// 			monto:  1514945,
				// 			porcentaje: 19,
				// 		},
				// 		{
				// 			titulo: 'Deuda a LP',
				// 			monto:  296656,
				// 			porcentaje: 4,
				// 		},
				// 		{
				// 			titulo: 'Total Pasivo',
				// 			monto:  4590745,
				// 			porcentaje: 56,
				// 		},
				// 		{
				// 			titulo: 'Capital Contable',
				// 			monto:  3591057,
				// 			porcentaje: 44,
				// 		},
					
				// 		{
				// 			titulo: 'Total',
				// 			monto:  8181802,
				// 			porcentaje: 100,
				// 		},
				// 		{
				// 			titulo: 'Deuda Total',
				// 			monto:  758228,
				// 			porcentaje: 0,
				// 		},
				// 		{
				// 			titulo: 'Deuda Neta',
				// 			monto:  0,
				// 			porcentaje: 0,
				// 		},
				// 		{
				// 			titulo: 'Indicador CV',
				// 			monto:  0.89,
				// 			porcentaje: 0,
				// 		},
				// 		{
				// 			titulo: 'Cobertura de CV',
				// 			monto:  0,
				// 			porcentaje: 0,
				// 		},
					
				// 	],
				// 	cash_flow: null,
				// 	magnitudes_y_ratios: null
				// },
				
			],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						2.310909852,
						2.015240157,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						1.7,
						1.41,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						1.08,
						0.81,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.536985376,
						0.893418265,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2012,
						2013,
					],
					datos: [
						93.38,
						77.44
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2012,
						2013,
					],
					datos: [
						69.75,
						61.74,
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2012,
						2013,
					],
					datos: [
						113.75,
						58.84,
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2012,
						2013,
					],
					datos: [
						49.38,
						80.34
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2012,
						2013,
					],
					datos: [
						1.374903003,
						1.27838266,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.062952292,
						0.038096649,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2012,
						2013,
					],
					datos: [
						3.65046672,
						4.85260618,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2012,
						2013,
					],
					datos: [
						2.49,
						1.33,
					]
				},
				{
					titulo: 'Utilidad Neta/Ventas',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.072229198,
						0.015665458,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.045914081,
						0.010151187,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.109041489,
						0.023128288,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.578930172,
						0.561092165,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.341974804,
						0.329999815,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.057332994,
						0.032987337,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2012,
						2013,
					],
					datos: [
						3.65046672,
						4.85260618,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2012,
						2013,
					],
					datos: [
						1987359,
						1538033,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2012,
						2013,
					],
					datos: [
						405634.67,
						441816.00,
					]
				},
				
			]
		},
		{
			id: 12, 
			posiciones_actuales: '',
			parent: 4,
			nombre: 'Consmexica S.A. de C.V',
			tipo: 'Filial',
			fecha_constitucion: '1960',
			actividad_principal: 'Construccion Industrial',
			cliente_desde: '1988',
			pais_cabecera: 'México',
			rfc: 'MIN991906-AR4',
			cuenta_clave: 'NO',
			examen: true,
			codigo: 'examen3',
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2013',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2013,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 4867616,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 1018754,
							monto: null,
							porcentaje: 21,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 279075,
							monto: null,
							porcentaje: 6,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 351584,
							monto: null,
							porcentaje: 7,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 1643924,
							monto: null,
							porcentaje: 21,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 930231,
							monto: null,
							porcentaje: 12,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 3503374,
							monto: null,
							porcentaje: 46,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 2472259,
							monto: null,
							porcentaje: 32,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 1109628,
							monto: null,
							porcentaje: 14,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 7657433,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  129797,
							monto: null,
							porcentaje: 2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  910873,
							monto: null,
							porcentaje: 12,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  1516015,
							monto: null,
							porcentaje: 20,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  417259,
							monto: null,
							porcentaje: 5,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  4433119,
							monto: null,
							porcentaje: 58,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  3224314,
							monto: null,
							porcentaje: 42,
							base: 16,
						},
					
						{
							titulo: 'Total',
							// monto:  7657433,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  547056,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  0.54,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2014',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2014,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 4867616,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 1018754,
							monto: null,
							porcentaje: 21,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 279075,
							monto: null,
							porcentaje: 6,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 351584,
							monto: null,
							porcentaje: 7,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 1643924,
							monto: null,
							porcentaje: 21,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 930231,
							monto: null,
							porcentaje: 12,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 3503374,
							monto: null,
							porcentaje: 46,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 2472259,
							monto: null,
							porcentaje: 32,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 1109628,
							monto: null,
							porcentaje: 14,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 7657433,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  129797,
							monto: null,
							porcentaje: 2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  910873,
							monto: null,
							porcentaje: 12,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  1516015,
							monto: null,
							porcentaje: 20,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  417259,
							monto: null,
							porcentaje: 5,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  4433119,
							monto: null,
							porcentaje: 58,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  3224314,
							monto: null,
							porcentaje: 42,
							base: 16,
						},
					
						{
							titulo: 'Total',
							// monto:  7657433,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  547056,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  0.54,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
			],
			// informes: [
			// 	{
			// 		fecha: '31/12/2013',
			// 		datos_en: 'Miles',
			// 		estado: 'CONSOLIDATED',
			// 		ano: 2013,
			// 		divisa: 'PESOS MEXICANOS',
			// 		balance: null,
			// 		cuenta_resultados: [
			// 			{
			// 				titulo: 'VENTAS',
			// 				monto: 13505892,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'EBITDA',
			// 				monto: 1855508,
			// 				porcentaje: 14,
			// 			},
			// 			{
			// 				titulo: 'Gastos financieros',
			// 				monto: 308223,
			// 				porcentaje: 2,
			// 			},
			// 			{
			// 				titulo: 'Beneficio Neto',
			// 				monto: 315405,
			// 				porcentaje: 2,
			// 			},
			// 			{
			// 				titulo: 'Caja',
			// 				monto: 1761935,
			// 				porcentaje: 8,
			// 			},
			// 			{
			// 				titulo: 'Cuentas X Cobrar',
			// 				monto: 1825763,
			// 				porcentaje: 8,
			// 			},
			// 			{
			// 				titulo: 'Activos Circulantes',
			// 				monto: 7760176,
			// 				porcentaje: 35,
			// 			},
			// 			{
			// 				titulo: 'Activo Fijo',
			// 				monto: 11822531,
			// 				porcentaje: 54,
			// 			},
			// 			{
			// 				titulo: 'Otros Activos',
			// 				monto: 600348,
			// 				porcentaje: 3,
			// 			},
			// 			{
			// 				titulo: 'Total Activo',
			// 				monto: 22008372,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'Bancos CP y PCLP',
			// 				monto:  456267,
			// 				porcentaje: 2,
			// 			},
			// 			{
			// 				titulo: 'Proveedores',
			// 				monto:  2330471,
			// 				porcentaje: 11,
			// 			},
			// 			{
			// 				titulo: 'Total P. Circulante',
			// 				monto:  3520285,
			// 				porcentaje: 16,
			// 			},
			// 			{
			// 				titulo: 'Deuda a LP',
			// 				monto:  2926129,
			// 				porcentaje: 13,
			// 			},
			// 			{
			// 				titulo: 'Total Pasivo',
			// 				monto:  10988917,
			// 				porcentaje: 50,
			// 			},
			// 			{
			// 				titulo: 'Capital Contable',
			// 				monto:  10988917,
			// 				porcentaje: 50,
			// 			},
					
			// 			{
			// 				titulo: 'Total',
			// 				monto:  22008372,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'Deuda Total',
			// 				monto:  3382396,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Deuda Neta',
			// 				monto:  1620461,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Indicador CV',
			// 				monto:  1.82,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Cobertura de CV',
			// 				monto:  0,
			// 				porcentaje: 0,
			// 			},
					
			// 		],
			// 		cash_flow: null,
			// 		magnitudes_y_ratios: null
			// 	},
			// 	{
			// 		fecha: '31/12/2014',
			// 		datos_en: 'Miles',
			// 		estado: 'CONSOLIDATED',
			// 		ano: 2014,
			// 		divisa: 'PESOS MEXICANOS',
			// 		balance: null,
			// 		cuenta_resultados: [
			// 			{
			// 				titulo: 'VENTAS',
			// 				monto: 12929454,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'EBITDA',
			// 				monto: 1612256,
			// 				porcentaje: 12,
			// 			},
			// 			{
			// 				titulo: 'Gastos financieros',
			// 				monto: 469867,
			// 				porcentaje: 4,
			// 			},
			// 			{
			// 				titulo: 'Beneficio Neto',
			// 				monto: 491503,
			// 				porcentaje: 4,
			// 			},
			// 			{
			// 				titulo: 'Caja',
			// 				monto: 1972934,
			// 				porcentaje: 8,
			// 			},
			// 			{
			// 				titulo: 'Cuentas X Cobrar',
			// 				monto: 2381597,
			// 				porcentaje: 9,
			// 			},
			// 			{
			// 				titulo: 'Activos Circulantes',
			// 				monto: 8087426,
			// 				porcentaje: 31,
			// 			},
			// 			{
			// 				titulo: 'Activo Fijo',
			// 				monto: 14608087,
			// 				porcentaje: 56,
			// 			},
			// 			{
			// 				titulo: 'Otros Activos',
			// 				monto: 1515792,
			// 				porcentaje: 6,
			// 			},
			// 			{
			// 				titulo: 'Total Activo',
			// 				monto: 26223917,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'Bancos CP y PCLP',
			// 				monto:  192533,
			// 				porcentaje: 1,
			// 			},
			// 			{
			// 				titulo: 'Proveedores',
			// 				monto:  2663274,
			// 				porcentaje: '',
			// 			},
			// 			{
			// 				titulo: 'Total P. Circulante',
			// 				monto:  3978325,
			// 				porcentaje: 15,
			// 			},
			// 			{
			// 				titulo: 'Deuda a LP',
			// 				monto:  3185182,
			// 				porcentaje: 12,
			// 			},
			// 			{
			// 				titulo: 'Total Pasivo',
			// 				monto:  11788051,
			// 				porcentaje: 45,
			// 			},
			// 			{
			// 				titulo: 'Capital Contable',
			// 				monto:  14435866,
			// 				porcentaje: 55,
			// 			},
					
			// 			{
			// 				titulo: 'Total',
			// 				monto:  26223917,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'Deuda Total',
			// 				monto:  3377715,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Deuda Neta',
			// 				monto:  1404781,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Indicador CV',
			// 				monto:  2.10,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Cobertura de CV',
			// 				monto:  0,
			// 				porcentaje: 0,
			// 			},
					
			// 		],
			// 		cash_flow: null,
			// 		magnitudes_y_ratios: null
			// 	},
			// ],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						2.204416972,
						2.032872126,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						1.06,
						1.13,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.50,
						0.50,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2012,
						2013,
					],
					datos: [
						1.822894862,
						2.095023991,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2012,
						2013,
					],
					datos: [
						92.39,
						89.35,
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2012,
						2013,
					],
					datos: [
						49.34,
						67.23,
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2012,
						2013,
					],
					datos: [
						87.13,
						105.75,
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2012,
						2013,
					],
					datos: [
						54.6,
						50.83
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2012,
						2013,
					],
					datos: [
						1.002778982,
						0.8165808,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.027970803,
						0.0398596,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2012,
						2013,
					],
					datos: [
						6.020017974,
						3.431302901,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2012,
						2013,
					],
					datos: [
						2.43,
						2.43,
					]
				},
				{
					titulo: 'Utilidad Neta/Ventas',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.023353141,
						0.038014212,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.014331137,
						0.018742547,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.0287021,
						0.034047351,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.500693781,
						0.449515265,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.319460899,
						0.337487936,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.022821373,
						0.036340823,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2012,
						2013,
					],
					datos: [
						6.020017974,
						3.431302901,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2012,
						2013,
					],
					datos: [
						4239891,
						4109101,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2012,
						2013,
					],
					datos: [
						1125491.00,
						1077454.50,
					]
				},
				
			]
		},
		{
			id: 13, 
			posiciones_actuales: '',
			parent: 5,
			nombre: 'Nations Mining Corporation',
			tipo: 'Filial',
			fecha_constitucion: '1960',
			actividad_principal: 'Construccion Industrial',
			cliente_desde: '1988',
			pais_cabecera: 'México',
			rfc: 'MIN991906-AR4',
			cuenta_clave: 'NO',
			examen: true,
			codigo: 'examen3',
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2013',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2013,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 8350899,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 4727259,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: -235884,
							monto: null,
							porcentaje: -3,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 2307803,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 2593625,
							monto: null,
							porcentaje: 19,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 766105,
							monto: null,
							porcentaje: 5,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 5115158,
							monto: null,
							porcentaje: 37,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 7081158,
							monto: null,
							porcentaje: 51,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 1750231,
							monto: null,
							porcentaje: 13,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 13946547,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  10000,
							monto: null,
							porcentaje: 0,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  540107,
							monto: null,
							porcentaje: 4,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  1620602,
							monto: null,
							porcentaje: 12,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  4203863,
							monto: null,
							porcentaje: 30,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  7907207,
							monto: null,
							porcentaje: 57,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  6039340,
							monto: null,
							porcentaje: 43,
							base: 16,
						},
					
						{
							titulo: 'Total',
							// monto:  13946547,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  4213863,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1620238,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  0.89,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2014',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2014,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 8350899,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 4727259,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: -235884,
							monto: null,
							porcentaje: -3,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 2307803,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 2593625,
							monto: null,
							porcentaje: 19,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 766105,
							monto: null,
							porcentaje: 5,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 5115158,
							monto: null,
							porcentaje: 37,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 7081158,
							monto: null,
							porcentaje: 51,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 1750231,
							monto: null,
							porcentaje: 13,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 13946547,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  10000,
							monto: null,
							porcentaje: 0,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  540107,
							monto: null,
							porcentaje: 4,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  1620602,
							monto: null,
							porcentaje: 12,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  4203863,
							monto: null,
							porcentaje: 30,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  7907207,
							monto: null,
							porcentaje: 57,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  6039340,
							monto: null,
							porcentaje: 43,
							base: 16,
						},
					
						{
							titulo: 'Total',
							// monto:  13946547,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  4213863,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1620238,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  0.89,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				// {
				// 	fecha: '31/12/2014',
				// 	datos_en: 'Miles',
				// 	estado: 'CONSOLIDATED',
				// 	ano: 2014,
				// 	divisa: 'PESOS MEXICANOS',
				// 	balance: null,
				// 	cuenta_resultados: [
				// 		{
				// 			titulo: 'VENTAS',
				// 			monto: 7276654,
				// 			porcentaje: 100,
				// 		},
				// 		{
				// 			titulo: 'EBITDA',
				// 			monto: 3333831,
				// 			porcentaje: 46,
				// 		},
				// 		{
				// 			titulo: 'Gastos financieros',
				// 			monto: -206608,
				// 			porcentaje: -3,
				// 		},
				// 		{
				// 			titulo: 'Beneficio Neto',
				// 			monto: 1823209,
				// 			porcentaje: 25,
				// 		},
				// 		{
				// 			titulo: 'Caja',
				// 			monto: 1971019,
				// 			porcentaje: 14,
				// 		},
				// 		{
				// 			titulo: 'Cuentas X Cobrar',
				// 			monto: 614693,
				// 			porcentaje: 4,
				// 		},
				// 		{
				// 			titulo: 'Activos Circulantes',
				// 			monto: 4148741,
				// 			porcentaje: 30,
				// 		},
				// 		{
				// 			titulo: 'Activo Fijo',
				// 			monto: 8555280,
				// 			porcentaje: 61,
				// 		},
				// 		{
				// 			titulo: 'Otros Activos',
				// 			monto: 1314142,
				// 			porcentaje: 9,
				// 		},
				// 		{
				// 			titulo: 'Total Activo',
				// 			monto: 14018163,
				// 			porcentaje: 100,
				// 		},
				// 		{
				// 			titulo: 'Bancos CP y PCLP',
				// 			monto:  0,
				// 			porcentaje: 0,
				// 		},
				// 		{
				// 			titulo: 'Proveedores',
				// 			monto:  696565,
				// 			porcentaje: 5,
				// 		},
				// 		{
				// 			titulo: 'Total P. Circulante',
				// 			monto:  1400460,
				// 			porcentaje: '',
				// 		},
				// 		{
				// 			titulo: 'Deuda a LP',
				// 			monto:  4204915,
				// 			porcentaje: 30,
				// 		},
				// 		{
				// 			titulo: 'Total Pasivo',
				// 			monto:  6993167,
				// 			porcentaje: 50,
				// 		},
				// 		{
				// 			titulo: 'Capital Contable',
				// 			monto:  7024996,
				// 			porcentaje: 50,
				// 		},
					
				// 		{
				// 			titulo: 'Total',
				// 			monto:  14018163,
				// 			porcentaje: 100,
				// 		},
				// 		{
				// 			titulo: 'Deuda Total',
				// 			monto:  4204915,
				// 			porcentaje: 0,
				// 		},
				// 		{
				// 			titulo: 'Deuda Neta',
				// 			monto:  2233896,
				// 			porcentaje: 0,
				// 		},
				// 		{
				// 			titulo: 'Indicador CV',
				// 			monto:  1.26,
				// 			porcentaje: 0,
				// 		},
				// 		{
				// 			titulo: 'Cobertura de CV',
				// 			monto:  0,
				// 			porcentaje: 0,
				// 		},
					
				// 	],
				// 	cash_flow: null,
				// 	magnitudes_y_ratios: null
				// },
				
			],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						3.15633203,
						2.962413064,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						2.35,
						1.97,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						1.60,
						1.41,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.891396685,
						1.26128619,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2012,
						2013,
					],
					datos: [
						90.15,
						77.57,
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2012,
						2013,
					],
					datos: [
						33.48,
						30.83,
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2012,
						2013,
					],
					datos: [
						45.92,
						60.26,
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2012,
						2013,
					],
					datos: [
						77.71,
						48.14,
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2012,
						2013,
					],
					datos: [
						1.309283299,
						0.995469179,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2012,
						2013,
					],
					datos: [
						-0.02983152,
						-0.029544268,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2012,
						2013,
					],
					datos: [
						-20.04060894,
						-16.13602087,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2012,
						2013,
					],
					datos: [
						-20.93,
						-16.14,
					]
				},
				{
					titulo: 'Utilidad Neta/Ventas',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.276353839,
						0.250555956,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.165474866,
						0.130060479,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.382128345,
						0.259531678,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.566965214,
						0.498864723,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.20495252,
						0.200261198,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2012,
						2013,
					],
					datos: [
						-0.02824654,
						-0.02839327,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2012,
						2013,
					],
					datos: [
						-20.04060894,
						-16.13602087,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2012,
						2013,
					],
					datos: [
						3494556,
						2748281,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2012,
						2013,
					],
					datos: [
						695908.25,
						606387.83,
					]
				},
				
			]
		},
		{
			id: 14, 
			posiciones_actuales: '',
			parent: 5,
			nombre: 'Infraestructura y Transportes Nacionales S.A. de C.V',
			tipo: 'Filial',
			fecha_constitucion: '1960',
			actividad_principal: 'Construccion Industrial',
			cliente_desde: '1988',
			pais_cabecera: 'México',
			rfc: 'MIN991906-AR4',
			cuenta_clave: 'NO',
			examen: true,
			codigo: 'examen3',
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2013',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2013,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 8350899,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 4727259,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: -235884,
							monto: null,
							porcentaje: -3,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 2307803,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 2593625,
							monto: null,
							porcentaje: 19,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 766105,
							monto: null,
							porcentaje: 5,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 5115158,
							monto: null,
							porcentaje: 37,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 7081158,
							monto: null,
							porcentaje: 51,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 1750231,
							monto: null,
							porcentaje: 13,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 13946547,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  10000,
							monto: null,
							porcentaje: 0,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  540107,
							monto: null,
							porcentaje: 4,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  1620602,
							monto: null,
							porcentaje: 12,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  4203863,
							monto: null,
							porcentaje: 30,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  7907207,
							monto: null,
							porcentaje: 57,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  6039340,
							monto: null,
							porcentaje: 43,
							base: 16,
						},
					
						{
							titulo: 'Total',
							// monto:  13946547,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  4213863,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1620238,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  0.89,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2014',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2014,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 8350899,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 4727259,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: -235884,
							monto: null,
							porcentaje: -3,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 2307803,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 2593625,
							monto: null,
							porcentaje: 19,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 766105,
							monto: null,
							porcentaje: 5,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 5115158,
							monto: null,
							porcentaje: 37,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 7081158,
							monto: null,
							porcentaje: 51,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 1750231,
							monto: null,
							porcentaje: 13,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 13946547,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  10000,
							monto: null,
							porcentaje: 0,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  540107,
							monto: null,
							porcentaje: 4,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  1620602,
							monto: null,
							porcentaje: 12,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  4203863,
							monto: null,
							porcentaje: 30,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  7907207,
							monto: null,
							porcentaje: 57,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  6039340,
							monto: null,
							porcentaje: 43,
							base: 16,
						},
					
						{
							titulo: 'Total',
							// monto:  13946547,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  4213863,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1620238,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  0.89,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
			],
			// informes: [
			// 	{
			// 		fecha: '31/12/2013',
			// 		datos_en: 'Miles',
			// 		estado: 'CONSOLIDATED',
			// 		ano: 2013,
			// 		divisa: 'PESOS MEXICANOS',
			// 		balance: null,
			// 		cuenta_resultados: [
			// 			{
			// 				titulo: 'VENTAS',
			// 				monto: 1676720,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'EBITDA',
			// 				monto: 540939,
			// 				porcentaje: 32,
			// 			},
			// 			{
			// 				titulo: 'Gastos financieros',
			// 				monto: -32393,
			// 				porcentaje: -2,
			// 			},
			// 			{
			// 				titulo: 'Beneficio Neto',
			// 				monto: 341854,
			// 				porcentaje: 20,
			// 			},
			// 			{
			// 				titulo: 'Caja',
			// 				monto: 420162,
			// 				porcentaje: 14,
			// 			},
			// 			{
			// 				titulo: 'Cuentas X Cobrar',
			// 				monto: 174390,
			// 				porcentaje: 6,
			// 			},
			// 			{
			// 				titulo: 'Activos Circulantes',
			// 				monto: 728370,
			// 				porcentaje: 24,
			// 			},
			// 			{
			// 				titulo: 'Activo Fijo',
			// 				monto: 1640988,
			// 				porcentaje: 54,
			// 			},
			// 			{
			// 				titulo: 'Otros Activos',
			// 				monto: 674249,
			// 				porcentaje: 22,
			// 			},
			// 			{
			// 				titulo: 'Total Activo',
			// 				monto: 3043607,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'Bancos CP y PCLP',
			// 				monto:  52176,
			// 				porcentaje: 2,
			// 			},
			// 			{
			// 				titulo: 'Proveedores',
			// 				monto:  265876,
			// 				porcentaje: 9,
			// 			},
			// 			{
			// 				titulo: 'Total P. Circulante',
			// 				monto:  318052,
			// 				porcentaje: '',
			// 			},
			// 			{
			// 				titulo: 'Deuda a LP',
			// 				monto:  422049,
			// 				porcentaje: 14,
			// 			},
			// 			{
			// 				titulo: 'Total Pasivo',
			// 				monto:  848118,
			// 				porcentaje: 28,
			// 			},
			// 			{
			// 				titulo: 'Capital Contable',
			// 				monto:  2195489,
			// 				porcentaje: 72,
			// 			},
					
			// 			{
			// 				titulo: 'Total',
			// 				monto:  3043607,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'Deuda Total',
			// 				monto:  474225,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Deuda Neta',
			// 				monto:  54063,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Indicador CV',
			// 				monto:  0.88,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Cobertura de CV',
			// 				monto:  0.10,
			// 				porcentaje: 0,
			// 			},
					
			// 		],
			// 		cash_flow: null,
			// 		magnitudes_y_ratios: null
			// 	},
			// 	{
			// 		fecha: '31/12/2014',
			// 		datos_en: 'Miles',
			// 		estado: 'CONSOLIDATED',
			// 		ano: 2014,
			// 		divisa: 'PESOS MEXICANOS',
			// 		balance: null,
			// 		cuenta_resultados: [
			// 			{
			// 				titulo: 'VENTAS',
			// 				monto: 1856416,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'EBITDA',
			// 				monto: 611397,
			// 				porcentaje: 33,
			// 			},
			// 			{
			// 				titulo: 'Gastos financieros',
			// 				monto: -24888,
			// 				porcentaje: -1,
			// 			},
			// 			{
			// 				titulo: 'Beneficio Neto',
			// 				monto: 262181,
			// 				porcentaje: 14,
			// 			},
			// 			{
			// 				titulo: 'Caja',
			// 				monto: 282307,
			// 				porcentaje: 9,
			// 			},
			// 			{
			// 				titulo: 'Cuentas X Cobrar',
			// 				monto: 216577,
			// 				porcentaje: 7,
			// 			},
			// 			{
			// 				titulo: 'Activos Circulantes',
			// 				monto: 655180,
			// 				porcentaje: 20,
			// 			},
			// 			{
			// 				titulo: 'Activo Fijo',
			// 				monto: 1897025,
			// 				porcentaje: 59,
			// 			},
			// 			{
			// 				titulo: 'Otros Activos',
			// 				monto: 653905,
			// 				porcentaje: 20,
			// 			},
			// 			{
			// 				titulo: 'Total Activo',
			// 				monto: 3206110,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'Bancos CP y PCLP',
			// 				monto:  113269,
			// 				porcentaje: 4,
			// 			},
			// 			{
			// 				titulo: 'Proveedores',
			// 				monto:  261654,
			// 				porcentaje: 8,
			// 			},
			// 			{
			// 				titulo: 'Total P. Circulante',
			// 				monto:  374923,
			// 				porcentaje: 12,
			// 			},
			// 			{
			// 				titulo: 'Deuda a LP',
			// 				monto:  303961,
			// 				porcentaje: '',
			// 			},
			// 			{
			// 				titulo: 'Total Pasivo',
			// 				monto:  823348,
			// 				porcentaje: 26,
			// 			},
			// 			{
			// 				titulo: 'Capital Contable',
			// 				monto:  2382762,
			// 				porcentaje: 74,
			// 			},
					
			// 			{
			// 				titulo: 'Total',
			// 				monto:  3206110,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'Deuda Total',
			// 				monto:  420230,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Deuda Neta',
			// 				monto:  137923,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Indicador CV',
			// 				monto:  0.69,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Cobertura de CV',
			// 				monto:  0.23,
			// 				porcentaje: 0,
			// 			},
					
			// 		],
			// 		cash_flow: null,
			// 		magnitudes_y_ratios: null
			// 	},
			// ],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						2.290097217,
						1.747505488,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						2.15,
						1.6,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						1.32,
						0.75,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.876670013,
						0.687327547,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2012,
						2013,
					],
					datos: [
						0,
						0,
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2012,
						2013,
					],
					datos: [
						37.96,
						42.58,
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2012,
						2013,
					],
					datos: [
						91.03,
						81.44,
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2012,
						2013,
					],
					datos: [
						-53.07,
						-38.86,
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.386300273,
						0.345543533,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2012,
						2013,
					],
					datos: [
						-0.038193978,
						-0.030227802,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2012,
						2013,
					],
					datos: [
						-16.69925601,
						-24.56593539,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2012,
						2013,
					],
					datos: [
						27.34,
						6.92,
					]
				},
				{
					titulo: 'Utilidad Neta/Ventas',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.20388258,
						0.14122966,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.112318706,
						0.081775423,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.155707453,
						0.110032391,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.278655556,
						0.256805911,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.375009138,
						0.455363953,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2012,
						2013,
					],
					datos: [
						-0.019319266,
						-0.013406478,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2012,
						2013,
					],
					datos: [
						-16.69925601,
						-24.56593539,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2012,
						2013,
					],
					datos: [
						410318,
						280257,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2012,
						2013,
					],
					datos: [
						139726.67,
						154701.33,
					]
				},
				
			]
		},
		{
			id: 15, 
			posiciones_actuales: '',
			parent: 5,
			nombre: 'Proyectos y Desarrollos Nacionales S.A. de C.V',
			tipo: 'Filial',
			fecha_constitucion: '1960',
			actividad_principal: 'Construccion Industrial',
			cliente_desde: '1988',
			pais_cabecera: 'México',
			rfc: 'MIN991906-AR4',
			cuenta_clave: 'NO',
			examen: true,
			codigo: 'examen3',
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2013',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2013,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 8350899,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 4727259,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: -235884,
							monto: null,
							porcentaje: -3,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 2307803,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 2593625,
							monto: null,
							porcentaje: 19,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 766105,
							monto: null,
							porcentaje: 5,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 5115158,
							monto: null,
							porcentaje: 37,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 7081158,
							monto: null,
							porcentaje: 51,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 1750231,
							monto: null,
							porcentaje: 13,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 13946547,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  10000,
							monto: null,
							porcentaje: 0,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  540107,
							monto: null,
							porcentaje: 4,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  1620602,
							monto: null,
							porcentaje: 12,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  4203863,
							monto: null,
							porcentaje: 30,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  7907207,
							monto: null,
							porcentaje: 57,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  6039340,
							monto: null,
							porcentaje: 43,
							base: 16,
						},
					
						{
							titulo: 'Total',
							// monto:  13946547,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  4213863,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1620238,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  0.89,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2014',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2014,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 8350899,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 4727259,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: -235884,
							monto: null,
							porcentaje: -3,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 2307803,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 2593625,
							monto: null,
							porcentaje: 19,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 766105,
							monto: null,
							porcentaje: 5,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 5115158,
							monto: null,
							porcentaje: 37,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 7081158,
							monto: null,
							porcentaje: 51,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 1750231,
							monto: null,
							porcentaje: 13,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 13946547,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  10000,
							monto: null,
							porcentaje: 0,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  540107,
							monto: null,
							porcentaje: 4,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  1620602,
							monto: null,
							porcentaje: 12,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  4203863,
							monto: null,
							porcentaje: 30,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  7907207,
							monto: null,
							porcentaje: 57,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  6039340,
							monto: null,
							porcentaje: 43,
							base: 16,
						},
					
						{
							titulo: 'Total',
							// monto:  13946547,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  4213863,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1620238,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  0.89,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  0,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
			],
			// informes: [
			// 	{
			// 		fecha: '31/12/2013',
			// 		datos_en: 'Miles',
			// 		estado: 'CONSOLIDATED',
			// 		ano: 2013,
			// 		divisa: 'PESOS MEXICANOS',
			// 		balance: null,
			// 		cuenta_resultados: [
			// 			{
			// 				titulo: 'VENTAS',
			// 				monto: 223160,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'EBITDA',
			// 				monto: 64020,
			// 				porcentaje: 29,
			// 			},
			// 			{
			// 				titulo: 'Gastos financieros',
			// 				monto: -17452,
			// 				porcentaje: -8,
			// 			},
			// 			{
			// 				titulo: 'Beneficio Neto',
			// 				monto: 17299,
			// 				porcentaje: 8,
			// 			},
			// 			{
			// 				titulo: 'Caja',
			// 				monto: 117812,
			// 				porcentaje: 6,
			// 			},
			// 			{
			// 				titulo: 'Cuentas X Cobrar',
			// 				monto: 68298,
			// 				porcentaje: 4,
			// 			},
			// 			{
			// 				titulo: 'Activos Circulantes',
			// 				monto: 469078,
			// 				porcentaje: 25,
			// 			},
			// 			{
			// 				titulo: 'Activo Fijo',
			// 				monto: 885071,
			// 				porcentaje: 48,
			// 			},
			// 			{
			// 				titulo: 'Otros Activos',
			// 				monto: 503666,
			// 				porcentaje: 27,
			// 			},
			// 			{
			// 				titulo: 'Total Activo',
			// 				monto: 1857815,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'Bancos CP y PCLP',
			// 				monto:  47312,
			// 				porcentaje: 3,
			// 			},
			// 			{
			// 				titulo: 'Proveedores',
			// 				monto:  238385,
			// 				porcentaje: 13,
			// 			},
			// 			{
			// 				titulo: 'Total P. Circulante',
			// 				monto:  285697,
			// 				porcentaje: 15,
			// 			},
			// 			{
			// 				titulo: 'Deuda a LP',
			// 				monto:  848438,
			// 				porcentaje: 46,
			// 			},
			// 			{
			// 				titulo: 'Total Pasivo',
			// 				monto:  1460331,
			// 				porcentaje: 79,
			// 			},
			// 			{
			// 				titulo: 'Capital Contable',
			// 				monto:  397484,
			// 				porcentaje: 21,
			// 			},
					
			// 			{
			// 				titulo: 'Total',
			// 				monto:  1857815,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'Deuda Total',
			// 				monto:  895750,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Deuda Neta',
			// 				monto:  777938,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Indicador CV',
			// 				monto:  13.99,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Cobertura de CV',
			// 				monto:  12.15,
			// 				porcentaje: 0,
			// 			},
					
			// 		],
			// 		cash_flow: null,
			// 		magnitudes_y_ratios: null
			// 	},
			// 	{
			// 		fecha: '31/12/2014',
			// 		datos_en: 'Miles',
			// 		estado: 'CONSOLIDATED',
			// 		ano: 2014,
			// 		divisa: 'PESOS MEXICANOS',
			// 		balance: null,
			// 		cuenta_resultados: [
			// 			{
			// 				titulo: 'VENTAS',
			// 				monto: 304516,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'EBITDA',
			// 				monto: 106685,
			// 				porcentaje: 35,
			// 			},
			// 			{
			// 				titulo: 'Gastos financieros',
			// 				monto: -41923,
			// 				porcentaje: -14,
			// 			},
			// 			{
			// 				titulo: 'Beneficio Neto',
			// 				monto: 23087,
			// 				porcentaje: 8,
			// 			},
			// 			{
			// 				titulo: 'Caja',
			// 				monto: 96501,
			// 				porcentaje: 4,
			// 			},
			// 			{
			// 				titulo: 'Cuentas X Cobrar',
			// 				monto: 97646,
			// 				porcentaje: 4,
			// 			},
			// 			{
			// 				titulo: 'Activos Circulantes',
			// 				monto: 314032,
			// 				porcentaje: 14,
			// 			},
			// 			{
			// 				titulo: 'Activo Fijo',
			// 				monto: 1401922,
			// 				porcentaje: 61,
			// 			},
			// 			{
			// 				titulo: 'Otros Activos',
			// 				monto: 564825,
			// 				porcentaje: 25,
			// 			},
			// 			{
			// 				titulo: 'Total Activo',
			// 				monto: 2280779,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'Bancos CP y PCLP',
			// 				monto:  253803,
			// 				porcentaje: 11,
			// 			},
			// 			{
			// 				titulo: 'Proveedores',
			// 				monto:  262992,
			// 				porcentaje: 12,
			// 			},
			// 			{
			// 				titulo: 'Total P. Circulante',
			// 				monto:  516795,
			// 				porcentaje: 23,
			// 			},
			// 			{
			// 				titulo: 'Deuda a LP',
			// 				monto:  931895,
			// 				porcentaje: 41,
			// 			},
			// 			{
			// 				titulo: 'Total Pasivo',
			// 				monto:  1752070,
			// 				porcentaje: 77,
			// 			},
			// 			{
			// 				titulo: 'Capital Contable',
			// 				monto:  528709,
			// 				porcentaje: 23,
			// 			},
					
			// 			{
			// 				titulo: 'Total',
			// 				monto:  2280779,
			// 				porcentaje: 100,
			// 			},
			// 			{
			// 				titulo: 'Deuda Total',
			// 				monto:  1185698,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Deuda Neta',
			// 				monto:  1089197,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Indicador CV',
			// 				monto:  11.11,
			// 				porcentaje: 0,
			// 			},
			// 			{
			// 				titulo: 'Cobertura de CV',
			// 				monto:  10.21,
			// 				porcentaje: 0,
			// 			},
					
			// 		],
			// 		cash_flow: null,
			// 		magnitudes_y_ratios: null
			// 	},
				
			// ],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						1.641872333,
						0.607652938,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.65,
						0.38,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.41,
						0.19,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2012,
						2013,
					],
					datos: [
						13.99172134,
						11.11400853,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2012,
						2013,
					],
					datos: [
						736.2,
						237.86,
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2012,
						2013,
					],
					datos: [
						111.71,
						117.04,
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2012,
						2013,
					],
					datos: [
						0,
						0,
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2012,
						2013,
					],
					datos: [
						847.91,
						354.9,
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2012,
						2013,
					],
					datos: [
						3.673936561,
						3.313864527,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2012,
						2013,
					],
					datos: [
						-0.011950715,
						-0.023927697,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2012,
						2013,
					],
					datos: [
						-3.668347467,
						-2.544784486,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2012,
						2013,
					],
					datos: [
						2.14,
						0.50,
					]
				},
				{
					titulo: 'Utilidad Neta/Ventas',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.077518372,
						0.075815392,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.009311476,
						0.010122419,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.043521249,
						0.043666743,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.786047588,
						0.76818929,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2012,
						2013,
					],
					datos: [
						0.195638523,
						0.29496253,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2012,
						2013,
					],
					datos: [
						-0.078203979,
						-0.137670927,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2012,
						2013,
					],
					datos: [
						-3.668347467,
						-2.544784486,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2012,
						2013,
					],
					datos: [
						183381,
						-202763,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2012,
						2013,
					],
					datos: [
						18596.67,
						25376.33,
					]
				},
				
			]
		},
		{
			id: 16, 
			posiciones_actuales: '',
			parent: 3,
			nombre: 'Sureste Motriz',
			tipo: 'Filial',
			fecha_constitucion: '1960',
			actividad_principal: 'minería, el transporte y la infraestructura.',
			cliente_desde: '1988',
			pais_cabecera: 'México',
			rfc: 'MIN991906-AR4',
			cuenta_clave: 'NO',
			examen: true,
			codigo: 'examen3',
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2013',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2013,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 4329565,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 291615,
							monto: null,
							porcentaje: 7,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 178026,
							monto: null,
							porcentaje: 4,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: -108446,
							monto: null,
							porcentaje: -3,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 133883,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 955563,
							monto: null,
							porcentaje: 23,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 2198586,
							monto: null,
							porcentaje: 54,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 2303499,
							monto: null,
							porcentaje: 56,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 74794,
							monto: null,
							porcentaje: 2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 4095235,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  656905,
							monto: null,
							porcentaje: 16,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  678440,
							monto: null,
							porcentaje: 17,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  1535645,
							monto: null,
							porcentaje: 37,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  1346425,
							monto: null,
							porcentaje: 33,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  2942629,
							monto: null,
							porcentaje: 72,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  1152606,
							monto: null,
							porcentaje: 28,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto:  4095235,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  2003330,
						// 	porcentaje: null,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1869447,
						// 	porcentaje: null,
						// },
						// {
						// 	titulo: 'Deuda Total / EBITDA',
						// 	monto:  6.87,
						// 	porcentaje: null,
						// },
						// {
						// 	titulo: 'Deuda Neta / EBITDA',
						// 	monto:  6.41,
						// 	porcentaje: null,
						// },
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2014',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2014,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 4329565,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 291615,
							monto: null,
							porcentaje: 7,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 178026,
							monto: null,
							porcentaje: 4,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: -108446,
							monto: null,
							porcentaje: -3,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 133883,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 955563,
							monto: null,
							porcentaje: 23,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 2198586,
							monto: null,
							porcentaje: 54,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: 2303499,
							monto: null,
							porcentaje: 56,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: 74794,
							monto: null,
							porcentaje: 2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: 4095235,
							monto: null,
							porcentaje: 100,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto:  656905,
							monto: null,
							porcentaje: 16,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto:  678440,
							monto: null,
							porcentaje: 17,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto:  1535645,
							monto: null,
							porcentaje: 37,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto:  1346425,
							monto: null,
							porcentaje: 33,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto:  2942629,
							monto: null,
							porcentaje: 72,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto:  1152606,
							monto: null,
							porcentaje: 28,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto:  4095235,
							monto: null,
							porcentaje: 100,
							base: 16,
						},
						// {
						// 	titulo: 'Deuda Total',
						// 	monto:  2003330,
						// 	porcentaje: null,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1869447,
						// 	porcentaje: null,
						// },
						// {
						// 	titulo: 'Deuda Total / EBITDA',
						// 	monto:  6.87,
						// 	porcentaje: null,
						// },
						// {
						// 	titulo: 'Deuda Neta / EBITDA',
						// 	monto:  6.41,
						// 	porcentaje: null,
						// },
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				// {
				// 	fecha: '31/12/2014',
				// 	datos_en: 'Miles',
				// 	estado: 'CONSOLIDATED',
				// 	ano: 2014,
				// 	divisa: 'PESOS MEXICANOS',
				// 	balance: null,
				// 	cuenta_resultados: [
				// 		{
				// 			titulo: 'VENTAS',
				// 			monto: 5817165,
				// 			porcentaje: 100,
				// 		},
				// 		{
				// 			titulo: 'EBITDA',
				// 			monto: 471020,
				// 			porcentaje: 8,
				// 		},
				// 		{
				// 			titulo: 'Gastos financieros',
				// 			monto: 163873,
				// 			porcentaje: 3,
				// 		},
				// 		{
				// 			titulo: 'Beneficio Neto',
				// 			monto: -36303,
				// 			porcentaje: -1,
				// 		},
				// 		{
				// 			titulo: 'Caja',
				// 			monto: 222880,
				// 			porcentaje: 4,
				// 		},
				// 		{
				// 			titulo: 'Cuentas X Cobrar',
				// 			monto: 1221931,
				// 			porcentaje: 22,
				// 		},
				// 		{
				// 			titulo: 'Activos Circulantes',
				// 			monto: 2973405,
				// 			porcentaje: 53,
				// 		},
				// 		{
				// 			titulo: 'Activo Fijo',
				// 			monto: 3168287,
				// 			porcentaje: 56,
				// 		},
				// 		{
				// 			titulo: 'Otros Activos',
				// 			monto: 127169,
				// 			porcentaje: 2,
				// 		},
				// 		{
				// 			titulo: 'Total Activo',
				// 			monto: 5660726,
				// 			porcentaje: 100,
				// 		},
				// 		{
				// 			titulo: 'Bancos CP y PCLP',
				// 			monto:  658261,
				// 			porcentaje: 12,
				// 		},
				// 		{
				// 			titulo: 'Proveedores',
				// 			monto:  1394691,
				// 			porcentaje: 25,
				// 		},
				// 		{
				// 			titulo: 'Total P. Circulante',
				// 			monto:  2365460,
				// 			porcentaje: 42,
				// 		},
				// 		{
				// 			titulo: 'Deuda a LP',
				// 			monto:  939652,
				// 			porcentaje: 17,
				// 		},
				// 		{
				// 			titulo: 'Total Pasivo',
				// 			monto:  3410783,
				// 			porcentaje: 60,
				// 		},
				// 		{
				// 			titulo: 'Capital Contable',
				// 			monto:  2249943,
				// 			porcentaje: 40,
				// 		},
				// 		{
				// 			titulo: 'Total',
				// 			monto:  5660726,
				// 			porcentaje: 100,
				// 		},
				// 		{
				// 			titulo: 'Deuda Total',
				// 			monto:  1597913,
				// 			porcentaje: null,
				// 		},
				// 		{
				// 			titulo: 'Deuda Neta',
				// 			monto:  1375033,
				// 			porcentaje: null,
				// 		},
				// 		{
				// 			titulo: 'Deuda Total / EBITDA',
				// 			monto:  3.39,
				// 			porcentaje: null,
				// 		},
				// 		{
				// 			titulo: 'Deuda Neta / EBITDA',
				// 			monto:  2.92,
				// 			porcentaje: null,
				// 		},
				// 	],
				// 	cash_flow: null,
				// 	magnitudes_y_ratios: null
				// },
			],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2013,
						2014,
					],
					datos: [
						1.431701988,
						1.257009208,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.52,
						0.69,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.09,
						0.09,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2013,
						2014,
					],
					datos: [
						6.869776932,
						3.39245255,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2013,
						2014,
					],
					datos: [
						123.38,
						104.06
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2013,
						2014,
					],
					datos: [
						66.1,
						76.52
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2013,
						2014,
					],
					datos: [
						108.59,
						76.81
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2013,
						2014,
					],
					datos: [
						80.89,
						103.77
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2013,
						2014,
					],
					datos: [
						2.553022455,
						1.515941959,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.060498962,
						0.048045566,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2013,
						2014,
					],
					datos: [
						1.638047252,
						2.874299,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.35,
						0.57,
					]
				},
				{
					titulo: 'Utilidad Neta/Ventas',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2013,
						2014,
					],
					datos: [
						-0.025047782,
						-0.006240669,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2013,
						2014,
					],
					datos: [
						-0.02648102,
						-0.006413135,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2013,
						2014,
					],
					datos: [
						-0.094087659,
						-0.016135075,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.718549485,
						0.602534551,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.521861573,
						0.693524038,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2013,
						2014,
					],
					datos: [
						0.041118681,
						0.028170595,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2013,
						2014,
					],
					datos: [
						1.638047252,
						2.874299,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2013,
						2014,
					],
					datos: [
						662941,
						607945,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2013,
						2014,
					],
					datos: [
						360797.08,
						484763.75,
					]
				},
				
			]
		},
		{
			id: 17, 
			posiciones_actuales: '',
			parent: 1,
			nombre: 'Transportes Ayan SA de CV',
			tipo: 'Filial',
			fecha_constitucion: '1994',
			actividad_principal: 'Compraventa de aparatos eléctricos',
			cliente_desde: '2003',
			pais_cabecera: 'México',
			rfc: 'CAN940705AM7',
			cuenta_clave: 'NO',
			examen: false,
			codigo: null,
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2019',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2019,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
					
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2020',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2020,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
					
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
			],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						1.019606277,
						1.186719329,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.52,
						0.69,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.01,
						0.02,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2019,
						2020,
					],
					datos: [
						0,
						0,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2019,
						2020,
					],
					datos: [
						123.38,
						104.06
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2019,
						2020,
					],
					datos: [
						66.1,
						76.52
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2019,
						2020,
					],
					datos: [
						108.59,
						76.81
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2019,
						2020,
					],
					datos: [
						80.89,
						103.77
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2019,
						2020,
					],
					datos: [
						3,
						2,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.048084621,
						0.038347878,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2019,
						2020,
					],
					datos: [
						3.587790111,
						5.066827213,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2019,
						2020,
					],
					datos: [
						3.59,
						5.07,
					]
				},
				{
					titulo: 'Margen Neto',
					formula: 'Utilidad Neta/Ventas',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.026721178,
						0.101555352,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.068342269,
						0.158886272,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.174146884,
						0.298451798,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2019,
						2020,
					],
					datos: [
						1,
						1,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.607559621,
						0.467631713,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.01880063,
						0.024510817,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2019,
						2020,
					],
					datos: [
						3.587790111,
						5.066827213,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2019,
						2020,
					],
					datos: [
						491,
					   	3782,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2019,
						2020,
					],
					datos: [
						8785.17,
						5647.17,
					]
				},
				
			]
		},
		{
			id: 18, 
			posiciones_actuales: '',
			parent: 1,
			nombre: 'Metapel SA de CV',
			tipo: 'Filial',
			fecha_constitucion: '1994',
			actividad_principal: 'Compraventa de aparatos eléctricos',
			cliente_desde: '2003',
			pais_cabecera: 'México',
			rfc: 'CAN940705AM7',
			cuenta_clave: 'NO',
			examen: false,
			codigo: null,
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2019',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2019,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
					
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2020',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2020,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
					
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
			],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						1.05333714,
						1.759988433,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						1.7,
						1.41,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.02,
						0.01,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2019,
						2020,
					],
					datos: [
						0,
						107.9836901,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2019,
						2020,
					],
					datos: [
						93.38,
						77.44
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2019,
						2020,
					],
					datos: [
						69.75,
						61.74
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2019,
						2020,
					],
					datos: [
						113.75,
						58.84
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2019,
						2020,
					],
					datos: [
						49.38,
						80.34
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2019,
						2020,
					],
					datos: [
						6.332487494,
						8.391630617,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.022668987,
						0.001332604,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2019,
						2020,
					],
					datos: [
						1.280639731,
						2.581578947,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2019,
						2020,
					],
					datos: [
						1.28,
						2.58,
					]
				},
				{
					titulo: 'Margen Neto',
					formula: 'Utilidad Neta/Ventas',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.027195896,
						0.003081173,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.039899707,
						0.002714304,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.252664395,
						0.022777434,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2019,
						2020,
					],
					datos: [
						1,
						1,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.842084173,
						0.509345762,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.015451327,
						0.001512721,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2019,
						2020,
					],
					datos: [
						1.280639731,
						2.581578947,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2019,
						2020,
					],
					datos: [
						11769,
					   	110383,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2019,
						2020,
					],
					datos: [
						32036.08,
						20933.58,
					]
				},
				
			]
		},
		{
			id: 19, 
			posiciones_actuales: '',
			parent: 1,
			nombre: 'El Juan Drio SA de SV',
			tipo: 'Filial',
			fecha_constitucion: '1994',
			actividad_principal: 'Compraventa de aparatos eléctricos',
			cliente_desde: '2003',
			pais_cabecera: 'México',
			rfc: 'CAN940705AM7',
			cuenta_clave: 'NO',
			examen: false,
			codigo: null,
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2019',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2019,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
					
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2020',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2020,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
					
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
			],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.113558302,
						0.107128441,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						1.06,
						1.13,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.02,
						0.02,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.690712169,
						1.117355372,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2019,
						2020,
					],
					datos: [
						92.39,
						89.35,
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2019,
						2020,
					],
					datos: [
						49.34,
						67.23,
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2019,
						2020,
					],
					datos: [
						87.13,
						105.75
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2019,
						2020,
					],
					datos: [
						54.6,
						50.83
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2019,
						2020,
					],
					datos: [
						5.189165675,
						6.171805975,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.03406253,
						0.034860318,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2019,
						2020,
					],
					datos: [
						2.535492228,
						1.229924781,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2019,
						2020,
					],
					datos: [
						2.54,
						1.23,
					]
				},
				{
					titulo: 'Margen Neto',
					formula: 'Utilidad Neta/Ventas',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.269086662,
						0.084865044,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.048799428,
						0.007264043,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.253228318,
						0.044832262,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2019,
						2020,
					],
					datos: [
						1,
						1,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.747637243,
						0.790065624,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.18782541,
						0.407269415,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2019,
						2020,
					],
					datos: [
						2.535492228,
						1.229924781,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2019,
						2020,
					],
					datos: [
						-75102,
					   	-99540,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2019,
						2020,
					],
					datos: [
						1712.58,
						1006.50,
					]
				},
				
			]
		},
		{
			id: 20, 
			posiciones_actuales: '',
			parent: 1,
			nombre: 'Inmobiliaria San Juan N Lugo Sa de Cv',
			tipo: 'Filial',
			fecha_constitucion: '1994',
			actividad_principal: 'Compraventa de aparatos eléctricos',
			cliente_desde: '2003',
			pais_cabecera: 'México',
			rfc: 'CAN940705AM7',
			cuenta_clave: 'NO',
			examen: false,
			codigo: null,
			entidad: 9016,
			cif: 'xxxx',
			informes: [
				{
					fecha: '31/12/2019',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2019,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
					
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
				{
					fecha: '31/12/2020',
					datos_en: 'Miles',
					estado: 'CONSOLIDATED',
					ano: 2020,
					divisa: 'PESOS MEXICANOS',
					formulas: {
						deuda_total: [10,13],
						deuda_neta: 4,
						deuda_total_ebitda: 1,
						deuda_neta_ebitda: 1,
					},
					balance: null,
					cuenta_resultados: [
						{
							titulo: 'VENTAS',
							// monto: 650508,
							monto: null,
							porcentaje: 100,
							base: 0,
						},
						{
							titulo: 'EBITDA',
							// monto: 367818,
							monto: null,
							porcentaje: 57,
							base: 0,
						},
						{
							titulo: 'Gastos financieros',
							// monto: 182576,
							monto: null,
							porcentaje: 28,
							base: 0,
						},
						{
							titulo: 'Beneficio Neto',
							// monto: 142628,
							monto: null,
							porcentaje: 22,
							base: 0,
						},
						{
							titulo: 'Caja',
							// monto: 176049,
							monto: null,
							porcentaje: 3,
							base: 9,
						},
						{
							titulo: 'Cuentas X Cobrar',
							// monto: 2591785,
							monto: null,
							porcentaje: 48,
							base: 9,
						},
						{
							titulo: 'Activos Circulantes',
							// monto: 75622,
							monto: null,
							porcentaje: 1,
							base: 9,
						},
						{
							titulo: 'Activo Fijo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Otros Activos',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Total Activo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 9,
						},
						{
							titulo: 'Bancos CP y PCLP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Proveedores',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total P. Circulante',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Deuda a LP',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total Pasivo',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Capital Contable',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
						{
							titulo: 'Total',
							// monto: -116869,
							monto: null,
							porcentaje: -2,
							base: 16,
						},
					
						// {
						// 	titulo: 'Deuda Total',
							// monto:  1584941,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Deuda Neta',
						// 	monto:  1408892,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Indicador CV',
						// 	monto:  2.8,
						// 	porcentaje: 0,
						// },
						// {
						// 	titulo: 'Cobertura de CV',
						// 	monto:  155,
						// 	porcentaje: 0,
						// },
					
					],
					cash_flow: null,
					magnitudes_y_ratios: null
				},
			],
			buro: [],
			rating: [
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				{
					ano: '',
					score: '',
					escala_maestra: '',
					escala_larga: '',
				},
				
			],
			rating_local: [],
			cash_flow: [],
			magnitudes_y_ratios: [],
			extra: [
				{
					titulo: 'Liquidez',
					formula: 'AC/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						18.34926959,
						25.39285714,
					]
				},
				{
					titulo: 'Prueba Acida',
					formula: '(AC-Inventarios)/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						2.15,
						1.6,
					]
				},
				{
					titulo: 'Liquidez Inmediata',
					formula: 'Efectivo y Equivalente/PC',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.03,
						0.00,
					]
				},
				{
					titulo: 'Pay Back',
					formula: 'Deuda Fin+Fin Sol/UAFIRDA',
					anos: [
						2019,
						2020,
					],
					datos: [
						0,
						0,
					]
				},
				{
					titulo: 'Días de Inventario',
					formula: '360/Rotación de Inventarios',
					anos: [
						2019,
						2020,
					],
					datos: [
						0,
						0,
					]
				},
				{
					titulo: 'Días de Cuentas por Cobrar',
					formula: '360/Rotación de cuentas x cobrar',
					anos: [
						2019,
						2020,
					],
					datos: [
						37.96,
						42.58,
					]
				},
				{
					titulo: 'Días de Cuentas por Pagar',
					formula: '360/Rotación Proveedores',
					anos: [
						2019,
						2020,
					],
					datos: [
						91.03,
						81.44
					]
				},
				{
					titulo: 'Ciclo Financiero',
					formula: 'CF=Dinv+DcXc-DcXP',
					anos: [
						2019,
						2020,
					],
					datos: [
						-53.07,
						-38.86
					]
				},
				{
					titulo: 'Apalancamiento Máximo',
					formula: 'PT+Fin. Sol/ Cap. Cont',
					anos: [
						2019,
						2020,
					],
					datos: [
						1.012370626,
						1.00729116,
					]
				},
				{
					titulo: 'Palanca Financiera',
					formula: 'Deuda Fin. /Pas. Tot.',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.001541632,
						0.000517027,
					]
				},
				{
					titulo: 'Cobertura de Interés',
					formula: 'UAFIRDA/Interés + Interés del Fin. Sol',
					anos: [
						2019,
						2020,
					],
					datos: [
						52.15789474,
						53.83333333,
					]
				},
				{
					titulo: 'Cobertura de Deuda',
					formula: 'UAFIRDA/Gastos Financieros+Porción exigible de deuda a LP.',
					anos: [
						2019,
						2020,
					],
					datos: [
						52.16,
						53.83,
					]
				},
				{
					titulo: 'Margen Neto',
					formula: 'Utilidad Neta/Ventas',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.099037424,
						0.061872567,
					]
				},
				{
					titulo: 'ROA (Retorno sobre activos)',
					formula: 'Utilidad Neta/Activos Totales',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.077471074,
						0.026023714,
					]
				},
				{
					titulo: 'ROE (Rentabilidad sobre patrimonio)',
					formula: 'Utilidad Neta /Capital Contable',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.07842944,
						0.026213457,
					]
				},
				{
					titulo: 'Endeudamiento Total',
					formula: 'Pasivo Total /Activo Total',
					anos: [
						2019,
						2020,
					],
					datos: [
						1,
						1,
					]
				},
				{
					titulo: 'Endeudamiento a corto plazo',
					formula: 'Pasivo Corriente/Pasivo Total',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.012219464,
						0.007238384,
					]
				},
				{
					titulo: 'Carga Financiera',
					formula: 'Gastos Financieros /Ventas',
					anos: [
						2019,
						2020,
					],
					datos: [
						0.001970791,
						0.001229256,
					]
				},
				{
					titulo: 'Cobertura de gastos financieros o veces que se ha ganado el interés',
					formula: 'UAFIR/Gastos Financieros',
					anos: [
						2019,
						2020,
					],
					datos: [
						52.15789474,
						53.83333333,
					]
				},
				{
					titulo: 'Fondo de Maniobra',
					formula: '(Caja+clientes+Inventarios)-(Bancomer CP+Otros Bancos CP+Proveedores)',
					anos: [
						2019,
						2020,
					],
					datos: [
						13064,
					   	10245,
					]
				},
				{
					titulo: 'Venta promedio por mes',
					formula: 'Ventas Netas / 12 meses',
					anos: [
						2019,
						2020,
					],
					datos: [
						4017.00,
						2033.75,
					]
				},
				
			]
		},

	]
}